// modules are defined as an array
// [ module function, map of requires ]
//
// map of requires is short require name -> numeric require
//
// anything defined in a previous bundle is accessed via the
// orig method which is the require for previous bundles

(function (modules, entry, mainEntry, parcelRequireName, globalName) {
  /* eslint-disable no-undef */
  var globalObject =
    typeof globalThis !== 'undefined'
      ? globalThis
      : typeof self !== 'undefined'
      ? self
      : typeof window !== 'undefined'
      ? window
      : typeof global !== 'undefined'
      ? global
      : {};
  /* eslint-enable no-undef */

  // Save the require from previous bundle to this closure if any
  var previousRequire =
    typeof globalObject[parcelRequireName] === 'function' &&
    globalObject[parcelRequireName];

  var cache = previousRequire.cache || {};
  // Do not use `require` to prevent Webpack from trying to bundle this call
  var nodeRequire =
    typeof module !== 'undefined' &&
    typeof module.require === 'function' &&
    module.require.bind(module);

  function newRequire(name, jumped) {
    if (!cache[name]) {
      if (!modules[name]) {
        // if we cannot find the module within our internal map or
        // cache jump to the current global require ie. the last bundle
        // that was added to the page.
        var currentRequire =
          typeof globalObject[parcelRequireName] === 'function' &&
          globalObject[parcelRequireName];
        if (!jumped && currentRequire) {
          return currentRequire(name, true);
        }

        // If there are other bundles on this page the require from the
        // previous one is saved to 'previousRequire'. Repeat this as
        // many times as there are bundles until the module is found or
        // we exhaust the require chain.
        if (previousRequire) {
          return previousRequire(name, true);
        }

        // Try the node require function if it exists.
        if (nodeRequire && typeof name === 'string') {
          return nodeRequire(name);
        }

        var err = new Error("Cannot find module '" + name + "'");
        err.code = 'MODULE_NOT_FOUND';
        throw err;
      }

      localRequire.resolve = resolve;
      localRequire.cache = {};

      var module = (cache[name] = new newRequire.Module(name));

      modules[name][0].call(
        module.exports,
        localRequire,
        module,
        module.exports,
        globalObject
      );
    }

    return cache[name].exports;

    function localRequire(x) {
      var res = localRequire.resolve(x);
      return res === false ? {} : newRequire(res);
    }

    function resolve(x) {
      var id = modules[name][1][x];
      return id != null ? id : x;
    }
  }

  function Module(moduleName) {
    this.id = moduleName;
    this.bundle = newRequire;
    this.exports = {};
  }

  newRequire.isParcelRequire = true;
  newRequire.Module = Module;
  newRequire.modules = modules;
  newRequire.cache = cache;
  newRequire.parent = previousRequire;
  newRequire.register = function (id, exports) {
    modules[id] = [
      function (require, module) {
        module.exports = exports;
      },
      {},
    ];
  };

  Object.defineProperty(newRequire, 'root', {
    get: function () {
      return globalObject[parcelRequireName];
    },
  });

  globalObject[parcelRequireName] = newRequire;

  for (var i = 0; i < entry.length; i++) {
    newRequire(entry[i]);
  }

  if (mainEntry) {
    // Expose entry point to Node, AMD or browser globals
    // Based on https://github.com/ForbesLindesay/umd/blob/master/template.js
    var mainExports = newRequire(mainEntry);

    // CommonJS
    if (typeof exports === 'object' && typeof module !== 'undefined') {
      module.exports = mainExports;

      // RequireJS
    } else if (typeof define === 'function' && define.amd) {
      define(function () {
        return mainExports;
      });

      // <script>
    } else if (globalName) {
      this[globalName] = mainExports;
    }
  }
})({"fM9uU":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "RootStoreContext", function() {
    return RootStoreContext;
});
parcelHelpers.export(exports, "TranslateContext", function() {
    return TranslateContext;
});
parcelHelpers.export(exports, "AuthSupplierContext", function() {
    return AuthSupplierContext;
});
parcelHelpers.export(exports, "EmbedContext", function() {
    return EmbedContext;
});
parcelHelpers.export(exports, "EmbedRoot", function() {
    return EmbedRoot;
});
var _objectSpread = require("@swc/helpers/_/_object_spread");
var _slicedToArray = require("@swc/helpers/_/_sliced_to_array");
var _taggedTemplateLiteral = require("@swc/helpers/_/_tagged_template_literal");
var _jsxRuntime = require("react/jsx-runtime");
var _mobxReactLite = require("mobx-react-lite");
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _styledComponents = require("styled-components");
var _authStore = require("../common/auth/auth.store");
var _commonStyles = require("../common/common.styles");
var _dwtLoadable = require("../common/components/loader/dwt-loadable");
var _appErrorBoundary = require("../common/errors/app-error-boundary");
var _errorCodes = require("../common/errors/error-codes");
var _textDirection = require("../common/styles/general/text-direction");
var _theme = require("../common/styles/general/theme");
var _embedStore = require("../store/embed-store");
var _rootStore = require("../store/root-store");
var _moduleContext = require("./context/module-context");
var _globalTooltipObserver = require("../common/components/tooltip/global-tooltip-observer");
var _globalTooltipObserverDefault = parcelHelpers.interopDefault(_globalTooltipObserver);
var _packageJson = require("../../../package.json");
var _packageJsonDefault = parcelHelpers.interopDefault(_packageJson);
var _handleAnchorLinks = require("./components/handle-anchor-links/handle-anchor-links");
function _templateObject() {
    var data = (0, _taggedTemplateLiteral._)([
        "\n  font-family: ",
        ";\n  color: ",
        ";\n  height: fit-content;\n  /* For the AtAvagDemo page correction AtAvagDemoFontFix style was added */\n  ",
        "\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}
var LazyEmbeddedModuleInfo = /*#__PURE__*/ (0, _react.lazy)(function() {
    return require("35f29200b5608b3f").then(function(m) {
        return m.EmbeddedModuleInfo;
    }).then((0, _dwtLoadable.wrapAsDefault));
});
var EmbeddedComponentRoot = (0, _commonStyles.styled).div(_templateObject(), (0, _theme.normalFont), function(p) {
    return p.theme.color.base[100];
}, function(p) {
    return p.debugMode ? 'border: 8px solid green' : '';
});
var RootStoreContext = /*#__PURE__*/ (0, _react.createContext)((0, _rootStore.rootStore));
var TranslateContext = /*#__PURE__*/ (0, _react.createContext)((0, _rootStore.rootStore).localizationStore.translate);
var AuthSupplierContext = /*#__PURE__*/ (0, _react.createContext)(function() {
    return Promise.resolve({});
});
var EmbedContext = /*#__PURE__*/ (0, _react.createContext)(new (0, _embedStore.EmbedStore)());
var EmbedRoot = (0, _mobxReactLite.observer)(function(props) {
    var moduleContext = (0, _react.useContext)((0, _moduleContext.ModuleContext));
    var _useState = (0, _slicedToArray._)((0, _react.useState)(new (0, _embedStore.EmbedStore)()), 1), embedStore = _useState[0];
    var _useState1 = (0, _slicedToArray._)((0, _react.useState)(new (0, _authStore.AuthStore)(embedStore)), 1), authStore = _useState1[0];
    (0, _globalTooltipObserverDefault.default)(props.options.brand || 'opelold');
    var _rootStore_urlStore_searchParams_devShowModules;
    var _useState2 = (0, _slicedToArray._)((0, _react.useState)((_rootStore_urlStore_searchParams_devShowModules = (0, _rootStore.rootStore).urlStore.searchParams.devShowModules) !== null && _rootStore_urlStore_searchParams_devShowModules !== void 0 ? _rootStore_urlStore_searchParams_devShowModules : false), 2), showDebug = _useState2[0], setShowDebug = _useState2[1];
    (0, _react.useEffect)(function() {
        embedStore.init(props.options, props.moduleName);
    }, [
        props.options
    ]);
    (0, _react.useEffect)(function() {
        if (moduleContext && moduleContext.module) (0, _rootStore.rootStore).localizationStore.loadLabels(moduleContext.module.labelPrefix, moduleContext.module.admin || false, authStore.getAuthInfo);
    }, [
        moduleContext
    ]);
    var cTimeout;
    var showVersionPopup = function() {
        if (!document.getElementById('version-popup')) {
            var popup = document.createElement('div');
            popup.id = 'version-popup';
            popup.style.position = 'fixed';
            popup.style.top = '10px';
            popup.style.right = '10px';
            popup.style.padding = '10px';
            popup.style.backgroundColor = 'white';
            popup.style.border = '1px solid #ccc';
            popup.style.boxShadow = '0 0 10px rgba(0, 0, 0, 0.1)';
            popup.style.zIndex = '1000';
            var versionText = document.createElement('p');
            versionText.textContent = "App verzi\xf3: ".concat((0, _packageJsonDefault.default).version);
            popup.appendChild(versionText);
            document.body.appendChild(popup);
            cTimeout = setTimeout(function() {
                hideVersionPopup();
            }, 5000);
        }
    };
    var hideVersionPopup = function() {
        var popup = document.getElementById('version-popup');
        if (popup) {
            document.body.removeChild(popup);
            clearTimeout(cTimeout);
        }
    };
    (0, _react.useEffect)(function() {
        var handleKeyDown = function(event) {
            if (event.ctrlKey && event.shiftKey && event.key === 'V') showVersionPopup();
        };
        var handleKeyUp = function(event) {
            if (event.ctrlKey && event.shiftKey && event.key === 'V') hideVersionPopup();
        };
        window.addEventListener('keydown', handleKeyDown);
        window.addEventListener('keyup', handleKeyUp);
        return function() {
            window.removeEventListener('keydown', handleKeyDown);
            window.removeEventListener('keyup', handleKeyUp);
        };
    }, []);
    if (!moduleContext || !moduleContext.module) return null;
    var theme = (0, _objectSpread._)({}, moduleContext.basetheme);
    var translate = (0, _rootStore.rootStore).localizationStore.translate;
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _appErrorBoundary.AppErrorBoundary), {
        name: "EmbedRoot",
        errorCode: (0, _errorCodes.ErrorCode).ReactBoundaryEmbedRoot,
        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)(AuthSupplierContext.Provider, {
            value: authStore.getAuthInfo,
            children: /*#__PURE__*/ (0, _jsxRuntime.jsx)(RootStoreContext.Provider, {
                value: (0, _rootStore.rootStore),
                children: /*#__PURE__*/ (0, _jsxRuntime.jsx)(TranslateContext.Provider, {
                    value: translate,
                    children: /*#__PURE__*/ (0, _jsxRuntime.jsx)(EmbedContext.Provider, {
                        value: embedStore,
                        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _styledComponents.ThemeProvider), {
                            theme: theme,
                            children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _textDirection.TextDirectionContext).Provider, {
                                value: props.directionGetter,
                                children: /*#__PURE__*/ (0, _jsxRuntime.jsxs)(EmbeddedComponentRoot, {
                                    className: "dwt-slider-container",
                                    debugMode: showDebug,
                                    children: [
                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _handleAnchorLinks.ScrollToHashWhenReady), {}),
                                        showDebug ? /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _react.Suspense), {
                                            fallback: null,
                                            children: /*#__PURE__*/ (0, _jsxRuntime.jsx)(LazyEmbeddedModuleInfo, {
                                                embedStore: embedStore
                                            })
                                        }) : null,
                                        props.children
                                    ]
                                })
                            })
                        })
                    })
                })
            })
        })
    });
});

},{"@swc/helpers/_/_object_spread":"7ZOov","@swc/helpers/_/_sliced_to_array":"5Sh31","@swc/helpers/_/_tagged_template_literal":"8vvZL","react/jsx-runtime":"lhkWg","mobx-react-lite":"dQyHT","react":"gjea9","styled-components":"4QkKB","../common/auth/auth.store":"b4AzI","../common/common.styles":"9NP4o","../common/components/loader/dwt-loadable":"174YZ","../common/errors/app-error-boundary":"3TLvJ","../common/errors/error-codes":"lKqrq","../common/styles/general/text-direction":"cFeey","../common/styles/general/theme":"h7q57","../store/embed-store":"kFJbF","../store/root-store":"iZyBo","./context/module-context":"6LTxE","../common/components/tooltip/global-tooltip-observer":"iB2jK","../../../package.json":"aSEXp","./components/handle-anchor-links/handle-anchor-links":"8Ipv2","35f29200b5608b3f":"94ZjL","@parcel/transformer-js/src/esmodule-helpers.js":"g0Ia8"}],"5Sh31":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "_", function() {
    return _sliced_to_array;
});
var _arrayWithHolesJs = require("./_array_with_holes.js");
var _iterableToArrayLimitJs = require("./_iterable_to_array_limit.js");
var _nonIterableRestJs = require("./_non_iterable_rest.js");
var _unsupportedIterableToArrayJs = require("./_unsupported_iterable_to_array.js");
function _sliced_to_array(arr, i) {
    return (0, _arrayWithHolesJs._)(arr) || (0, _iterableToArrayLimitJs._)(arr, i) || (0, _unsupportedIterableToArrayJs._)(arr, i) || (0, _nonIterableRestJs._)();
}

},{"./_array_with_holes.js":"kWbq7","./_iterable_to_array_limit.js":"Ggisl","./_non_iterable_rest.js":"hkEdH","./_unsupported_iterable_to_array.js":"cEWsJ","@parcel/transformer-js/src/esmodule-helpers.js":"g0Ia8"}],"kWbq7":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "_", function() {
    return _array_with_holes;
});
function _array_with_holes(arr) {
    if (Array.isArray(arr)) return arr;
}

},{"@parcel/transformer-js/src/esmodule-helpers.js":"g0Ia8"}],"Ggisl":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "_", function() {
    return _iterable_to_array_limit;
});
function _iterable_to_array_limit(arr, i) {
    var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"];
    if (_i == null) return;
    var _arr = [];
    var _n = true;
    var _d = false;
    var _s, _e;
    try {
        for(_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true){
            _arr.push(_s.value);
            if (i && _arr.length === i) break;
        }
    } catch (err) {
        _d = true;
        _e = err;
    } finally{
        try {
            if (!_n && _i["return"] != null) _i["return"]();
        } finally{
            if (_d) throw _e;
        }
    }
    return _arr;
}

},{"@parcel/transformer-js/src/esmodule-helpers.js":"g0Ia8"}],"hkEdH":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "_", function() {
    return _non_iterable_rest;
});
function _non_iterable_rest() {
    throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}

},{"@parcel/transformer-js/src/esmodule-helpers.js":"g0Ia8"}],"dQyHT":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "isUsingStaticRendering", function() {
    return 0, _staticRendering.isUsingStaticRendering;
});
parcelHelpers.export(exports, "enableStaticRendering", function() {
    return 0, _staticRendering.enableStaticRendering;
});
parcelHelpers.export(exports, "observer", function() {
    return 0, _observer.observer;
});
parcelHelpers.export(exports, "Observer", function() {
    return 0, _observerComponent.Observer;
});
parcelHelpers.export(exports, "useLocalObservable", function() {
    return 0, _useLocalObservable.useLocalObservable;
});
parcelHelpers.export(exports, "useLocalStore", function() {
    return 0, _useLocalStore.useLocalStore;
});
parcelHelpers.export(exports, "useAsObservableSource", function() {
    return 0, _useAsObservableSource.useAsObservableSource;
});
parcelHelpers.export(exports, "isObserverBatched", function() {
    return 0, _observerBatching.isObserverBatched;
});
parcelHelpers.export(exports, "observerBatching", function() {
    return 0, _observerBatching.observerBatching;
});
parcelHelpers.export(exports, "clearTimers", function() {
    return clearTimers;
});
parcelHelpers.export(exports, "useObserver", function() {
    return useObserver;
});
parcelHelpers.export(exports, "useStaticRendering", function() {
    return useStaticRendering;
});
var _assertEnvironment = require("./utils/assertEnvironment");
var _reactBatchedUpdates = require("./utils/reactBatchedUpdates");
var _observerBatching = require("./utils/observerBatching");
var _utils = require("./utils/utils");
var _useObserver = require("./useObserver");
var _staticRendering = require("./staticRendering");
var _observerFinalizationRegistry = require("./utils/observerFinalizationRegistry");
var _observer = require("./observer");
var _observerComponent = require("./ObserverComponent");
var _useLocalObservable = require("./useLocalObservable");
var _useLocalStore = require("./useLocalStore");
var _useAsObservableSource = require("./useAsObservableSource");
var _a;
(0, _observerBatching.observerBatching)((0, _reactBatchedUpdates.unstable_batchedUpdates));
var clearTimers = (_a = (0, _observerFinalizationRegistry.observerFinalizationRegistry)["finalizeAllImmediately"]) !== null && _a !== void 0 ? _a : function clearTimers() {};
function useObserver(fn, baseComponentName) {
    if (baseComponentName === void 0) baseComponentName = "observed";
    return (0, _useObserver.useObserver)(fn, baseComponentName);
}
function useStaticRendering(enable) {
    (0, _staticRendering.enableStaticRendering)(enable);
}

},{"./utils/assertEnvironment":"cEiRn","./utils/reactBatchedUpdates":"l3Jqa","./utils/observerBatching":"gtB4t","./utils/utils":"ed2UJ","./useObserver":"lOAJM","./staticRendering":"3QVSR","./utils/observerFinalizationRegistry":"03jVl","./observer":"2Sxkx","./ObserverComponent":"hzRjk","./useLocalObservable":"9opYd","./useLocalStore":"ndDuv","./useAsObservableSource":"fOeUH","@parcel/transformer-js/src/esmodule-helpers.js":"g0Ia8"}],"cEiRn":[function(require,module,exports,__globalThis) {
var _mobx = require("mobx");
var _react = require("react");
if (!(0, _react.useState)) throw new Error("mobx-react-lite requires React with Hooks support");
if (!(0, _mobx.makeObservable)) throw new Error("mobx-react-lite@3 requires mobx at least version 6 to be available");

},{"mobx":"itwSa","react":"gjea9"}],"l3Jqa":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "unstable_batchedUpdates", function() {
    return 0, _reactDom.unstable_batchedUpdates;
});
var _reactDom = require("react-dom");

},{"react-dom":"b9022","@parcel/transformer-js/src/esmodule-helpers.js":"g0Ia8"}],"gtB4t":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "defaultNoopBatch", function() {
    return defaultNoopBatch;
});
parcelHelpers.export(exports, "observerBatching", function() {
    return observerBatching;
});
parcelHelpers.export(exports, "isObserverBatched", function() {
    return isObserverBatched;
});
var _mobx = require("mobx");
function defaultNoopBatch(callback) {
    callback();
}
function observerBatching(reactionScheduler) {
    if (!reactionScheduler) reactionScheduler = defaultNoopBatch;
    (0, _mobx.configure)({
        reactionScheduler: reactionScheduler
    });
}
var isObserverBatched = function isObserverBatched() {
    return true;
};

},{"mobx":"itwSa","@parcel/transformer-js/src/esmodule-helpers.js":"g0Ia8"}],"ed2UJ":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "useDeprecated", function() {
    return useDeprecated;
});
var deprecatedMessages = [];
function useDeprecated(msg) {
    if (!deprecatedMessages.includes(msg)) {
        deprecatedMessages.push(msg);
        console.warn(msg);
    }
}

},{"@parcel/transformer-js/src/esmodule-helpers.js":"g0Ia8"}],"lOAJM":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "useObserver", function() {
    return useObserver;
});
var _mobx = require("mobx");
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _printDebugValue = require("./utils/printDebugValue");
var _observerFinalizationRegistry = require("./utils/observerFinalizationRegistry");
var _staticRendering = require("./staticRendering");
var __read = undefined && undefined.__read || function(o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while((n === void 0 || n-- > 0) && !(r = i.next()).done)ar.push(r.value);
    } catch (error) {
        e = {
            error: error
        };
    } finally{
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        } finally{
            if (e) throw e.error;
        }
    }
    return ar;
};
function observerComponentNameFor(baseComponentName) {
    return "observer".concat(baseComponentName);
}
/**
 * We use class to make it easier to detect in heap snapshots by name
 */ var ObjectToBeRetainedByReact = /** @class */ function() {
    function ObjectToBeRetainedByReact() {}
    return ObjectToBeRetainedByReact;
}();
function objectToBeRetainedByReactFactory() {
    return new ObjectToBeRetainedByReact();
}
function useObserver(fn, baseComponentName) {
    if (baseComponentName === void 0) baseComponentName = "observed";
    if ((0, _staticRendering.isUsingStaticRendering)()) return fn();
    var _a = __read((0, _reactDefault.default).useState(objectToBeRetainedByReactFactory), 1), objectRetainedByReact = _a[0];
    // Force update, see #2982
    var _b = __read((0, _reactDefault.default).useState(), 2), setState = _b[1];
    var forceUpdate = function forceUpdate() {
        return setState([]);
    };
    // StrictMode/ConcurrentMode/Suspense may mean that our component is
    // rendered and abandoned multiple times, so we need to track leaked
    // Reactions.
    var admRef = (0, _reactDefault.default).useRef(null);
    if (!admRef.current) // First render
    admRef.current = {
        reaction: null,
        mounted: false,
        changedBeforeMount: false
    };
    var adm = admRef.current;
    if (!adm.reaction) {
        // First render or component was not committed and reaction was disposed by registry
        adm.reaction = new (0, _mobx.Reaction)(observerComponentNameFor(baseComponentName), function() {
            // Observable has changed, meaning we want to re-render
            // BUT if we're a component that hasn't yet got to the useEffect()
            // stage, we might be a component that _started_ to render, but
            // got dropped, and we don't want to make state changes then.
            // (It triggers warnings in StrictMode, for a start.)
            if (adm.mounted) // We have reached useEffect(), so we're mounted, and can trigger an update
            forceUpdate();
            else // We haven't yet reached useEffect(), so we'll need to trigger a re-render
            // when (and if) useEffect() arrives.
            adm.changedBeforeMount = true;
        });
        (0, _observerFinalizationRegistry.observerFinalizationRegistry).register(objectRetainedByReact, adm, adm);
    }
    (0, _reactDefault.default).useDebugValue(adm.reaction, (0, _printDebugValue.printDebugValue));
    (0, _reactDefault.default).useEffect(function() {
        (0, _observerFinalizationRegistry.observerFinalizationRegistry).unregister(adm);
        adm.mounted = true;
        if (adm.reaction) {
            if (adm.changedBeforeMount) {
                // Got a change before mount, force an update
                adm.changedBeforeMount = false;
                forceUpdate();
            }
        } else {
            // The reaction we set up in our render has been disposed.
            // This can be due to bad timings of renderings, e.g. our
            // component was paused for a _very_ long time, and our
            // reaction got cleaned up
            // Re-create the reaction
            adm.reaction = new (0, _mobx.Reaction)(observerComponentNameFor(baseComponentName), function() {
                // We've definitely already been mounted at this point
                forceUpdate();
            });
            forceUpdate();
        }
        return function() {
            adm.reaction.dispose();
            adm.reaction = null;
            adm.mounted = false;
            adm.changedBeforeMount = false;
        };
    }, []);
    // render the original component, but have the
    // reaction track the observables, so that rendering
    // can be invalidated (see above) once a dependency changes
    var rendering;
    var exception;
    adm.reaction.track(function() {
        try {
            rendering = fn();
        } catch (e) {
            exception = e;
        }
    });
    if (exception) throw exception; // re-throw any exceptions caught during rendering
    return rendering;
}

},{"mobx":"itwSa","react":"gjea9","./utils/printDebugValue":"gfAPm","./utils/observerFinalizationRegistry":"03jVl","./staticRendering":"3QVSR","@parcel/transformer-js/src/esmodule-helpers.js":"g0Ia8"}],"gfAPm":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "printDebugValue", function() {
    return printDebugValue;
});
var _mobx = require("mobx");
function printDebugValue(v) {
    return (0, _mobx.getDependencyTree)(v);
}

},{"mobx":"itwSa","@parcel/transformer-js/src/esmodule-helpers.js":"g0Ia8"}],"03jVl":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "observerFinalizationRegistry", function() {
    return observerFinalizationRegistry;
});
var _universalFinalizationRegistry = require("./UniversalFinalizationRegistry");
var observerFinalizationRegistry = new (0, _universalFinalizationRegistry.UniversalFinalizationRegistry)(function(adm) {
    var _a;
    (_a = adm.reaction) === null || _a === void 0 || _a.dispose();
    adm.reaction = null;
});

},{"./UniversalFinalizationRegistry":"9CCle","@parcel/transformer-js/src/esmodule-helpers.js":"g0Ia8"}],"9CCle":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "REGISTRY_FINALIZE_AFTER", function() {
    return REGISTRY_FINALIZE_AFTER;
});
parcelHelpers.export(exports, "REGISTRY_SWEEP_INTERVAL", function() {
    return REGISTRY_SWEEP_INTERVAL;
});
parcelHelpers.export(exports, "TimerBasedFinalizationRegistry", function() {
    return TimerBasedFinalizationRegistry;
});
parcelHelpers.export(exports, "UniversalFinalizationRegistry", function() {
    return UniversalFinalizationRegistry;
});
var REGISTRY_FINALIZE_AFTER = 10000;
var REGISTRY_SWEEP_INTERVAL = 10000;
var TimerBasedFinalizationRegistry = /** @class */ function() {
    function TimerBasedFinalizationRegistry(finalize) {
        var _this = this;
        Object.defineProperty(this, "finalize", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: finalize
        });
        Object.defineProperty(this, "registrations", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: new Map()
        });
        Object.defineProperty(this, "sweepTimeout", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        // Bound so it can be used directly as setTimeout callback.
        Object.defineProperty(this, "sweep", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: function value(maxAge) {
                if (maxAge === void 0) maxAge = REGISTRY_FINALIZE_AFTER;
                // cancel timeout so we can force sweep anytime
                clearTimeout(_this.sweepTimeout);
                _this.sweepTimeout = undefined;
                var now = Date.now();
                _this.registrations.forEach(function(registration, token) {
                    if (now - registration.registeredAt >= maxAge) {
                        _this.finalize(registration.value);
                        _this.registrations.delete(token);
                    }
                });
                if (_this.registrations.size > 0) _this.scheduleSweep();
            }
        });
        // Bound so it can be exported directly as clearTimers test utility.
        Object.defineProperty(this, "finalizeAllImmediately", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: function value() {
                _this.sweep(0);
            }
        });
    }
    // Token is actually required with this impl
    Object.defineProperty(TimerBasedFinalizationRegistry.prototype, "register", {
        enumerable: false,
        configurable: true,
        writable: true,
        value: function value(target, _value, token) {
            this.registrations.set(token, {
                value: _value,
                registeredAt: Date.now()
            });
            this.scheduleSweep();
        }
    });
    Object.defineProperty(TimerBasedFinalizationRegistry.prototype, "unregister", {
        enumerable: false,
        configurable: true,
        writable: true,
        value: function value(token) {
            this.registrations.delete(token);
        }
    });
    Object.defineProperty(TimerBasedFinalizationRegistry.prototype, "scheduleSweep", {
        enumerable: false,
        configurable: true,
        writable: true,
        value: function value() {
            if (this.sweepTimeout === undefined) this.sweepTimeout = setTimeout(this.sweep, REGISTRY_SWEEP_INTERVAL);
        }
    });
    return TimerBasedFinalizationRegistry;
}();
var UniversalFinalizationRegistry = typeof FinalizationRegistry !== "undefined" ? FinalizationRegistry : TimerBasedFinalizationRegistry;

},{"@parcel/transformer-js/src/esmodule-helpers.js":"g0Ia8"}],"3QVSR":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "enableStaticRendering", function() {
    return enableStaticRendering;
});
parcelHelpers.export(exports, "isUsingStaticRendering", function() {
    return isUsingStaticRendering;
});
var globalIsUsingStaticRendering = false;
function enableStaticRendering(enable) {
    globalIsUsingStaticRendering = enable;
}
function isUsingStaticRendering() {
    return globalIsUsingStaticRendering;
}

},{"@parcel/transformer-js/src/esmodule-helpers.js":"g0Ia8"}],"2Sxkx":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
// n.b. base case is not used for actual typings or exported in the typing files
parcelHelpers.export(exports, "observer", function() {
    return observer;
});
var _react = require("react");
var _staticRendering = require("./staticRendering");
var _useObserver = require("./useObserver");
var warnObserverOptionsDeprecated = true;
var hasSymbol = typeof Symbol === "function" && Symbol.for;
// Using react-is had some issues (and operates on elements, not on types), see #608 / #609
var ReactForwardRefSymbol = hasSymbol ? Symbol.for("react.forward_ref") : typeof (0, _react.forwardRef) === "function" && (0, _react.forwardRef)(function(props) {
    return null;
})["$$typeof"];
var ReactMemoSymbol = hasSymbol ? Symbol.for("react.memo") : typeof (0, _react.memo) === "function" && (0, _react.memo)(function(props) {
    return null;
})["$$typeof"];
function observer(baseComponent, // TODO remove in next major
options) {
    var _a;
    if (ReactMemoSymbol && baseComponent["$$typeof"] === ReactMemoSymbol) throw new Error("[mobx-react-lite] You are trying to use `observer` on a function component wrapped in either another `observer` or `React.memo`. The observer already applies 'React.memo' for you.");
    // The working of observer is explained step by step in this talk: https://www.youtube.com/watch?v=cPF4iBedoF0&feature=youtu.be&t=1307
    if ((0, _staticRendering.isUsingStaticRendering)()) return baseComponent;
    var useForwardRef = (_a = options === null || options === void 0 ? void 0 : options.forwardRef) !== null && _a !== void 0 ? _a : false;
    var render = baseComponent;
    var baseComponentName = baseComponent.displayName || baseComponent.name;
    // If already wrapped with forwardRef, unwrap,
    // so we can patch render and apply memo
    if (ReactForwardRefSymbol && baseComponent["$$typeof"] === ReactForwardRefSymbol) {
        useForwardRef = true;
        render = baseComponent["render"];
        if (typeof render !== "function") throw new Error("[mobx-react-lite] `render` property of ForwardRef was not a function");
    }
    var observerComponent = function observerComponent(props, ref) {
        return (0, _useObserver.useObserver)(function() {
            return render(props, ref);
        }, baseComponentName);
    };
    // Don't set `displayName` for anonymous components,
    // so the `displayName` can be customized by user, see #3192.
    if (baseComponentName !== "") observerComponent.displayName = baseComponentName;
    // Support legacy context: `contextTypes` must be applied before `memo`
    if (baseComponent.contextTypes) observerComponent.contextTypes = baseComponent.contextTypes;
    if (useForwardRef) // `forwardRef` must be applied prior `memo`
    // `forwardRef(observer(cmp))` throws:
    // "forwardRef requires a render function but received a `memo` component. Instead of forwardRef(memo(...)), use memo(forwardRef(...))"
    observerComponent = (0, _react.forwardRef)(observerComponent);
    // memo; we are not interested in deep updates
    // in props; we assume that if deep objects are changed,
    // this is in observables, which would have been tracked anyway
    observerComponent = (0, _react.memo)(observerComponent);
    copyStaticProperties(baseComponent, observerComponent);
    return observerComponent;
}
// based on https://github.com/mridgway/hoist-non-react-statics/blob/master/src/index.js
var hoistBlackList = {
    $$typeof: true,
    render: true,
    compare: true,
    type: true,
    // Don't redefine `displayName`,
    // it's defined as getter-setter pair on `memo` (see #3192).
    displayName: true
};
function copyStaticProperties(base, target) {
    Object.keys(base).forEach(function(key) {
        if (!hoistBlackList[key]) Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(base, key));
    });
}

},{"react":"gjea9","./staticRendering":"3QVSR","./useObserver":"lOAJM","@parcel/transformer-js/src/esmodule-helpers.js":"g0Ia8"}],"hzRjk":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "Observer", function() {
    return ObserverComponent;
});
var _typeOf = require("@swc/helpers/_/_type_of");
var _useObserver = require("./useObserver");
function ObserverComponent(_a) {
    var children = _a.children, render = _a.render;
    var component = children || render;
    if (typeof component !== "function") return null;
    return (0, _useObserver.useObserver)(component);
}
ObserverComponent.displayName = "Observer";
function ObserverPropsCheck(props, key, componentName, location, propFullName) {
    var extraKey = key === "children" ? "render" : "children";
    var hasProp = typeof props[key] === "function";
    var hasExtraProp = typeof props[extraKey] === "function";
    if (hasProp && hasExtraProp) return new Error("MobX Observer: Do not use children and render in the same time in`" + componentName);
    if (hasProp || hasExtraProp) return null;
    return new Error("Invalid prop `" + propFullName + "` of type `" + (0, _typeOf._)(props[key]) + "` supplied to" + " `" + componentName + "`, expected `function`.");
}

},{"@swc/helpers/_/_type_of":"cYs4R","./useObserver":"lOAJM","@parcel/transformer-js/src/esmodule-helpers.js":"g0Ia8"}],"9opYd":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "useLocalObservable", function() {
    return useLocalObservable;
});
var _mobx = require("mobx");
var _react = require("react");
function useLocalObservable(initializer, annotations) {
    return (0, _react.useState)(function() {
        return (0, _mobx.observable)(initializer(), annotations, {
            autoBind: true
        });
    })[0];
}

},{"mobx":"itwSa","react":"gjea9","@parcel/transformer-js/src/esmodule-helpers.js":"g0Ia8"}],"ndDuv":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "useLocalStore", function() {
    return useLocalStore;
});
var _mobx = require("mobx");
var _react = require("react");
var _utils = require("./utils/utils");
var _useAsObservableSource = require("./useAsObservableSource");
function useLocalStore(initializer, current) {
    var source = current && (0, _useAsObservableSource.useAsObservableSource)(current);
    return (0, _react.useState)(function() {
        return (0, _mobx.observable)(initializer(source), undefined, {
            autoBind: true
        });
    })[0];
}

},{"mobx":"itwSa","react":"gjea9","./utils/utils":"ed2UJ","./useAsObservableSource":"fOeUH","@parcel/transformer-js/src/esmodule-helpers.js":"g0Ia8"}],"fOeUH":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "useAsObservableSource", function() {
    return useAsObservableSource;
});
var _utils = require("./utils/utils");
var _mobx = require("mobx");
var _react = require("react");
var __read = undefined && undefined.__read || function(o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while((n === void 0 || n-- > 0) && !(r = i.next()).done)ar.push(r.value);
    } catch (error) {
        e = {
            error: error
        };
    } finally{
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        } finally{
            if (e) throw e.error;
        }
    }
    return ar;
};
function useAsObservableSource(current) {
    var _a = __read((0, _react.useState)(function() {
        return (0, _mobx.observable)(current, {}, {
            deep: false
        });
    }), 1), res = _a[0];
    (0, _mobx.runInAction)(function() {
        Object.assign(res, current);
    });
    return res;
}

},{"./utils/utils":"ed2UJ","mobx":"itwSa","react":"gjea9","@parcel/transformer-js/src/esmodule-helpers.js":"g0Ia8"}],"b4AzI":[function(require,module,exports,__globalThis) {
// tslint:disable-next-line: no-submodule-imports
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "noAuth", function() {
    return noAuth;
});
parcelHelpers.export(exports, "AuthStore", function() {
    return AuthStore;
});
var _asyncToGenerator = require("@swc/helpers/_/_async_to_generator");
var _classCallCheck = require("@swc/helpers/_/_class_call_check");
var _createClass = require("@swc/helpers/_/_create_class");
var _defineProperty = require("@swc/helpers/_/_define_property");
var _objectSpread = require("@swc/helpers/_/_object_spread");
var _objectSpreadProps = require("@swc/helpers/_/_object_spread_props");
var _tsGenerator = require("@swc/helpers/_/_ts_generator");
var _parseISO = require("date-fns/parseISO");
var _parseISODefault = parcelHelpers.interopDefault(_parseISO);
var _mobx = require("mobx");
var _errorCodes = require("../errors/error-codes");
var _loggingService = require("../logging.service");
var _storageService = require("../storage/storage.service");
var _authService = require("./auth.service");
var _jwtDecode = require("jwt-decode");
var _jwtDecodeDefault = parcelHelpers.interopDefault(_jwtDecode);
var FIVE_MINUTES_MS = 300000;
var AUTH_STORAGE_KEY = 'auth_';
var noAuth = function() {
    return Promise.reject('No Auth is called');
};
var AuthStore = /*#__PURE__*/ function() {
    "use strict";
    function AuthStore(embedStore) {
        var _this = this;
        (0, _classCallCheck._)(this, AuthStore);
        (0, _defineProperty._)(this, "embedStore", void 0);
        (0, _defineProperty._)(this, "jwtToken", void 0);
        (0, _defineProperty._)(this, "tokenExpiresAt", void 0);
        (0, _defineProperty._)(this, "authState", void 0);
        (0, _defineProperty._)(this, "activeApiKey", void 0);
        (0, _defineProperty._)(this, "getAuthInfo", void 0);
        this.embedStore = embedStore;
        this.authState = 'LOGGED_OUT';
        this.getAuthInfo = function() {
            _this.checkLogin();
            return new Promise(function(resolve) {
                return (0, _mobx.when)(function() {
                    return _this.loggedIn;
                }, function() {
                    var _this_embedStore, _this_embedStore_customData, _this_embedStore_customData1;
                    return resolve({
                        apiUrl: _this.embedStore.apiUrl || '',
                        additionalQueryParams: (_this_embedStore = _this.embedStore) === null || _this_embedStore === void 0 ? void 0 : _this_embedStore.additionalQueryParams,
                        headers: new Headers((0, _objectSpreadProps._)((0, _objectSpread._)({}, _this.embedStore.customHeaders), {
                            Authorization: 'Bearer ' + _this.jwtToken
                        })),
                        setting: _this.embedStore.setting,
                        moduleId: _this.embedStore.moduleId,
                        moduleVariantId: _this.embedStore.moduleVariantId,
                        adminMode: _this.embedStore.adminMode,
                        pageType: _this.embedStore.pageType,
                        useVacs: (_this_embedStore_customData = _this.embedStore.customData) === null || _this_embedStore_customData === void 0 ? void 0 : _this_embedStore_customData.useVacs,
                        isCmsAvailable: (_this_embedStore_customData1 = _this.embedStore.customData) === null || _this_embedStore_customData1 === void 0 ? void 0 : _this_embedStore_customData1.isCmsAvailable
                    });
                });
            });
        };
        (0, _mobx.makeObservable)(this, {
            loggedIn: (0, _mobx.computed),
            jwtToken: (0, _mobx.observable),
            tokenExpiresAt: (0, _mobx.observable),
            authState: (0, _mobx.observable),
            activeApiKey: (0, _mobx.observable),
            checkLogin: (0, _mobx.action),
            login: (0, _mobx.action),
            setLoginState: (0, _mobx.action)
        });
        (0, _mobx.autorun)(function() {
            var apiKey = _this.embedStore.apiKey;
            if (apiKey !== _this.activeApiKey || _this.embedStore.customEnvironment) {
                (0, _loggingService.logger).log('ApiKey changed, checking login');
                _this.checkLogin();
            }
        });
    }
    (0, _createClass._)(AuthStore, [
        {
            key: "loggedIn",
            get: function get() {
                return this.authState === 'LOGGED_IN';
            }
        },
        {
            key: "checkLogin",
            value: function checkLogin() {
                var _this_embedStore_decodedJwtToken, _this_embedStore, _this_embedStore_decodedJwtToken1, _this_embedStore1;
                if (this.authState === 'PENDING' || this.embedStore.apiUrl === '') return;
                var apiKey = this.embedStore.apiKey;
                if (apiKey !== this.activeApiKey) {
                    this.setLoginState('LOGGED_OUT', {});
                    this.activeApiKey = apiKey;
                }
                if (!this.jwtToken && apiKey) {
                    var authStored = (0, _storageService.storageService).getItem(this.authStorageKey(apiKey));
                    if (authStored && !this.isTokenNearExpiration(authStored.expiresAt)) {
                        (0, _loggingService.logger).log('Using stored authInfo');
                        this.setLoginState('LOGGED_IN', authStored);
                        var decodedJwtToken = (0, _jwtDecodeDefault.default)(authStored.token);
                        this.embedStore.decodedJwtToken = decodedJwtToken;
                        this.embedStore.permissions = decodedJwtToken.permissions;
                        this.embedStore.setIsCountrySite(decodedJwtToken.isCountrySite || false);
                    }
                }
                if (!this.jwtToken || this.isTokenNearExpiration(this.tokenExpiresAt)) {
                    this.jwtToken ? (0, _loggingService.logger).log('Auth needed') : (0, _loggingService.logger).log('Auth token expired.');
                    this.login();
                }
                if (this.embedStore.adminMode && this.embedStore.customEnvironment !== 'local' && (((_this_embedStore_decodedJwtToken = this.embedStore.decodedJwtToken) === null || _this_embedStore_decodedJwtToken === void 0 ? void 0 : _this_embedStore_decodedJwtToken.shiroSessionId) !== ((_this_embedStore = this.embedStore) === null || _this_embedStore === void 0 ? void 0 : _this_embedStore.shiroSessionId) || ((_this_embedStore_decodedJwtToken1 = this.embedStore.decodedJwtToken) === null || _this_embedStore_decodedJwtToken1 === void 0 ? void 0 : _this_embedStore_decodedJwtToken1.amAuthUserSessionId) !== ((_this_embedStore1 = this.embedStore) === null || _this_embedStore1 === void 0 ? void 0 : _this_embedStore1.amAuthUserSessionId))) {
                    (0, _loggingService.logger).log('Case of adminMode, login is needed');
                    this.login();
                }
            }
        },
        {
            key: "login",
            value: function login() {
                var _this = this;
                return (0, _asyncToGenerator._)(function() {
                    var apiKey, authInfo, decodedJwtToken, error;
                    return (0, _tsGenerator._)(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                _this.authState = 'PENDING';
                                apiKey = _this.embedStore.apiKey;
                                _state.label = 1;
                            case 1:
                                _state.trys.push([
                                    1,
                                    3,
                                    ,
                                    4
                                ]);
                                return [
                                    4,
                                    (0, _authService.authSvc).acquireJWTToken(apiKey, _this.embedStore.loginUrl, _this.embedStore.shiroSessionId, _this.embedStore.amAuthUserSessionId)
                                ];
                            case 2:
                                authInfo = _state.sent();
                                if (authInfo.message) (0, _loggingService.logger).log('Token expired!');
                                else {
                                    (0, _storageService.storageService).clear();
                                    (0, _storageService.storageService).setItem(_this.authStorageKey(apiKey), authInfo);
                                    _this.setLoginState('LOGGED_IN', authInfo);
                                    decodedJwtToken = (0, _jwtDecodeDefault.default)(authInfo.token);
                                    _this.embedStore.decodedJwtToken = decodedJwtToken;
                                    _this.embedStore.permissions = decodedJwtToken.permissions;
                                    _this.embedStore.setIsCountrySite(decodedJwtToken.isCountrySite || false);
                                    (0, _loggingService.logger).log('Auth success');
                                }
                                return [
                                    3,
                                    4
                                ];
                            case 3:
                                error = _state.sent();
                                _this.setLoginState('LOGIN_FAILED', {});
                                (0, _loggingService.logger).error((0, _errorCodes.ErrorCode).AuthFailed, 'Auth failed', apiKey, error);
                                return [
                                    3,
                                    4
                                ];
                            case 4:
                                return [
                                    2
                                ];
                        }
                    });
                })();
            }
        },
        {
            key: "setLoginState",
            value: function setLoginState(authState, authInfo) {
                this.authState = authState;
                this.jwtToken = authInfo.token;
                this.tokenExpiresAt = authInfo.expiresAt;
            }
        },
        {
            key: "isTokenNearExpiration",
            value: function isTokenNearExpiration(expiration) {
                if (!expiration) return true;
                var expireTimeStamp = (0, _parseISODefault.default)(expiration).getTime();
                if (Number.isNaN(expireTimeStamp)) return true;
                return expireTimeStamp < Date.now() + FIVE_MINUTES_MS;
            }
        },
        {
            key: "authStorageKey",
            value: function authStorageKey(apiKey) {
                return AUTH_STORAGE_KEY + apiKey + ':' + this.embedStore.customEnvironment + (this.embedStore.adminMode ? ':admin' : '');
            }
        }
    ]);
    return AuthStore;
}();

},{"@swc/helpers/_/_async_to_generator":"23AWs","@swc/helpers/_/_class_call_check":"4fJVn","@swc/helpers/_/_create_class":"LhYkq","@swc/helpers/_/_define_property":"dmvty","@swc/helpers/_/_object_spread":"7ZOov","@swc/helpers/_/_object_spread_props":"8MPJG","@swc/helpers/_/_ts_generator":"dGETY","date-fns/parseISO":"j1l2w","mobx":"itwSa","../errors/error-codes":"lKqrq","../logging.service":"6ktkq","../storage/storage.service":"gbvEV","./auth.service":"NrLDG","jwt-decode":"a7MBL","@parcel/transformer-js/src/esmodule-helpers.js":"g0Ia8"}],"8MPJG":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "_", function() {
    return _object_spread_props;
});
function ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) symbols = symbols.filter(function(sym) {
            return Object.getOwnPropertyDescriptor(object, sym).enumerable;
        });
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function _object_spread_props(target, source) {
    source = source != null ? source : {};
    if (Object.getOwnPropertyDescriptors) Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    else ownKeys(Object(source)).forEach(function(key) {
        Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
    });
    return target;
}

},{"@parcel/transformer-js/src/esmodule-helpers.js":"g0Ia8"}],"j1l2w":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", function() {
    return parseISO;
});
var _indexJs = require("../constants/index.js");
var _indexJs1 = require("../_lib/requiredArgs/index.js");
var _indexJsDefault = parcelHelpers.interopDefault(_indexJs1);
var _indexJs2 = require("../_lib/toInteger/index.js");
var _indexJsDefault1 = parcelHelpers.interopDefault(_indexJs2);
function parseISO(argument, options) {
    var _options$additionalDi;
    (0, _indexJsDefault.default)(1, arguments);
    var additionalDigits = (0, _indexJsDefault1.default)((_options$additionalDi = options === null || options === void 0 ? void 0 : options.additionalDigits) !== null && _options$additionalDi !== void 0 ? _options$additionalDi : 2);
    if (additionalDigits !== 2 && additionalDigits !== 1 && additionalDigits !== 0) throw new RangeError('additionalDigits must be 0, 1 or 2');
    if (!(typeof argument === 'string' || Object.prototype.toString.call(argument) === '[object String]')) return new Date(NaN);
    var dateStrings = splitDateString(argument);
    var date;
    if (dateStrings.date) {
        var parseYearResult = parseYear(dateStrings.date, additionalDigits);
        date = parseDate(parseYearResult.restDateString, parseYearResult.year);
    }
    if (!date || isNaN(date.getTime())) return new Date(NaN);
    var timestamp = date.getTime();
    var time = 0;
    var offset;
    if (dateStrings.time) {
        time = parseTime(dateStrings.time);
        if (isNaN(time)) return new Date(NaN);
    }
    if (dateStrings.timezone) {
        offset = parseTimezone(dateStrings.timezone);
        if (isNaN(offset)) return new Date(NaN);
    } else {
        var dirtyDate = new Date(timestamp + time);
        // js parsed string assuming it's in UTC timezone
        // but we need it to be parsed in our timezone
        // so we use utc values to build date in our timezone.
        // Year values from 0 to 99 map to the years 1900 to 1999
        // so set year explicitly with setFullYear.
        var result = new Date(0);
        result.setFullYear(dirtyDate.getUTCFullYear(), dirtyDate.getUTCMonth(), dirtyDate.getUTCDate());
        result.setHours(dirtyDate.getUTCHours(), dirtyDate.getUTCMinutes(), dirtyDate.getUTCSeconds(), dirtyDate.getUTCMilliseconds());
        return result;
    }
    return new Date(timestamp + time + offset);
}
var patterns = {
    dateTimeDelimiter: /[T ]/,
    timeZoneDelimiter: /[Z ]/i,
    timezone: /([Z+-].*)$/
};
var dateRegex = /^-?(?:(\d{3})|(\d{2})(?:-?(\d{2}))?|W(\d{2})(?:-?(\d{1}))?|)$/;
var timeRegex = /^(\d{2}(?:[.,]\d*)?)(?::?(\d{2}(?:[.,]\d*)?))?(?::?(\d{2}(?:[.,]\d*)?))?$/;
var timezoneRegex = /^([+-])(\d{2})(?::?(\d{2}))?$/;
function splitDateString(dateString) {
    var dateStrings = {};
    var array = dateString.split(patterns.dateTimeDelimiter);
    var timeString;
    // The regex match should only return at maximum two array elements.
    // [date], [time], or [date, time].
    if (array.length > 2) return dateStrings;
    if (/:/.test(array[0])) timeString = array[0];
    else {
        dateStrings.date = array[0];
        timeString = array[1];
        if (patterns.timeZoneDelimiter.test(dateStrings.date)) {
            dateStrings.date = dateString.split(patterns.timeZoneDelimiter)[0];
            timeString = dateString.substr(dateStrings.date.length, dateString.length);
        }
    }
    if (timeString) {
        var token = patterns.timezone.exec(timeString);
        if (token) {
            dateStrings.time = timeString.replace(token[1], '');
            dateStrings.timezone = token[1];
        } else dateStrings.time = timeString;
    }
    return dateStrings;
}
function parseYear(dateString, additionalDigits) {
    var regex = new RegExp('^(?:(\\d{4}|[+-]\\d{' + (4 + additionalDigits) + '})|(\\d{2}|[+-]\\d{' + (2 + additionalDigits) + '})$)');
    var captures = dateString.match(regex);
    // Invalid ISO-formatted year
    if (!captures) return {
        year: NaN,
        restDateString: ''
    };
    var year = captures[1] ? parseInt(captures[1]) : null;
    var century = captures[2] ? parseInt(captures[2]) : null;
    // either year or century is null, not both
    return {
        year: century === null ? year : century * 100,
        restDateString: dateString.slice((captures[1] || captures[2]).length)
    };
}
function parseDate(dateString, year) {
    // Invalid ISO-formatted year
    if (year === null) return new Date(NaN);
    var captures = dateString.match(dateRegex);
    // Invalid ISO-formatted string
    if (!captures) return new Date(NaN);
    var isWeekDate = !!captures[4];
    var dayOfYear = parseDateUnit(captures[1]);
    var month = parseDateUnit(captures[2]) - 1;
    var day = parseDateUnit(captures[3]);
    var week = parseDateUnit(captures[4]);
    var dayOfWeek = parseDateUnit(captures[5]) - 1;
    if (isWeekDate) {
        if (!validateWeekDate(year, week, dayOfWeek)) return new Date(NaN);
        return dayOfISOWeekYear(year, week, dayOfWeek);
    } else {
        var date = new Date(0);
        if (!validateDate(year, month, day) || !validateDayOfYearDate(year, dayOfYear)) return new Date(NaN);
        date.setUTCFullYear(year, month, Math.max(dayOfYear, day));
        return date;
    }
}
function parseDateUnit(value) {
    return value ? parseInt(value) : 1;
}
function parseTime(timeString) {
    var captures = timeString.match(timeRegex);
    if (!captures) return NaN; // Invalid ISO-formatted time
    var hours = parseTimeUnit(captures[1]);
    var minutes = parseTimeUnit(captures[2]);
    var seconds = parseTimeUnit(captures[3]);
    if (!validateTime(hours, minutes, seconds)) return NaN;
    return hours * (0, _indexJs.millisecondsInHour) + minutes * (0, _indexJs.millisecondsInMinute) + seconds * 1000;
}
function parseTimeUnit(value) {
    return value && parseFloat(value.replace(',', '.')) || 0;
}
function parseTimezone(timezoneString) {
    if (timezoneString === 'Z') return 0;
    var captures = timezoneString.match(timezoneRegex);
    if (!captures) return 0;
    var sign = captures[1] === '+' ? -1 : 1;
    var hours = parseInt(captures[2]);
    var minutes = captures[3] && parseInt(captures[3]) || 0;
    if (!validateTimezone(hours, minutes)) return NaN;
    return sign * (hours * (0, _indexJs.millisecondsInHour) + minutes * (0, _indexJs.millisecondsInMinute));
}
function dayOfISOWeekYear(isoWeekYear, week, day) {
    var date = new Date(0);
    date.setUTCFullYear(isoWeekYear, 0, 4);
    var fourthOfJanuaryDay = date.getUTCDay() || 7;
    var diff = (week - 1) * 7 + day + 1 - fourthOfJanuaryDay;
    date.setUTCDate(date.getUTCDate() + diff);
    return date;
}
// Validation functions
// February is null to handle the leap year (using ||)
var daysInMonths = [
    31,
    null,
    31,
    30,
    31,
    30,
    31,
    31,
    30,
    31,
    30,
    31
];
function isLeapYearIndex(year) {
    return year % 400 === 0 || year % 4 === 0 && year % 100 !== 0;
}
function validateDate(year, month, date) {
    return month >= 0 && month <= 11 && date >= 1 && date <= (daysInMonths[month] || (isLeapYearIndex(year) ? 29 : 28));
}
function validateDayOfYearDate(year, dayOfYear) {
    return dayOfYear >= 1 && dayOfYear <= (isLeapYearIndex(year) ? 366 : 365);
}
function validateWeekDate(_year, week, day) {
    return week >= 1 && week <= 53 && day >= 0 && day <= 6;
}
function validateTime(hours, minutes, seconds) {
    if (hours === 24) return minutes === 0 && seconds === 0;
    return seconds >= 0 && seconds < 60 && minutes >= 0 && minutes < 60 && hours >= 0 && hours < 25;
}
function validateTimezone(_hours, minutes) {
    return minutes >= 0 && minutes <= 59;
}

},{"../constants/index.js":"4QoKn","../_lib/requiredArgs/index.js":"hTxbw","../_lib/toInteger/index.js":"8sKL3","@parcel/transformer-js/src/esmodule-helpers.js":"g0Ia8"}],"4QoKn":[function(require,module,exports,__globalThis) {
/**
 * Days in 1 week.
 *
 * @name daysInWeek
 * @constant
 * @type {number}
 * @default
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "daysInWeek", function() {
    return daysInWeek;
});
parcelHelpers.export(exports, "daysInYear", function() {
    return daysInYear;
});
parcelHelpers.export(exports, "maxTime", function() {
    return maxTime;
});
parcelHelpers.export(exports, "millisecondsInMinute", function() {
    return millisecondsInMinute;
});
parcelHelpers.export(exports, "millisecondsInHour", function() {
    return millisecondsInHour;
});
parcelHelpers.export(exports, "millisecondsInSecond", function() {
    return millisecondsInSecond;
});
parcelHelpers.export(exports, "minTime", function() {
    return minTime;
});
parcelHelpers.export(exports, "minutesInHour", function() {
    return minutesInHour;
});
parcelHelpers.export(exports, "monthsInQuarter", function() {
    return monthsInQuarter;
});
parcelHelpers.export(exports, "monthsInYear", function() {
    return monthsInYear;
});
parcelHelpers.export(exports, "quartersInYear", function() {
    return quartersInYear;
});
parcelHelpers.export(exports, "secondsInHour", function() {
    return secondsInHour;
});
parcelHelpers.export(exports, "secondsInMinute", function() {
    return secondsInMinute;
});
parcelHelpers.export(exports, "secondsInDay", function() {
    return secondsInDay;
});
parcelHelpers.export(exports, "secondsInWeek", function() {
    return secondsInWeek;
});
parcelHelpers.export(exports, "secondsInYear", function() {
    return secondsInYear;
});
parcelHelpers.export(exports, "secondsInMonth", function() {
    return secondsInMonth;
});
parcelHelpers.export(exports, "secondsInQuarter", function() {
    return secondsInQuarter;
});
var daysInWeek = 7;
var daysInYear = 365.2425;
var maxTime = Math.pow(10, 8) * 86400000;
var millisecondsInMinute = 60000;
var millisecondsInHour = 3600000;
var millisecondsInSecond = 1000;
var minTime = -maxTime;
var minutesInHour = 60;
var monthsInQuarter = 3;
var monthsInYear = 12;
var quartersInYear = 4;
var secondsInHour = 3600;
var secondsInMinute = 60;
var secondsInDay = secondsInHour * 24;
var secondsInWeek = secondsInDay * 7;
var secondsInYear = secondsInDay * daysInYear;
var secondsInMonth = secondsInYear / 12;
var secondsInQuarter = secondsInMonth * 3;

},{"@parcel/transformer-js/src/esmodule-helpers.js":"g0Ia8"}],"hTxbw":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", function() {
    return requiredArgs;
});
function requiredArgs(required, args) {
    if (args.length < required) throw new TypeError(required + ' argument' + (required > 1 ? 's' : '') + ' required, but only ' + args.length + ' present');
}

},{"@parcel/transformer-js/src/esmodule-helpers.js":"g0Ia8"}],"8sKL3":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", function() {
    return toInteger;
});
function toInteger(dirtyNumber) {
    if (dirtyNumber === null || dirtyNumber === true || dirtyNumber === false) return NaN;
    var number = Number(dirtyNumber);
    if (isNaN(number)) return number;
    return number < 0 ? Math.ceil(number) : Math.floor(number);
}

},{"@parcel/transformer-js/src/esmodule-helpers.js":"g0Ia8"}],"NrLDG":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "AuthService", function() {
    return AuthService;
});
parcelHelpers.export(exports, "authSvc", function() {
    return authSvc;
});
var _asyncToGenerator = require("@swc/helpers/_/_async_to_generator");
var _classCallCheck = require("@swc/helpers/_/_class_call_check");
var _createClass = require("@swc/helpers/_/_create_class");
var _tsGenerator = require("@swc/helpers/_/_ts_generator");
var _retryingFetch = require("../retrying-fetch");
var AuthService = /*#__PURE__*/ function() {
    "use strict";
    function AuthService() {
        (0, _classCallCheck._)(this, AuthService);
    }
    (0, _createClass._)(AuthService, [
        {
            key: "acquireJWTToken",
            value: function acquireJWTToken(apiKey, loginUrl, shiroSessionId, amAuthUserSessionId) {
                return (0, _asyncToGenerator._)(function() {
                    var url, response, authInfo;
                    return (0, _tsGenerator._)(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                url = new URL(loginUrl);
                                url.searchParams.append('apiKey', apiKey);
                                if (shiroSessionId) url.searchParams.append('shiroSessionId', shiroSessionId);
                                if (amAuthUserSessionId) url.searchParams.append('amAuthUserSessionId', amAuthUserSessionId);
                                if (!shiroSessionId && !amAuthUserSessionId) url.searchParams.append('origin', window.location.host);
                                return [
                                    4,
                                    (0, _retryingFetch.retryingFetch)(url.toString())
                                ];
                            case 1:
                                response = _state.sent();
                                return [
                                    4,
                                    response.json()
                                ];
                            case 2:
                                authInfo = _state.sent();
                                return [
                                    2,
                                    authInfo
                                ];
                        }
                    });
                })();
            }
        }
    ]);
    return AuthService;
}();
var authSvc = new AuthService();

},{"@swc/helpers/_/_async_to_generator":"23AWs","@swc/helpers/_/_class_call_check":"4fJVn","@swc/helpers/_/_create_class":"LhYkq","@swc/helpers/_/_ts_generator":"dGETY","../retrying-fetch":"iF8gI","@parcel/transformer-js/src/esmodule-helpers.js":"g0Ia8"}],"iF8gI":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "retryingFetch", function() {
    return retryingFetch;
});
var _asyncToGenerator = require("@swc/helpers/_/_async_to_generator");
var _tsGenerator = require("@swc/helpers/_/_ts_generator");
var _rootStore = require("../store/root-store");
var promiseTimeout = function(ms) {
    return new Promise(function(resolve) {
        return setTimeout(resolve, ms);
    });
};
var retryingFetch = /*#__PURE__*/ function() {
    var _ref = (0, _asyncToGenerator._)(function(url, options) {
        var retry, delayMS, attempt, err;
        var _arguments = arguments;
        return (0, _tsGenerator._)(this, function(_state) {
            switch(_state.label){
                case 0:
                    retry = _arguments.length > 2 && _arguments[2] !== void 0 ? _arguments[2] : 5, delayMS = _arguments.length > 3 && _arguments[3] !== void 0 ? _arguments[3] : 200, attempt = _arguments.length > 4 && _arguments[4] !== void 0 ? _arguments[4] : 1;
                    _state.label = 1;
                case 1:
                    _state.trys.push([
                        1,
                        3,
                        ,
                        6
                    ]);
                    return [
                        4,
                        fetch(url, options)
                    ];
                case 2:
                    return [
                        2,
                        _state.sent()
                    ];
                case 3:
                    err = _state.sent();
                    if (retry <= 1) throw err;
                    return [
                        4,
                        (0, _rootStore.rootStore).onlineStatusStore.waitOnline()
                    ];
                case 4:
                    _state.sent();
                    return [
                        4,
                        promiseTimeout(delayMS * attempt)
                    ];
                case 5:
                    _state.sent();
                    return [
                        2,
                        retryingFetch(url, options, retry - 1, delayMS, attempt + 1)
                    ];
                case 6:
                    return [
                        2
                    ];
            }
        });
    });
    return function retryingFetch(url, options) {
        return _ref.apply(this, arguments);
    };
}();

},{"@swc/helpers/_/_async_to_generator":"23AWs","@swc/helpers/_/_ts_generator":"dGETY","../store/root-store":"iZyBo","@parcel/transformer-js/src/esmodule-helpers.js":"g0Ia8"}],"iZyBo":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "rootStore", function() {
    return rootStore;
});
var _classCallCheck = require("@swc/helpers/_/_class_call_check");
var _defineProperty = require("@swc/helpers/_/_define_property");
var _onlineStatusStore = require("../common/general/online-status/online-status.store");
var _localizationStore = require("../common/localization/general/localization.store");
var _urlStore = require("../common/url/url.store");
var RootStore = function RootStore() {
    "use strict";
    (0, _classCallCheck._)(this, RootStore);
    (0, _defineProperty._)(this, "urlStore", new (0, _urlStore.UrlStore)());
    (0, _defineProperty._)(this, "onlineStatusStore", new (0, _onlineStatusStore.OnlineStatusStore)());
    (0, _defineProperty._)(this, "localizationStore", new (0, _localizationStore.LocalizationStore)(this.urlStore));
};
var rootStore = new RootStore();

},{"@swc/helpers/_/_class_call_check":"4fJVn","@swc/helpers/_/_define_property":"dmvty","../common/general/online-status/online-status.store":"c5kPD","../common/localization/general/localization.store":"cmg3A","../common/url/url.store":"9Lkct","@parcel/transformer-js/src/esmodule-helpers.js":"g0Ia8"}],"c5kPD":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "OnlineStatusStore", function() {
    return OnlineStatusStore;
});
var _classCallCheck = require("@swc/helpers/_/_class_call_check");
var _createClass = require("@swc/helpers/_/_create_class");
var _defineProperty = require("@swc/helpers/_/_define_property");
var _mobx = require("mobx");
var OnlineStatusStore = /*#__PURE__*/ function() {
    "use strict";
    function OnlineStatusStore() {
        var _this = this;
        (0, _classCallCheck._)(this, OnlineStatusStore);
        (0, _defineProperty._)(this, "online", true);
        (0, _defineProperty._)(this, "waitOnline", function() {
            return new Promise(function(resolve) {
                return (0, _mobx.when)(function() {
                    return _this.online;
                }, function() {
                    return resolve(undefined);
                });
            });
        });
        (0, _mobx.makeObservable)(this, {
            online: (0, _mobx.observable),
            setOnline: (0, _mobx.action)
        });
        window.addEventListener('online', function() {
            return _this.setOnline(true);
        });
        window.addEventListener('offline', function() {
            return _this.setOnline(false);
        });
    }
    (0, _createClass._)(OnlineStatusStore, [
        {
            key: "setOnline",
            value: function setOnline(status) {
                this.online = status;
            }
        }
    ]);
    return OnlineStatusStore;
}();

},{"@swc/helpers/_/_class_call_check":"4fJVn","@swc/helpers/_/_create_class":"LhYkq","@swc/helpers/_/_define_property":"dmvty","mobx":"itwSa","@parcel/transformer-js/src/esmodule-helpers.js":"g0Ia8"}],"cmg3A":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "LocalizationStore", function() {
    return LocalizationStore;
});
var _asyncToGenerator = require("@swc/helpers/_/_async_to_generator");
var _classCallCheck = require("@swc/helpers/_/_class_call_check");
var _createClass = require("@swc/helpers/_/_create_class");
var _defineProperty = require("@swc/helpers/_/_define_property");
var _objectSpread = require("@swc/helpers/_/_object_spread");
var _tsGenerator = require("@swc/helpers/_/_ts_generator");
var _mobx = require("mobx");
var _loggingService = require("../../logging.service");
var _storageService = require("../../storage/storage.service");
var _stringUtils = require("../../utils/string-utils");
var _localizationService = require("./localization.service");
var LABEL_STORAGE_KEY = 'labels';
var LocalizationStore = /*#__PURE__*/ function() {
    "use strict";
    function LocalizationStore(urlStore) {
        var _this = this;
        (0, _classCallCheck._)(this, LocalizationStore);
        (0, _defineProperty._)(this, "urlStore", void 0);
        (0, _defineProperty._)(this, "labels", void 0);
        (0, _defineProperty._)(this, "loadedLabels", void 0);
        (0, _defineProperty._)(this, "translate", void 0);
        (0, _defineProperty._)(this, "translateResponse", void 0);
        this.urlStore = urlStore;
        this.labels = {};
        this.loadedLabels = new Set();
        this.translate = function(key, parameters, defaultDevStr) {
            var _this_urlStore;
            var debugShowLabels = !!((_this_urlStore = _this.urlStore) === null || _this_urlStore === void 0 ? void 0 : _this_urlStore.searchParams.devShowLabels);
            if (!key) {
                (0, _loggingService.logger).warn('Undefined translate key is used!');
                return '';
            }
            var translatedText = _this.getTranslatedLabel(key, parameters);
            if (debugShowLabels) return "".concat(key, " (").concat(translatedText, ")");
            if (defaultDevStr && translatedText === '') return defaultDevStr;
            return translatedText;
        };
        this.translateResponse = function(key, parameters, defaultDevStr) {
            var _this_urlStore;
            var debugShowLabels = !!((_this_urlStore = _this.urlStore) === null || _this_urlStore === void 0 ? void 0 : _this_urlStore.searchParams.devShowLabels);
            var translatedText = key ? _this.getTranslatedLabel(key, parameters) : '';
            if (debugShowLabels && key) return "".concat(key, " (").concat(translatedText, ")");
            if (defaultDevStr && translatedText === '') return defaultDevStr;
            return translatedText;
        };
        (0, _mobx.makeObservable)(this, {
            labels: (0, _mobx.observable)
        });
        this.restoreLabels();
    }
    (0, _createClass._)(LocalizationStore, [
        {
            key: "loadLabels",
            value: function loadLabels(moduleName, admin, authSupplier) {
                var _this = this;
                return (0, _asyncToGenerator._)(function() {
                    var moduleId, loadedModuleName;
                    return (0, _tsGenerator._)(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                if (moduleName === 'admin') return [
                                    2
                                ];
                                return [
                                    4,
                                    authSupplier()
                                ];
                            case 1:
                                moduleId = _state.sent().moduleId;
                                loadedModuleName = moduleId + '_' + moduleName;
                                if (_this.loadedLabels.has(loadedModuleName)) {
                                    (0, _loggingService.logger).log("Skipping label fetching, because ".concat(moduleName, " labels are loaded for ").concat(moduleId));
                                    return [
                                        2
                                    ];
                                } else _this.loadedLabels.add(loadedModuleName);
                                return [
                                    4,
                                    _this.load(moduleName, admin, authSupplier)
                                ];
                            case 2:
                                _state.sent();
                                return [
                                    2
                                ];
                        }
                    });
                })();
            }
        },
        {
            key: "loadLabelsByModuleName",
            value: function loadLabelsByModuleName(moduleName, admin, authSupplier) {
                var _this = this;
                return (0, _asyncToGenerator._)(function() {
                    var moduleId;
                    return (0, _tsGenerator._)(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                moduleId = 'module_' + moduleName;
                                if (_this.loadedLabels.has(moduleId)) {
                                    (0, _loggingService.logger).log("Skipping label fetching, because ".concat(moduleName, " labels are loaded for ").concat(moduleId));
                                    return [
                                        2
                                    ];
                                } else _this.loadedLabels.add(moduleId);
                                return [
                                    4,
                                    _this.load(moduleName, admin, authSupplier)
                                ];
                            case 1:
                                _state.sent();
                                return [
                                    2
                                ];
                        }
                    });
                })();
            }
        },
        {
            key: "load",
            value: function load(moduleName, admin, authSupplier) {
                var _this = this;
                return (0, _asyncToGenerator._)(function() {
                    var newLabels;
                    return (0, _tsGenerator._)(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                return [
                                    4,
                                    (0, _localizationService.localizationSvc).loadLabels(moduleName, admin, authSupplier)
                                ];
                            case 1:
                                newLabels = _state.sent();
                                (0, _mobx.runInAction)(function() {
                                    _this.addLabels(newLabels);
                                    _this.storeLabels();
                                });
                                return [
                                    2
                                ];
                        }
                    });
                })();
            }
        },
        {
            key: "addLabels",
            value: function addLabels(newLabels) {
                this.labels = (0, _objectSpread._)({}, (0, _mobx.toJS)(this.labels), newLabels);
            }
        },
        {
            key: "getTranslatedLabel",
            value: function getTranslatedLabel(key, parameters) {
                var initialTemplate = this.labels[key];
                if (!initialTemplate) return '';
                if (!parameters) return initialTemplate;
                return (0, _stringUtils.replaceStringParameters)(initialTemplate, parameters);
            }
        },
        {
            key: "storeLabels",
            value: function storeLabels() {
                (0, _storageService.storageService).setItem(LABEL_STORAGE_KEY, (0, _mobx.toJS)(this.labels), 'session');
            }
        },
        {
            key: "restoreLabels",
            value: function restoreLabels() {
                var storedLabels = (0, _storageService.storageService).getItem(LABEL_STORAGE_KEY, 'session');
                this.addLabels(storedLabels !== null && storedLabels !== void 0 ? storedLabels : {});
            }
        }
    ]);
    return LocalizationStore;
}();

},{"@swc/helpers/_/_async_to_generator":"23AWs","@swc/helpers/_/_class_call_check":"4fJVn","@swc/helpers/_/_create_class":"LhYkq","@swc/helpers/_/_define_property":"dmvty","@swc/helpers/_/_object_spread":"7ZOov","@swc/helpers/_/_ts_generator":"dGETY","mobx":"itwSa","../../logging.service":"6ktkq","../../storage/storage.service":"gbvEV","../../utils/string-utils":"7ruzm","./localization.service":"dpHQk","@parcel/transformer-js/src/esmodule-helpers.js":"g0Ia8"}],"7ruzm":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "replaceStringParameters", function() {
    return replaceStringParameters;
});
parcelHelpers.export(exports, "capitalize", function() {
    return capitalize;
});
var replaceStringParameters = function(template, parameters) {
    var paramKeyToTemplateParam = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : function(key) {
        return '${' + key + '}';
    };
    var result = template;
    for(var key in parameters)if (parameters[key]) {
        var templateParam = paramKeyToTemplateParam(key);
        var escapedTemplateParam = templateParam.replace(/[.*+?^${}()|[\]\\]/g, '\\$&');
        var regex = new RegExp(escapedTemplateParam, 'g');
        result = result.replace(regex, parameters[key]);
    }
    return result;
};
var capitalize = function(s) {
    if (!s) return '';
    s = s.toLowerCase();
    return s.charAt(0).toUpperCase() + s.slice(1);
};

},{"@parcel/transformer-js/src/esmodule-helpers.js":"g0Ia8"}],"dpHQk":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "LocalizationService", function() {
    return LocalizationService;
});
parcelHelpers.export(exports, "localizationSvc", function() {
    return localizationSvc;
});
var _asyncToGenerator = require("@swc/helpers/_/_async_to_generator");
var _classCallCheck = require("@swc/helpers/_/_class_call_check");
var _createClass = require("@swc/helpers/_/_create_class");
var _toConsumableArray = require("@swc/helpers/_/_to_consumable_array");
var _tsGenerator = require("@swc/helpers/_/_ts_generator");
var _errorCodes = require("../../errors/error-codes");
var _loggingService = require("../../logging.service");
var _retryingFetch = require("../../retrying-fetch");
var LOCALES_TO_FORMAT = [
    'de_DE'
];
var LocalizationService = /*#__PURE__*/ function() {
    "use strict";
    function LocalizationService() {
        (0, _classCallCheck._)(this, LocalizationService);
    }
    (0, _createClass._)(LocalizationService, [
        {
            key: "loadLabels",
            value: function loadLabels(moduleName, admin, authSupplier) {
                return (0, _asyncToGenerator._)(function() {
                    var _ref, apiUrl, headers, response, content, error, body, error1;
                    return (0, _tsGenerator._)(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                return [
                                    4,
                                    authSupplier()
                                ];
                            case 1:
                                _ref = _state.sent(), apiUrl = _ref.apiUrl, headers = _ref.headers;
                                _state.label = 2;
                            case 2:
                                _state.trys.push([
                                    2,
                                    9,
                                    ,
                                    10
                                ]);
                                return [
                                    4,
                                    (0, _retryingFetch.retryingFetch)(apiUrl + "/".concat(moduleName.toLowerCase(), "/v1/").concat(admin ? 'admin/' : '', "label/list?translate=true"), {
                                        headers: headers
                                    })
                                ];
                            case 3:
                                response = _state.sent();
                                if (!response.ok) {
                                    (0, _loggingService.logger).error((0, _errorCodes.ErrorCode).LabelBadRequest, "Couldn't load labels for ".concat(moduleName, " with server status ").concat(response.status));
                                    return [
                                        2,
                                        {}
                                    ];
                                }
                                _state.label = 4;
                            case 4:
                                _state.trys.push([
                                    4,
                                    6,
                                    ,
                                    8
                                ]);
                                return [
                                    4,
                                    response.clone().json()
                                ];
                            case 5:
                                content = _state.sent();
                                return [
                                    2,
                                    content.labels
                                ];
                            case 6:
                                error = _state.sent();
                                return [
                                    4,
                                    response.text()
                                ];
                            case 7:
                                body = _state.sent();
                                (0, _loggingService.logger).error((0, _errorCodes.ErrorCode).LabelParseError, "Labels of ".concat(moduleName, " JSON Parse failed with response: ").concat(JSON.stringify({
                                    headers: response.headers,
                                    body: body,
                                    status: response.status,
                                    statusText: response.statusText
                                })));
                                return [
                                    2,
                                    {}
                                ];
                            case 8:
                                return [
                                    3,
                                    10
                                ];
                            case 9:
                                error1 = _state.sent();
                                (0, _loggingService.logger).error((0, _errorCodes.ErrorCode).LabelFetchFailed, "Error fetching Labels for ".concat(moduleName), error1);
                                return [
                                    2,
                                    {}
                                ];
                            case 10:
                                return [
                                    2
                                ];
                        }
                    });
                })();
            }
        },
        {
            key: "getPriceFormat",
            value: function getPriceFormat() {
                var locale = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : this.getUserPreferredLocale(), currencyCode = arguments.length > 1 ? arguments[1] : void 0, currencySymbolPosition = arguments.length > 2 ? arguments[2] : void 0, currencyValue = arguments.length > 3 ? arguments[3] : void 0, maximumFractionDigits = arguments.length > 4 && arguments[4] !== void 0 ? arguments[4] : 0, minimumFractionDigits = arguments.length > 5 && arguments[5] !== void 0 ? arguments[5] : 0;
                if (!currencyCode) return this.getNumberFormat(locale);
                var safeLocale = locale && locale.replace('_', '-');
                return {
                    format: function(value) {
                        var _parts_find, _parts_find1;
                        var parts = new Intl.NumberFormat(safeLocale, {
                            style: 'currency',
                            currency: currencyCode,
                            maximumFractionDigits: maximumFractionDigits,
                            minimumFractionDigits: minimumFractionDigits
                        }).formatToParts(value);
                        var literal = (_parts_find = parts.find(function(element) {
                            return element.type === 'literal';
                        })) === null || _parts_find === void 0 ? void 0 : _parts_find.value;
                        var currency = currencyValue !== null && currencyValue !== void 0 ? currencyValue : (_parts_find1 = parts.find(function(element) {
                            return element.type === 'currency';
                        })) === null || _parts_find1 === void 0 ? void 0 : _parts_find1.value;
                        var result;
                        if (currencySymbolPosition) {
                            result = parts.filter(function(element) {
                                return element.type !== 'literal' && element.type !== 'currency';
                            }).map(function(entry) {
                                return entry.value;
                            });
                            result = currencySymbolPosition === 'BEFORE' ? [
                                currency,
                                literal
                            ].concat((0, _toConsumableArray._)(result)) : (0, _toConsumableArray._)(result).concat([
                                literal,
                                currency
                            ]);
                        } else result = parts.map(function(entry) {
                            if (entry.type === 'literal') return literal;
                            else if (entry.type === 'currency') return currency;
                            return entry.value;
                        });
                        return result.join('');
                    }
                };
            }
        },
        {
            key: "getNumberFormat",
            value: function getNumberFormat() {
                var locale = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : this.getUserPreferredLocale();
                var safeLocale = locale && locale.replace('_', '-');
                return new Intl.NumberFormat(safeLocale, {
                    maximumFractionDigits: 0,
                    minimumFractionDigits: 0
                });
            }
        },
        {
            key: "formatNumber",
            value: function formatNumber(value, locale) {
                if (value === undefined || value === null) return value;
                if (locale && LOCALES_TO_FORMAT.includes(locale)) {
                    var safeLocale = locale && locale.replace('_', '-');
                    var numberFormat = new Intl.NumberFormat(safeLocale, {
                        maximumFractionDigits: 2,
                        minimumFractionDigits: 0
                    });
                    return numberFormat.format(value);
                }
                return value;
            }
        },
        {
            key: "parseLocalizedCurrencyString",
            value: function parseLocalizedCurrencyString(value, locale) {
                var safeLocale = locale && locale.replace('_', '-');
                // Get the number format for the specified locale
                var numberFormat = new Intl.NumberFormat(safeLocale);
                // Get the decimal separator for the specified locale
                var decimalSeparator = numberFormat.format(0.1).replace(/\d/g, '');
                // Remove the thousands separator from the number format pattern
                var pattern = numberFormat.format(1000);
                var thousandsSeparator = pattern.replace(/\d/g, '');
                // Remove any non-digit or non-decimal separator characters from the string
                var cleanValue = value.replace(new RegExp("[^\\d".concat(decimalSeparator, "]"), 'g'), '');
                // Replace the thousands separator with an empty string
                var parsedValue = thousandsSeparator ? cleanValue.replace(new RegExp("\\".concat(thousandsSeparator), 'g'), '') : cleanValue;
                // Parse the cleaned value to a number
                var numberValue = parseFloat(parsedValue.replace(decimalSeparator, '.'));
                return isNaN(numberValue) ? 0 : numberValue;
            }
        },
        {
            key: "formatLocalizedPhoneString",
            value: function formatLocalizedPhoneString(value, locale) {
                switch(locale){
                    case 'hu_HU':
                        return this.phoneFormatHU(value);
                }
                return value;
            }
        },
        {
            key: "phoneFormatHU",
            value: function phoneFormatHU(input) {
                var cleaned = ('' + input).replace(/\D/g, ''); // Remove all non-numeric characters
                var match = cleaned.match(/^(\d{2})(\d{1,2})(\d{6,7})$/); // Match groups of 2, 1 or 2, and 6 or 7 digits
                if (match) return "".concat(match[1], " ").concat(match[2], " ").concat(match[3]);
                return input;
            }
        },
        {
            key: "getUnitFormat",
            value: function getUnitFormat() {
                var locale = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : this.getUserPreferredLocale(), unit = arguments.length > 1 ? arguments[1] : void 0, maximumFractionDigits = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : 0, minimumFractionDigits = arguments.length > 3 && arguments[3] !== void 0 ? arguments[3] : 0;
                var safeLocale = locale && locale.replace('_', '-');
                return new Intl.NumberFormat(safeLocale, {
                    style: 'unit',
                    // eslint-disable-next-line @typescript-eslint/ban-ts-comment
                    // @ts-ignore
                    unit: unit,
                    maximumFractionDigits: maximumFractionDigits,
                    minimumFractionDigits: minimumFractionDigits
                });
            }
        },
        {
            key: "getUserPreferredLocale",
            value: function getUserPreferredLocale() {
                return window.navigator.language || 'en';
            }
        }
    ]);
    return LocalizationService;
}();
var localizationSvc = new LocalizationService();

},{"@swc/helpers/_/_async_to_generator":"23AWs","@swc/helpers/_/_class_call_check":"4fJVn","@swc/helpers/_/_create_class":"LhYkq","@swc/helpers/_/_to_consumable_array":"hqEru","@swc/helpers/_/_ts_generator":"dGETY","../../errors/error-codes":"lKqrq","../../logging.service":"6ktkq","../../retrying-fetch":"iF8gI","@parcel/transformer-js/src/esmodule-helpers.js":"g0Ia8"}],"9Lkct":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "UrlStore", function() {
    return UrlStore;
});
var _classCallCheck = require("@swc/helpers/_/_class_call_check");
var _createClass = require("@swc/helpers/_/_create_class");
var _defineProperty = require("@swc/helpers/_/_define_property");
var _mobx = require("mobx");
var _urlService = require("./url.service");
var UrlStore = /*#__PURE__*/ function() {
    "use strict";
    function UrlStore() {
        (0, _classCallCheck._)(this, UrlStore);
        (0, _defineProperty._)(this, "href", window.location.href);
        (0, _defineProperty._)(this, "search", window.location.search);
        (0, _mobx.makeObservable)(this, {
            href: (0, _mobx.observable),
            search: (0, _mobx.observable),
            searchParams: (0, _mobx.computed),
            snapshotAndSet: (0, _mobx.action),
            setParams: (0, _mobx.action),
            setParam: (0, _mobx.action),
            removeParam: (0, _mobx.action)
        });
        this.addEventListeners();
    }
    (0, _createClass._)(UrlStore, [
        {
            key: "searchParams",
            get: function get() {
                return (0, _urlService.urlService).extractParams(this.search);
            }
        },
        {
            key: "snapshotAndSet",
            value: function snapshotAndSet() {
                this.href = window.location.href;
                this.search = window.location.search;
            }
        },
        {
            key: "setParams",
            value: function setParams(newParams) {
                var _this = this;
                var filteredParams = Object.keys(newParams).filter(function(name) {
                    return _this.searchParams[name] !== newParams[name];
                }).reduce(function(partialFilteredParams, name) {
                    partialFilteredParams[name] = newParams[name];
                    return partialFilteredParams;
                }, {});
                if (Object.keys(filteredParams).length) {
                    (0, _urlService.urlService).setParams(filteredParams);
                    this.snapshotAndSet();
                }
            }
        },
        {
            key: "getNextUrl",
            value: function getNextUrl(newParams) {
                return (0, _urlService.urlService).getNextUrl(this.href, newParams);
            }
        },
        {
            key: "getNextUrlWithHref",
            value: function getNextUrlWithHref(href, newParams) {
                return (0, _urlService.urlService).getNextUrl(href, newParams, true);
            }
        },
        {
            key: "setParam",
            value: function setParam(name, value) {
                this.setParams((0, _defineProperty._)({}, name, value));
            }
        },
        {
            key: "removeParam",
            value: function removeParam(name) {
                (0, _urlService.urlService).removeParam(name);
                this.snapshotAndSet();
            }
        },
        {
            key: "addEventListeners",
            value: function addEventListeners() {
                var _this = this;
                window.addEventListener('changestate', function() {
                    return _this.snapshotAndSet();
                });
                window.addEventListener('popstate', function() {
                    return _this.snapshotAndSet();
                });
                window.addEventListener('hashchange', function() {
                    return _this.snapshotAndSet();
                });
            }
        }
    ]);
    return UrlStore;
}();

},{"@swc/helpers/_/_class_call_check":"4fJVn","@swc/helpers/_/_create_class":"LhYkq","@swc/helpers/_/_define_property":"dmvty","mobx":"itwSa","./url.service":"eyqDN","@parcel/transformer-js/src/esmodule-helpers.js":"g0Ia8"}],"eyqDN":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "searchParamDWTPrefix", function() {
    return searchParamDWTPrefix;
});
parcelHelpers.export(exports, "UrlService", function() {
    return UrlService;
});
parcelHelpers.export(exports, "urlService", function() {
    return urlService;
});
var _classCallCheck = require("@swc/helpers/_/_class_call_check");
var _createClass = require("@swc/helpers/_/_create_class");
var _defineProperty = require("@swc/helpers/_/_define_property");
var _slicedToArray = require("@swc/helpers/_/_sliced_to_array");
var _toConsumableArray = require("@swc/helpers/_/_to_consumable_array");
var _urlParams = require("./url-params");
var searchParamDWTPrefix = 'caru-';
var deprecatedPrefixes = [
    'dwt-'
];
var defaultSerializer = function(v) {
    return '' + v;
};
var UrlService = /*#__PURE__*/ function() {
    "use strict";
    function UrlService() {
        (0, _classCallCheck._)(this, UrlService);
        (0, _defineProperty._)(this, "getRawParamName", function(name) {
            return searchParamDWTPrefix + name;
        });
    }
    (0, _createClass._)(UrlService, [
        {
            key: "extractParams",
            value: function extractParams() {
                var _this = this;
                var currentSearch = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : window.location.search;
                var search = new URLSearchParams(currentSearch);
                var params = {};
                (0, _urlParams.dwtUrlParams).forEach(function(param) {
                    var searchItem = _this.getAliasedParamFromSearch(search, param.name, !param.dontTransformParamName);
                    if (searchItem) {
                        var paramValue = param.parser(searchItem);
                        if (paramValue) params[param.name] = paramValue;
                    }
                });
                return params;
            }
        },
        {
            key: "setParams",
            value: function setParams(newParams) {
                var url = this.getNextUrl(window.location.href, newParams);
                if (url.href === window.location.href) return;
                window.history.pushState({}, document.title, url.href);
            }
        },
        {
            key: "getNextUrl",
            value: function getNextUrl(href, newParams, relativeHref) {
                var _this = this;
                var url = relativeHref ? new URL(href, window.location.href) : new URL(href);
                var search = url.searchParams;
                Object.entries(newParams).forEach(function(entry) {
                    var _entry = (0, _slicedToArray._)(entry, 2), name = _entry[0], value = _entry[1];
                    var param = (0, _urlParams.dwtUrlParams).find(function(p) {
                        return p.name === name;
                    });
                    _this.deleteFromSearch(search, name);
                    if (value) {
                        var serializer = (param === null || param === void 0 ? void 0 : param.serializer) || defaultSerializer;
                        var serializedValue = serializer(value);
                        if (serializedValue) {
                            var paramName = (param === null || param === void 0 ? void 0 : param.dontTransformParamName) ? name : _this.getRawParamName(name);
                            search.set(paramName, serializedValue);
                        }
                    }
                });
                return url;
            }
        },
        {
            key: "setParam",
            value: function setParam(name, value) {
                this.setParams((0, _defineProperty._)({}, name, value));
            }
        },
        {
            key: "removeParam",
            value: function removeParam(name) {
                this.setParams((0, _defineProperty._)({}, name, undefined));
            }
        },
        {
            key: "deleteFromSearch",
            value: function deleteFromSearch(search, name) {
                var possiblePrefixes = [
                    '',
                    searchParamDWTPrefix
                ].concat((0, _toConsumableArray._)(deprecatedPrefixes));
                var aliases = (0, _urlParams.dwtUrlParamAliases)[name] || [];
                var possibleNames = [
                    name
                ].concat((0, _toConsumableArray._)(aliases));
                possibleNames.forEach(function(possibleName) {
                    return possiblePrefixes.forEach(function(prefix) {
                        return search.delete(prefix + possibleName);
                    });
                });
            }
        },
        {
            key: "getAliasedParamFromSearch",
            value: function getAliasedParamFromSearch(search, name, usePrefix) {
                var _this = this;
                var param = this.getPrefixedParamFromSearch(search, name, usePrefix);
                if (!param) {
                    var aliases = (0, _urlParams.dwtUrlParamAliases)[name];
                    if (aliases) return aliases.map(function(alias) {
                        return _this.getPrefixedParamFromSearch(search, alias, usePrefix);
                    }).find(function(v) {
                        return !!v;
                    });
                }
                return param;
            }
        },
        {
            key: "getPrefixedParamFromSearch",
            value: function getPrefixedParamFromSearch(search, name, usePrefix) {
                if (!usePrefix) return search.get(name);
                return [
                    searchParamDWTPrefix
                ].concat((0, _toConsumableArray._)(deprecatedPrefixes)).map(function(prefix) {
                    return prefix + name;
                }).map(function(param) {
                    return search.get(param);
                }).find(function(value) {
                    return !!value;
                });
            }
        }
    ]);
    return UrlService;
}();
var urlService = new UrlService();

},{"@swc/helpers/_/_class_call_check":"4fJVn","@swc/helpers/_/_create_class":"LhYkq","@swc/helpers/_/_define_property":"dmvty","@swc/helpers/_/_sliced_to_array":"5Sh31","@swc/helpers/_/_to_consumable_array":"hqEru","./url-params":"dqMwG","@parcel/transformer-js/src/esmodule-helpers.js":"g0Ia8"}],"dqMwG":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "dwtUrlParams", function() {
    return dwtUrlParams;
});
parcelHelpers.export(exports, "dwtUrlParamAliases", function() {
    return dwtUrlParamAliases;
});
var handleUndefinedOrNullString = function(f) {
    return function(s) {
        return [
            'undefined',
            'null'
        ].includes(s) ? undefined : f(s);
    };
};
var stringParser = handleUndefinedOrNullString(function(s) {
    return s;
});
var numberParser = handleUndefinedOrNullString(function(s) {
    return Number.parseFloat(s);
});
var booleanParser = handleUndefinedOrNullString(function(s) {
    return s.toLocaleLowerCase() === 'true';
});
var dwtUrlParams = [
    {
        name: 'smVehicleId',
        parser: numberParser
    },
    {
        name: 'smPage',
        parser: numberParser
    },
    {
        name: 'showroomModelId',
        parser: numberParser
    },
    {
        name: 'showroomModel',
        parser: stringParser
    },
    {
        name: 'showroomModelAdmin',
        parser: stringParser
    },
    {
        name: 'showroomModelAdminAlias',
        parser: stringParser
    },
    {
        name: 'showroomCategoryTabIdx',
        parser: numberParser
    },
    {
        name: 'showroomCategoryTabName',
        parser: stringParser
    },
    {
        name: 'showroomCategoryTab',
        parser: stringParser
    },
    {
        name: 'showroomTabIdx',
        parser: numberParser
    },
    {
        name: 'smFilter',
        parser: stringParser
    },
    {
        name: 'smReservation',
        parser: booleanParser
    },
    {
        name: 'tlpSalesOfferId',
        parser: numberParser
    },
    {
        name: 'tlpStockId',
        parser: numberParser
    },
    {
        name: 'tlpStockPage',
        parser: numberParser
    },
    {
        name: 'tlpCarId',
        parser: numberParser
    },
    {
        name: 'tabIndex',
        parser: numberParser
    },
    {
        name: 'location',
        parser: stringParser,
        dontTransformParamName: true
    },
    {
        name: 'ratingTab',
        parser: stringParser,
        dontTransformParamName: true
    },
    {
        name: 'devShowLabels',
        parser: booleanParser,
        dontTransformParamName: true
    },
    {
        name: 'devShowModules',
        parser: booleanParser,
        dontTransformParamName: true
    },
    {
        name: 'devShowFormValue',
        parser: booleanParser,
        dontTransformParamName: true
    },
    {
        name: 'devShowFormFieldInfo',
        parser: booleanParser,
        dontTransformParamName: true
    },
    {
        name: 'campaignid',
        parser: stringParser,
        dontTransformParamName: true
    },
    {
        name: 'offerid',
        parser: stringParser,
        dontTransformParamName: true
    },
    {
        name: 'level1',
        parser: stringParser,
        dontTransformParamName: true
    },
    {
        name: 'level2',
        parser: stringParser,
        dontTransformParamName: true
    },
    {
        name: 'level3',
        parser: stringParser,
        dontTransformParamName: true
    },
    {
        name: 'ctatype',
        parser: stringParser,
        dontTransformParamName: true
    },
    {
        name: 'businessarea',
        parser: stringParser,
        dontTransformParamName: true
    }
];
var dwtUrlParamAliases = {
    smPage: [
        'vacsPage'
    ],
    smFilter: [
        'vacsFilter'
    ],
    smVehicleId: [
        'vacsVehicleId'
    ]
};

},{"@parcel/transformer-js/src/esmodule-helpers.js":"g0Ia8"}],"a7MBL":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "InvalidTokenError", function() {
    return n;
});
function e(e) {
    this.message = e;
}
e.prototype = new Error, e.prototype.name = "InvalidCharacterError";
var r = "undefined" != typeof window && window.atob && window.atob.bind(window) || function(r) {
    var t = String(r).replace(/=+$/, "");
    if (t.length % 4 == 1) throw new e("'atob' failed: The string to be decoded is not correctly encoded.");
    for(var _$n, _$o, a = 0, i = 0, c = ""; _$o = t.charAt(i++); ~_$o && (_$n = a % 4 ? 64 * _$n + _$o : _$o, a++ % 4) && (c += String.fromCharCode(255 & _$n >> (-2 * a & 6))))_$o = "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/=".indexOf(_$o);
    return c;
};
function t(e) {
    var t = e.replace(/-/g, "+").replace(/_/g, "/");
    switch(t.length % 4){
        case 0:
            break;
        case 2:
            t += "==";
            break;
        case 3:
            t += "=";
            break;
        default:
            throw "Illegal base64url string!";
    }
    try {
        return function(e) {
            return decodeURIComponent(r(e).replace(/(.)/g, function(e, r) {
                var t = r.charCodeAt(0).toString(16).toUpperCase();
                return t.length < 2 && (t = "0" + t), "%" + t;
            }));
        }(t);
    } catch (e) {
        return r(t);
    }
}
function n(e) {
    this.message = e;
}
function o(e, r) {
    if ("string" != typeof e) throw new n("Invalid token specified");
    var _$o = !0 === (r = r || {}).header ? 0 : 1;
    try {
        return JSON.parse(t(e.split(".")[_$o]));
    } catch (e) {
        throw new n("Invalid token specified: " + e.message);
    }
}
n.prototype = new Error, n.prototype.name = "InvalidTokenError";
exports.default = o;

},{"@parcel/transformer-js/src/esmodule-helpers.js":"g0Ia8"}],"3TLvJ":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "AppErrorBoundary", function() {
    return AppErrorBoundary;
});
var _callSuper = require("@swc/helpers/_/_call_super");
var _classCallCheck = require("@swc/helpers/_/_class_call_check");
var _createClass = require("@swc/helpers/_/_create_class");
var _inherits = require("@swc/helpers/_/_inherits");
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _loggingService = require("../logging.service");
var AppErrorBoundary = /*#__PURE__*/ function(_React_Component) {
    "use strict";
    (0, _inherits._)(AppErrorBoundary, _React_Component);
    function AppErrorBoundary(props) {
        (0, _classCallCheck._)(this, AppErrorBoundary);
        var _this;
        _this = (0, _callSuper._)(this, AppErrorBoundary, [
            props
        ]);
        _this.state = {
            hasError: false
        };
        return _this;
    }
    (0, _createClass._)(AppErrorBoundary, [
        {
            key: "componentDidCatch",
            value: function componentDidCatch(error, info) {
                (0, _loggingService.logger).error(this.props.errorCode, "".concat(this.props.name, " Error boundary: ").concat(info.componentStack, " | Message: ").concat(error.message));
            }
        },
        {
            key: "render",
            value: function render() {
                if (this.state.hasError) return null;
                return /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _jsxRuntime.Fragment), {
                    children: this.props.children
                });
            }
        }
    ], [
        {
            key: "getDerivedStateFromError",
            value: function getDerivedStateFromError() {
                return {
                    hasError: true
                };
            }
        }
    ]);
    return AppErrorBoundary;
}((0, _reactDefault.default).Component);

},{"@swc/helpers/_/_call_super":"6D4Bs","@swc/helpers/_/_class_call_check":"4fJVn","@swc/helpers/_/_create_class":"LhYkq","@swc/helpers/_/_inherits":"YAPwf","react/jsx-runtime":"lhkWg","react":"gjea9","../logging.service":"6ktkq","@parcel/transformer-js/src/esmodule-helpers.js":"g0Ia8"}],"6D4Bs":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "_", function() {
    return _call_super;
});
var _getPrototypeOfJs = require("./_get_prototype_of.js");
var _isNativeReflectConstructJs = require("./_is_native_reflect_construct.js");
var _possibleConstructorReturnJs = require("./_possible_constructor_return.js");
function _call_super(_this, derived, args) {
    // Super
    derived = (0, _getPrototypeOfJs._)(derived);
    return (0, _possibleConstructorReturnJs._)(_this, (0, _isNativeReflectConstructJs._)() ? Reflect.construct(derived, args || [], (0, _getPrototypeOfJs._)(_this).constructor) : derived.apply(_this, args));
}

},{"./_get_prototype_of.js":"2SYpg","./_is_native_reflect_construct.js":"57F41","./_possible_constructor_return.js":"NY9Sh","@parcel/transformer-js/src/esmodule-helpers.js":"g0Ia8"}],"2SYpg":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "_", function() {
    return _get_prototype_of;
});
function _get_prototype_of(o) {
    _get_prototype_of = Object.setPrototypeOf ? Object.getPrototypeOf : function getPrototypeOf(o) {
        return o.__proto__ || Object.getPrototypeOf(o);
    };
    return _get_prototype_of(o);
}

},{"@parcel/transformer-js/src/esmodule-helpers.js":"g0Ia8"}],"57F41":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "_", function() {
    return _is_native_reflect_construct;
});
function _is_native_reflect_construct() {
    // Since Reflect.construct can't be properly polyfilled, some
    // implementations (e.g. core-js@2) don't set the correct internal slots.
    // Those polyfills don't allow us to subclass built-ins, so we need to
    // use our fallback implementation.
    try {
        // If the internal slots aren't set, this throws an error similar to
        //   TypeError: this is not a Boolean object.
        var result = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {}));
    } catch (_) {}
    return (_is_native_reflect_construct = function() {
        return !!result;
    })();
}

},{"@parcel/transformer-js/src/esmodule-helpers.js":"g0Ia8"}],"NY9Sh":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "_", function() {
    return _possible_constructor_return;
});
var _assertThisInitializedJs = require("./_assert_this_initialized.js");
var _typeOfJs = require("./_type_of.js");
function _possible_constructor_return(self, call) {
    if (call && ((0, _typeOfJs._)(call) === "object" || typeof call === "function")) return call;
    return (0, _assertThisInitializedJs._)(self);
}

},{"./_assert_this_initialized.js":"2Do2u","./_type_of.js":"cYs4R","@parcel/transformer-js/src/esmodule-helpers.js":"g0Ia8"}],"2Do2u":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "_", function() {
    return _assert_this_initialized;
});
function _assert_this_initialized(self) {
    if (self === void 0) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    return self;
}

},{"@parcel/transformer-js/src/esmodule-helpers.js":"g0Ia8"}],"YAPwf":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "_", function() {
    return _inherits;
});
var _setPrototypeOfJs = require("./_set_prototype_of.js");
function _inherits(subClass, superClass) {
    if (typeof superClass !== "function" && superClass !== null) throw new TypeError("Super expression must either be null or a function");
    subClass.prototype = Object.create(superClass && superClass.prototype, {
        constructor: {
            value: subClass,
            writable: true,
            configurable: true
        }
    });
    if (superClass) (0, _setPrototypeOfJs._)(subClass, superClass);
}

},{"./_set_prototype_of.js":"94i3w","@parcel/transformer-js/src/esmodule-helpers.js":"g0Ia8"}],"94i3w":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "_", function() {
    return _set_prototype_of;
});
function _set_prototype_of(o, p) {
    _set_prototype_of = Object.setPrototypeOf || function setPrototypeOf(o, p) {
        o.__proto__ = p;
        return o;
    };
    return _set_prototype_of(o, p);
}

},{"@parcel/transformer-js/src/esmodule-helpers.js":"g0Ia8"}],"h7q57":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "customColor", function() {
    return customColor;
});
parcelHelpers.export(exports, "baseColor", function() {
    return baseColor;
});
parcelHelpers.export(exports, "primaryColor", function() {
    return primaryColor;
});
parcelHelpers.export(exports, "secondaryColor", function() {
    return secondaryColor;
});
parcelHelpers.export(exports, "accentColor", function() {
    return accentColor;
});
parcelHelpers.export(exports, "mobile", function() {
    return mobile;
});
parcelHelpers.export(exports, "smallMobile", function() {
    return smallMobile;
});
parcelHelpers.export(exports, "mediumMobile", function() {
    return mediumMobile;
});
parcelHelpers.export(exports, "phablet", function() {
    return phablet;
});
parcelHelpers.export(exports, "tablet", function() {
    return tablet;
});
parcelHelpers.export(exports, "smallDesktop", function() {
    return smallDesktop;
});
parcelHelpers.export(exports, "normalFont", function() {
    return normalFont;
});
parcelHelpers.export(exports, "primaryFont", function() {
    return primaryFont;
});
parcelHelpers.export(exports, "secondaryFont", function() {
    return secondaryFont;
});
parcelHelpers.export(exports, "tertiaryFont", function() {
    return tertiaryFont;
});
parcelHelpers.export(exports, "accentFont", function() {
    return accentFont;
});
var customColor = function(c) {
    return c;
};
var baseColor = function(c) {
    return function(p) {
        return p.theme.color.base[c];
    };
};
var primaryColor = function(c) {
    return function(p) {
        return p.theme.color.primary[c];
    };
};
var secondaryColor = function(c) {
    return function(p) {
        return p.theme.color.secondary[c];
    };
};
var accentColor = function(c) {
    return function(p) {
        return p.theme.color.accent[c];
    };
};
var mobile = function(p) {
    return p.theme.breakPoint.mobile;
};
var smallMobile = function(p) {
    return p.theme.breakPoint.smallMobile;
};
var mediumMobile = function(p) {
    return p.theme.breakPoint.mediumMobile;
};
var phablet = function(p) {
    return p.theme.breakPoint.phablet || p.theme.breakPoint.tablet;
};
var tablet = function(p) {
    return p.theme.breakPoint.tablet;
};
var smallDesktop = function(p) {
    return p.theme.breakPoint.smallDesktop;
};
var normalFont = function(p) {
    return p.theme.font.normal;
};
var primaryFont = function(p) {
    return p.theme.font.primary;
};
var secondaryFont = function(p) {
    return p.theme.font.secondary;
};
var tertiaryFont = function(p) {
    return p.theme.font.tertiary;
};
var accentFont = function(p) {
    return p.theme.font.accent;
};

},{"@parcel/transformer-js/src/esmodule-helpers.js":"g0Ia8"}],"kFJbF":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "EmbedStore", function() {
    return EmbedStore;
});
var _classCallCheck = require("@swc/helpers/_/_class_call_check");
var _createClass = require("@swc/helpers/_/_create_class");
var _defineProperty = require("@swc/helpers/_/_define_property");
var _objectWithoutProperties = require("@swc/helpers/_/_object_without_properties");
var _mobx = require("mobx");
var _environmentService = require("../common/environment.service");
var _assetsInjection = require("../embedding/assets-injection");
var _vacsAdminManualVehicleModel = require("../admin/vacs-admin-manual-vehicles/vacs-admin-manual-vehicle.model");
var brands = [
    'opel',
    'opelold',
    'peugeot',
    'ds',
    'citroen',
    'ssangyong',
    'isuzu',
    'fiat',
    'jeep',
    'alfaromeo',
    'abarth',
    'lancia'
];
var brandsMap = {
    OPEL: 'opel',
    OPELOLD: 'opelold',
    PEUGEOT: 'peugeot',
    CITROEN: 'citroen',
    DS: 'ds',
    SSANGYONG: 'ssangyong',
    ISUZU: 'isuzu',
    FIAT: 'fiat',
    JEEP: 'jeep',
    ALFA: 'alfaromeo',
    ABARTH: 'abarth',
    LANCIA: 'lancia'
};
var tinyMCEditorAoiKeys = {
    local: 'T7LK77EF99E1987BDFBEF74E0BB194ED6729818864661B89715C37544D521770',
    dev: 'T7LK77EF99E1987BDFBEF74E0BB194ED6729818864661B89715C37544D521770',
    uat: 'T7LK77EF99E1987BDFBEF74E0BB194ED6729818864661B89715C37544D521770',
    staging: 'T7LK77EF99E1987BDFBEF74E0BB194ED6729818864661B89715C37544D521770',
    prod: 'T7LKF19DA2E14B233C26745CBD12BA440FD69E38541B840DACAD1F5FABD631B1'
};
var EmbedStore = /*#__PURE__*/ function() {
    "use strict";
    function EmbedStore() {
        var _this = this;
        (0, _classCallCheck._)(this, EmbedStore);
        (0, _defineProperty._)(this, "apiKey", void 0);
        (0, _defineProperty._)(this, "additionalQueryParams", void 0);
        (0, _defineProperty._)(this, "setting", void 0);
        (0, _defineProperty._)(this, "customEnvironment", 'dev');
        (0, _defineProperty._)(this, "customHeaders", void 0);
        (0, _defineProperty._)(this, "brand", void 0);
        (0, _defineProperty._)(this, "brandsMap", void 0);
        (0, _defineProperty._)(this, "permissions", void 0);
        (0, _defineProperty._)(this, "isCountrySite", false);
        (0, _defineProperty._)(this, "decodedJwtToken", void 0);
        (0, _defineProperty._)(this, "loginUrl", '');
        (0, _defineProperty._)(this, "moduleName", void 0);
        (0, _defineProperty._)(this, "apiUrl", '');
        (0, _defineProperty._)(this, "adminMode", false);
        (0, _defineProperty._)(this, "pageType", (0, _vacsAdminManualVehicleModel.PageType).BULK);
        (0, _defineProperty._)(this, "useVacs", false);
        (0, _defineProperty._)(this, "isCmsAvailable", false);
        (0, _defineProperty._)(this, "previewMode", false);
        (0, _defineProperty._)(this, "shiroSessionId", void 0);
        (0, _defineProperty._)(this, "amAuthUserSessionId", void 0);
        (0, _defineProperty._)(this, "callbackFnName", void 0);
        (0, _defineProperty._)(this, "tooltipContainerId", '');
        (0, _defineProperty._)(this, "customData", void 0);
        (0, _defineProperty._)(this, "widgetData", void 0);
        (0, _defineProperty._)(this, "moduleSpecificOptions", {});
        (0, _defineProperty._)(this, "createModuleEvent", function(name, data) {
            var _this_customData, _this_customData1;
            var _this_apiKey, _this_setting, _this_moduleName, _this_shiroSessionId, _this_amAuthUserSessionId;
            return {
                name: name,
                data: data,
                apiKey: (_this_apiKey = _this.apiKey) !== null && _this_apiKey !== void 0 ? _this_apiKey : '',
                setting: (_this_setting = _this.setting) !== null && _this_setting !== void 0 ? _this_setting : '',
                module: (_this_moduleName = _this.moduleName) !== null && _this_moduleName !== void 0 ? _this_moduleName : '',
                shiroSessionId: (_this_shiroSessionId = _this.shiroSessionId) !== null && _this_shiroSessionId !== void 0 ? _this_shiroSessionId : '',
                amAuthUserSessionId: (_this_amAuthUserSessionId = _this.amAuthUserSessionId) !== null && _this_amAuthUserSessionId !== void 0 ? _this_amAuthUserSessionId : '',
                brand: _this.brand,
                customData: _this.customData,
                widgetData: _this.widgetData,
                useVacs: ((_this_customData = _this.customData) === null || _this_customData === void 0 ? void 0 : _this_customData.useVacs) || false,
                isCmsAvailable: ((_this_customData1 = _this.customData) === null || _this_customData1 === void 0 ? void 0 : _this_customData1.isCmsAvailable) || false
            };
        });
        (0, _mobx.makeObservable)(this, {
            apiKey: (0, _mobx.observable),
            previewMode: (0, _mobx.observable),
            setting: (0, _mobx.observable),
            customEnvironment: (0, _mobx.observable),
            shiroSessionId: (0, _mobx.observable),
            amAuthUserSessionId: (0, _mobx.observable),
            customHeaders: (0, _mobx.observable),
            tooltipContainerId: (0, _mobx.observable),
            isCountrySite: (0, _mobx.observable),
            brand: (0, _mobx.observable),
            customData: (0, _mobx.observable),
            widgetData: (0, _mobx.observable),
            loginUrl: (0, _mobx.observable),
            moduleName: (0, _mobx.observable),
            apiUrl: (0, _mobx.observable),
            moduleSpecificOptions: (0, _mobx.observable),
            moduleId: (0, _mobx.computed),
            moduleVariantId: (0, _mobx.computed),
            outboundDomEventSource: (0, _mobx.computed),
            init: (0, _mobx.action),
            setIsCountrySite: (0, _mobx.action),
            pageType: (0, _mobx.observable)
        });
    }
    (0, _createClass._)(EmbedStore, [
        {
            key: "setIsCountrySite",
            value: function setIsCountrySite(value) {
                this.isCountrySite = value;
            }
        },
        {
            key: "moduleId",
            get: function get() {
                return "".concat(this.moduleName, "_").concat(this.apiKey);
            }
        },
        {
            key: "moduleVariantId",
            get: function get() {
                return "".concat(this.moduleName, "_").concat(this.apiKey, "_").concat(this.setting);
            }
        },
        {
            key: "outboundDomEventSource",
            get: function get() {
                var _this_apiKey, _this_setting;
                return {
                    module: this.moduleName,
                    moduleApiKey: (_this_apiKey = this.apiKey) !== null && _this_apiKey !== void 0 ? _this_apiKey : '',
                    moduleSettings: (_this_setting = this.setting) !== null && _this_setting !== void 0 ? _this_setting : ''
                };
            }
        },
        {
            key: "tinyMCEditorApiKey",
            get: function get() {
                return tinyMCEditorAoiKeys[this.customEnvironment];
            }
        },
        {
            key: "generateShortId",
            value: function generateShortId() {
                return Math.random().toString(36).substring(2, 8);
            }
        },
        {
            key: "init",
            value: function init(options, moduleName) {
                var _this_customData;
                if (!options) return;
                var apiKey = options.apiKey, setting = options.setting, brand = options.brand, customHeaders = options.customHeaders, adminMode = options.adminMode, pageType = options.pageType, shiroSessionId = options.shiroSessionId, amAuthUserSessionId = options.amAuthUserSessionId, callbackFnName = options.callbackFnName, customData = options.customData, widgetData = options.widgetData, additionalQueryParams = options.additionalQueryParams, previewMode = options.previewMode, customEnvironment = options.customEnvironment, moduleSpecificOptions = (0, _objectWithoutProperties._)(options, [
                    "apiKey",
                    "setting",
                    "brand",
                    "customHeaders",
                    "adminMode",
                    "pageType",
                    "shiroSessionId",
                    "amAuthUserSessionId",
                    "callbackFnName",
                    "customData",
                    "widgetData",
                    "additionalQueryParams",
                    "previewMode",
                    "customEnvironment"
                ]);
                this.moduleName = moduleName;
                this.apiKey = apiKey;
                this.additionalQueryParams = additionalQueryParams;
                this.setting = setting;
                this.moduleSpecificOptions = moduleSpecificOptions;
                this.customHeaders = customHeaders;
                this.brandsMap = brandsMap;
                this.shiroSessionId = shiroSessionId;
                this.amAuthUserSessionId = amAuthUserSessionId;
                this.callbackFnName = callbackFnName;
                this.widgetData = widgetData;
                this.customData = customData && typeof customData === 'string' ? JSON.parse(customData !== null && customData !== void 0 ? customData : {}) : customData;
                this.useVacs = (customData === null || customData === void 0 ? void 0 : customData.useVacs) || false;
                this.previewMode = previewMode || false;
                this.isCmsAvailable = ((_this_customData = this.customData) === null || _this_customData === void 0 ? void 0 : _this_customData.isCmsAvailable) || false;
                this.customEnvironment = customEnvironment;
                this.loginUrl = (0, _environmentService.environmentSvc).getLoginUrl(this.customEnvironment, adminMode);
                this.apiUrl = (0, _environmentService.environmentSvc).getApiUrl(this.customEnvironment);
                this.adminMode = adminMode;
                this.pageType = pageType !== undefined ? pageType : (0, _vacsAdminManualVehicleModel.PageType).BULK;
                this.tooltipContainerId = options.tooltipContainerId ? options.tooltipContainerId : this.generateShortId();
                (0, _assetsInjection.preconnectToApiUrl)(this.apiUrl);
                if (brand && brands.includes(brand)) this.brand = brand;
            }
        }
    ]);
    return EmbedStore;
}();

},{"@swc/helpers/_/_class_call_check":"4fJVn","@swc/helpers/_/_create_class":"LhYkq","@swc/helpers/_/_define_property":"dmvty","@swc/helpers/_/_object_without_properties":"1FjsY","mobx":"itwSa","../common/environment.service":"25FX4","../embedding/assets-injection":"77h03","../admin/vacs-admin-manual-vehicles/vacs-admin-manual-vehicle.model":"lEGEC","@parcel/transformer-js/src/esmodule-helpers.js":"g0Ia8"}],"1FjsY":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "_", function() {
    return _object_without_properties;
});
var _objectWithoutPropertiesLooseJs = require("./_object_without_properties_loose.js");
function _object_without_properties(source, excluded) {
    if (source == null) return {};
    var target = (0, _objectWithoutPropertiesLooseJs._)(source, excluded);
    var key, i;
    if (Object.getOwnPropertySymbols) {
        var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
        for(i = 0; i < sourceSymbolKeys.length; i++){
            key = sourceSymbolKeys[i];
            if (excluded.indexOf(key) >= 0) continue;
            if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
            target[key] = source[key];
        }
    }
    return target;
}

},{"./_object_without_properties_loose.js":"1eBPB","@parcel/transformer-js/src/esmodule-helpers.js":"g0Ia8"}],"1eBPB":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "_", function() {
    return _object_without_properties_loose;
});
function _object_without_properties_loose(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}

},{"@parcel/transformer-js/src/esmodule-helpers.js":"g0Ia8"}],"77h03":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "preconnectToApiUrl", function() {
    return preconnectToApiUrl;
});
function preconnectToApiUrl(apiUrl) {
    var preconnectLinks = Array.from(document.querySelectorAll('link[rel="preconnect"]'));
    var head = document.querySelector('head');
    var notPreconnected = preconnectLinks.every(function(link) {
        return !link.href.includes(apiUrl);
    });
    if (notPreconnected) {
        var link = document.createElement('link');
        link.setAttribute('rel', 'preconnect');
        link.setAttribute('href', apiUrl);
        if (head) head.appendChild(link);
    }
}

},{"@parcel/transformer-js/src/esmodule-helpers.js":"g0Ia8"}],"lEGEC":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "PageType", function() {
    return PageType;
});
var PageType = /*#__PURE__*/ function(PageType) {
    PageType["BULK"] = "BULK";
    PageType["VIN"] = "VIN";
    return PageType;
}({});

},{"@parcel/transformer-js/src/esmodule-helpers.js":"g0Ia8"}],"iB2jK":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "GLOBAL_TOOLTIP_CLASS", function() {
    return GLOBAL_TOOLTIP_CLASS;
});
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _customTooltip = require("./CustomTooltip");
var _client = require("react-dom/client");
var RICH_TEXT_TOOLTIP_CLASS = 'richtext-tooltip';
var GLOBAL_TOOLTIP_CLASS = 'global-tooltip';
function useGlobalTooltipChecker(brandName) {
    (0, _react.useEffect)(function() {
        var intervalId = setInterval(function() {
            findTooltipElements(document.body);
        }, 10);
        function findTooltipElements(root) {
            if (root instanceof HTMLElement && (root.classList.contains(RICH_TEXT_TOOLTIP_CLASS) || root.classList.contains(GLOBAL_TOOLTIP_CLASS))) attachTooltipEvents(root);
            root.childNodes.forEach(function(child) {
                if (child.nodeType === 1) findTooltipElements(child);
            });
            if (root instanceof HTMLElement && root.shadowRoot) root.shadowRoot.childNodes.forEach(function(child) {
                if (child.nodeType === 1) findTooltipElements(child);
            });
        }
        function attachTooltipEvents(element) {
            if (!element.hasAttribute('data-tooltip-initialized')) {
                element.addEventListener('mouseenter', handleMouseEnter);
                element.addEventListener('mouseleave', handleMouseLeave);
                element.setAttribute('data-tooltip-initialized', 'true');
            }
        }
        var isTooltipVisible = false;
        var isTooltipBig = false;
        var hoverTimeout;
        var tooltipWrapper = null;
        function handleMouseEnter(event) {
            if (isTooltipVisible) return;
            hoverTimeout = setTimeout(function() {
                var tooltipText = event.target.getAttribute('data-tooltip-html');
                if (tooltipText) {
                    isTooltipVisible = true;
                    var computedStyles = getComputedStyle(event.target);
                    var targetStyles = {
                        fontFamily: computedStyles.fontFamily,
                        color: computedStyles.color
                    };
                    showTooltip(event.target, tooltipText, targetStyles);
                }
            }, 100);
        }
        function handleMouseLeave(event) {
            clearTimeout(hoverTimeout);
            hoverTimeout = setTimeout(function() {
                var related = event.relatedTarget;
                if (tooltipWrapper && related && tooltipWrapper.contains(related)) return;
                closeTooltip();
            }, 200);
        }
        function closeTooltip() {
            if (activeTooltipRemover) activeTooltipRemover();
            isTooltipVisible = false;
            isTooltipBig = false;
        }
        function handleTooltipMouseEnter() {
            clearTimeout(hoverTimeout);
        }
        function handleTooltipMouseLeave(event) {
            var _event_target;
            var related = event.relatedTarget;
            if (!related || !(tooltipWrapper === null || tooltipWrapper === void 0 ? void 0 : tooltipWrapper.contains(related)) && !((_event_target = event.target) === null || _event_target === void 0 ? void 0 : _event_target.contains(related))) hoverTimeout = setTimeout(function() {
                closeTooltip();
            }, 200);
        }
        function adjustTooltipPosition(tooltipWrapperInner, target) {
            var _tooltipWrapperInner_getBoundingClientRect = tooltipWrapperInner.getBoundingClientRect(), tooltipWidth = _tooltipWrapperInner_getBoundingClientRect.width, tooltipHeight = _tooltipWrapperInner_getBoundingClientRect.height;
            var viewportWidth = window.innerWidth;
            var _target_getBoundingClientRect = target.getBoundingClientRect(), left = _target_getBoundingClientRect.left, targetWidth = _target_getBoundingClientRect.width;
            var _target_getBoundingClientRect1 = target.getBoundingClientRect(), top = _target_getBoundingClientRect1.top, targetHeight = _target_getBoundingClientRect1.height;
            var tooltipLeft = left + targetWidth / 2 - tooltipWidth / 2;
            var tooltipTop = top + window.scrollY - tooltipHeight - 12;
            var isTooltipAbove = true;
            if (tooltipTop < window.scrollY) {
                tooltipTop = top + window.scrollY + targetHeight + 12;
                isTooltipAbove = false;
            }
            if (tooltipLeft + tooltipWidth > viewportWidth) {
                tooltipLeft = viewportWidth - tooltipWidth - 10;
                isTooltipBig = true;
            }
            if (tooltipLeft < 10) {
                tooltipLeft = 10;
                isTooltipBig = true;
            }
            tooltipWrapperInner.style.left = "".concat(tooltipLeft - (isTooltipBig ? 20 : 0), "px");
            tooltipWrapperInner.style.top = "".concat(tooltipTop, "px");
            var arrowElement = tooltipWrapperInner.querySelector('.tooltip-arrow');
            if (arrowElement) {
                var ref;
                ref = target.getBoundingClientRect(), left = ref.left, targetWidth = ref.width, ref;
                var arrowPosition = isTooltipBig ? left - 3 + targetWidth / 2 - tooltipLeft : tooltipWidth / 2 - 4;
                arrowElement.style.left = "".concat(arrowPosition, "px");
                if (isTooltipAbove) {
                    arrowElement.style.bottom = '-4px';
                    arrowElement.style.top = '';
                    arrowElement.style.transform = 'rotate(45deg)';
                } else {
                    arrowElement.style.top = '-4px';
                    arrowElement.style.bottom = '';
                    arrowElement.style.transform = 'rotate(225deg)';
                }
                if (isTooltipBig) tooltipWrapperInner.style.width = "fit-content";
            }
        }
        var activeTooltipRemover = null;
        function showTooltip(target, tooltipText, styles) {
            if (activeTooltipRemover) activeTooltipRemover();
            tooltipWrapper = document.createElement('div');
            tooltipWrapper.style.position = 'absolute';
            tooltipWrapper.style.pointerEvents = 'auto'; // Engedélyezzük az egéreseményeket
            tooltipWrapper.style.zIndex = '99999';
            document.body.appendChild(tooltipWrapper);
            var root = (0, _client.createRoot)(tooltipWrapper);
            root.render(/*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _customTooltip.CustomTooltip), {
                brand: brandName,
                text: tooltipText,
                styles: styles
            }));
            setTimeout(function() {
                var tooltipElement = tooltipWrapper.firstChild;
                if (tooltipElement) {
                    tooltipElement.classList.add('visible');
                    tooltipElement.classList.add('richtext-tooltip');
                    tooltipElement.addEventListener('mouseenter', handleTooltipMouseEnter);
                    tooltipElement.addEventListener('mouseleave', handleTooltipMouseLeave);
                }
                adjustTooltipPosition(tooltipWrapper, target);
            }, 0);
            activeTooltipRemover = function() {
                root.unmount();
                tooltipWrapper.remove();
                activeTooltipRemover = null;
                tooltipWrapper = null;
            };
            return activeTooltipRemover;
        }
        return function() {
            clearInterval(intervalId);
            document.querySelectorAll('.' + RICH_TEXT_TOOLTIP_CLASS).forEach(function(tooltip) {
                tooltip.removeEventListener('mouseenter', handleMouseEnter);
                tooltip.removeEventListener('mouseleave', handleMouseLeave);
            });
        };
    }, [
        brandName
    ]);
}
exports.default = useGlobalTooltipChecker;

},{"react/jsx-runtime":"lhkWg","react":"gjea9","./CustomTooltip":"4hE91","react-dom/client":"buR08","@parcel/transformer-js/src/esmodule-helpers.js":"g0Ia8"}],"4hE91":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "TOOLTIP_ID", function() {
    return TOOLTIP_ID;
});
parcelHelpers.export(exports, "CustomTooltip", function() {
    return CustomTooltip;
});
var _taggedTemplateLiteral = require("@swc/helpers/_/_tagged_template_literal");
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _styledComponents = require("styled-components");
var _styledComponentsDefault = parcelHelpers.interopDefault(_styledComponents);
var _richText = require("../rich-text/general/rich-text");
var _reactScrollbarsCustom = require("react-scrollbars-custom");
var _reactScrollbarsCustomDefault = parcelHelpers.interopDefault(_reactScrollbarsCustom);
function _templateObject() {
    var data = (0, _taggedTemplateLiteral._)([
        "\n      border-color: ",
        ";\n    "
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject1() {
    var data = (0, _taggedTemplateLiteral._)([
        "\n  left: calc(50% - 4px);\n  bottom: -4px;\n  border-bottom: 1px solid transparent;\n  border-right: 1px solid transparent;\n  transform: rotate(45deg);\n  width: 8px;\n  height: 8px;\n  position: absolute;\n  background: inherit;\n  ",
        ";\n"
    ]);
    _templateObject1 = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject2() {
    var data = (0, _taggedTemplateLiteral._)([
        "\n  background: white !important;\n  font-size: 16px !important;\n  display: inline-block;\n  color: #787b80 !important;\n  border-radius: 0 !important;\n  z-index: 3000 !important;\n  padding: 10px !important;\n  margin: 0;\n  opacity: 0;\n  border: 1px solid black;\n  transition: all 0.3s ease-in-out;\n  pointer-events: all;\n  box-shadow: 0px 12px 16px -4px rgba(16, 24, 40, 0.08), 0px 4px 6px -2px rgba(16, 24, 40, 0.03) !important;\n\n  &.visible {\n    opacity: 1;\n  }\n"
    ]);
    _templateObject2 = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject3() {
    var data = (0, _taggedTemplateLiteral._)([
        "\n  border-radius: 8px !important;\n  border-color: transparent !important;\n  color: #333333 !important;\n  padding: 12px !important;\n  font-size: 12px;\n  word-break: break-word;\n  hyphens: auto;\n  font-family: 'Citroen', serif !important;\n\n  .ScrollbarsCustom-TrackY {\n    top: 0 !important;\n    width: 4px !important;\n    height: 100% !important;\n    background-color: #e4e2e2 !important;\n    border-radius: 2px !important;\n  }\n\n  .ScrollbarsCustom-Thumb {\n    width: 4px !important;\n    height: 48px !important;\n    background-color: #da291c !important;\n    border-radius: 2px !important;\n  }\n"
    ]);
    _templateObject3 = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject4() {
    var data = (0, _taggedTemplateLiteral._)([
        "\n  font-size: 10px;\n  font-style: normal;\n  font-weight: 400;\n  line-height: 140%;\n  border-color: transparent !important;\n  position: relative;\n  cursor: pointer;\n  margin: 0;\n  color: black !important;\n  font-family: 'PeugeotNormal', serif !important;\n\n  .ScrollbarsCustom-TrackY {\n    top: 0 !important;\n    width: 4px !important;\n    height: 100% !important;\n    background-color: #ececee !important;\n  }\n\n  .ScrollbarsCustom-Thumb {\n    width: 4px !important;\n    height: 48px !important;\n    background-color: #0074e8 !important;\n    border-radius: 0 !important;\n  }\n"
    ]);
    _templateObject4 = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject5() {
    var data = (0, _taggedTemplateLiteral._)([
        "\n  position: relative;\n  cursor: pointer;\n  font-size: 20px;\n  margin: 0;\n  padding: 16px !important;\n  border-color: #9d8c83 !important;\n  font-family: 'DSAutomobiles', serif !important;\n\n  .ScrollbarsCustom-TrackY {\n    top: 0 !important;\n    width: 4px !important;\n    height: 100% !important;\n    background-color: #e9e7e1 !important;\n  }\n\n  .ScrollbarsCustom-Thumb {\n    width: 4px !important;\n    height: 48px !important;\n    background-color: #9d8c83 !important;\n    border-radius: 0 !important;\n  }\n\n  p {\n    line-height: unset !important;\n  }\n"
    ]);
    _templateObject5 = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject6() {
    var data = (0, _taggedTemplateLiteral._)([
        "\n  cursor: pointer;\n  display: inline-flex;\n  width: fit-content;\n  margin: 0;\n  border-color: transparent !important;\n  font-size: 12px;\n  font-style: normal;\n  font-weight: 400;\n  line-height: 140%;\n  color: black !important;\n  font-family: 'OpelNext', serif !important;\n  border-radius: 16px !important;\n\n  .ScrollbarsCustom-TrackY {\n    top: 0 !important;\n    width: 4px !important;\n    height: 100% !important;\n    background-color: #cccccc !important;\n  }\n\n  .ScrollbarsCustom-Thumb {\n    width: 4px !important;\n    height: 48px !important;\n    background-color: black !important;\n    border-radius: 0 !important;\n  }\n"
    ]);
    _templateObject6 = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject7() {
    var data = (0, _taggedTemplateLiteral._)([
        "\n  position: relative;\n  cursor: pointer;\n  margin: 0;\n  color: #222 !important;\n  border-color: transparent !important;\n  font-size: 10px;\n  font-style: normal;\n  font-weight: 400;\n  line-height: 140%;\n  text-transform: none !important;\n  font-family: 'SansPro', serif !important;\n\n  .ScrollbarsCustom-TrackY {\n    top: 0 !important;\n    width: 4px !important;\n    height: 100% !important;\n    background-color: #c7c8ca !important;\n  }\n\n  .ScrollbarsCustom-Thumb {\n    width: 4px !important;\n    height: 48px !important;\n    background-color: #2f2c4d !important;\n    border-radius: 0 !important;\n  }\n"
    ]);
    _templateObject7 = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject8() {
    var data = (0, _taggedTemplateLiteral._)([
        "\n  position: relative;\n  cursor: pointer;\n  margin: 0;\n  color: #222 !important;\n  border-color: transparent !important;\n  font-size: 10px;\n  font-style: normal;\n  font-weight: 400;\n  line-height: 140%;\n  font-family: 'SansPro', serif !important;\n\n  .ScrollbarsCustom-TrackY {\n    top: 0 !important;\n    width: 4px !important;\n    height: 100% !important;\n    background-color: #c7c8ca !important;\n  }\n\n  .ScrollbarsCustom-Thumb {\n    width: 4px !important;\n    height: 48px !important;\n    background-color: #ff0000 !important;\n    border-radius: 0 !important;\n  }\n"
    ]);
    _templateObject8 = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject9() {
    var data = (0, _taggedTemplateLiteral._)([
        "\n  position: relative;\n  cursor: pointer;\n  font-size: 20px;\n  margin: 0;\n  padding: 12px !important;\n  border-color: transparent !important;\n  border-radius: 12px !important;\n  color: black !important;\n  font-family: 'Poppins', serif !important;\n\n  .ScrollbarsCustom-TrackY {\n    top: 0 !important;\n    width: 4px !important;\n    height: 100% !important;\n    background-color: #e0e0e0 !important;\n  }\n\n  .ScrollbarsCustom-Thumb {\n    width: 4px !important;\n    height: 48px !important;\n    background-color: #547496 !important;\n    border-radius: 2px !important;\n  }\n"
    ]);
    _templateObject9 = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject10() {
    var data = (0, _taggedTemplateLiteral._)([
        "\n  position: relative;\n  cursor: pointer;\n  font-size: 20px;\n  margin: 0;\n  padding: 12px !important;\n  border-color: transparent !important;\n  border-radius: 12px !important;\n  color: #222 !important;\n  font-family: 'Montserrat', serif !important;\n\n  .ScrollbarsCustom-TrackY {\n    top: 0 !important;\n    width: 4px !important;\n    height: 100% !important;\n    background-color: #e0e0e0 !important;\n  }\n\n  .ScrollbarsCustom-Thumb {\n    width: 4px !important;\n    height: 48px !important;\n    background-color: #787878 !important;\n    border-radius: 2px !important;\n  }\n"
    ]);
    _templateObject10 = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject11() {
    var data = (0, _taggedTemplateLiteral._)([
        "\n  position: relative;\n  cursor: pointer;\n  font-size: 20px;\n  margin: 0;\n  padding: 12px !important;\n  border-color: transparent !important;\n  color: black !important;\n  line-height: 140%;\n  font-family: 'Roboto', serif !important;\n\n  .ScrollbarsCustom-TrackY {\n    top: 0 !important;\n    width: 4px !important;\n    height: 100% !important;\n    background-color: #e0e0e0 !important;\n  }\n\n  .ScrollbarsCustom-Thumb {\n    width: 4px !important;\n    height: 48px !important;\n    background-color: #787878 !important;\n    border-radius: 0 !important;\n  }\n"
    ]);
    _templateObject11 = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject12() {
    var data = (0, _taggedTemplateLiteral._)([
        "\n  position: relative;\n  cursor: pointer;\n  font-size: 20px;\n  margin: 0;\n  padding: 12px !important;\n  border-color: transparent !important;\n  font-family: 'Helvetica', serif !important;\n\n  .ScrollbarsCustom-TrackY {\n    top: 0 !important;\n    width: 4px !important;\n    height: 100% !important;\n    background-color: #e0e0e0 !important;\n  }\n\n  .ScrollbarsCustom-Thumb {\n    width: 4px !important;\n    height: 48px !important;\n    background-color: #787878 !important;\n    border-radius: 0 !important;\n  }\n"
    ]);
    _templateObject12 = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject13() {
    var data = (0, _taggedTemplateLiteral._)([
        "\n  font-size: 10px;\n  font-style: normal;\n  font-weight: 400;\n  line-height: 140%;\n  padding: 12px !important;\n  background-color: #000000 !important;\n  position: relative;\n  cursor: pointer;\n  margin: 0;\n  color: white !important;\n  font-family: 'Abarth', serif !important;\n  border-radius: 8px !important;\n\n  .ScrollbarsCustom-TrackY {\n    top: 0 !important;\n    width: 4px !important;\n    height: 100% !important;\n    background-color: #e0e0e0 !important;\n  }\n\n  .ScrollbarsCustom-Thumb {\n    width: 4px !important;\n    height: 48px !important;\n    background-color: #787878 !important;\n    border-radius: 2px !important;\n  }\n"
    ]);
    _templateObject13 = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject14() {
    var data = (0, _taggedTemplateLiteral._)([
        ""
    ]);
    _templateObject14 = function _templateObject() {
        return data;
    };
    return data;
}
var TOOLTIP_ID = 'global-brand-tooltip';
var Arrow = (0, _styledComponentsDefault.default).div.attrs({
    className: 'tooltip-arrow'
})(_templateObject1(), function(p) {
    return p.borderColor && (0, _styledComponents.css)(_templateObject(), p.borderColor);
});
var BaseTooltipStyle = (0, _styledComponentsDefault.default).div(_templateObject2());
var CitBaseTooltipStyle = (0, _styledComponentsDefault.default)(BaseTooltipStyle)(_templateObject3());
var PeuBaseTooltipStyle = (0, _styledComponentsDefault.default)(BaseTooltipStyle)(_templateObject4());
var DsBaseTooltipStyle = (0, _styledComponentsDefault.default)(BaseTooltipStyle)(_templateObject5());
var OpelBaseTooltipStyle = (0, _styledComponentsDefault.default)(BaseTooltipStyle)(_templateObject6());
var SsgBaseTooltipStyle = (0, _styledComponentsDefault.default)(BaseTooltipStyle)(_templateObject7());
var IsuBaseTooltipStyle = (0, _styledComponentsDefault.default)(BaseTooltipStyle)(_templateObject8());
var FiatBaseTooltipStyle = (0, _styledComponentsDefault.default)(BaseTooltipStyle)(_templateObject9());
var LanciaBaseTooltipStyle = (0, _styledComponentsDefault.default)(BaseTooltipStyle)(_templateObject10());
var JeepBaseTooltipStyle = (0, _styledComponentsDefault.default)(BaseTooltipStyle)(_templateObject11());
var AlfaBaseTooltipStyle = (0, _styledComponentsDefault.default)(BaseTooltipStyle)(_templateObject12());
var AbarthBaseTooltipStyle = (0, _styledComponentsDefault.default)(BaseTooltipStyle)(_templateObject13());
var AbarthTooltip = function(props) {
    return /*#__PURE__*/ (0, _jsxRuntime.jsxs)(AbarthBaseTooltipStyle, {
        style: props.styles,
        children: [
            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _reactScrollbarsCustomDefault.default), {
                style: {
                    width: 285,
                    height: 234
                },
                children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _richText.RichText), {
                    disableOverflow: true,
                    content: props.text
                })
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)(Arrow, {})
        ]
    });
};
var BaseTooltip = function(props) {
    return /*#__PURE__*/ (0, _jsxRuntime.jsxs)(BaseTooltipStyle, {
        style: props.styles,
        children: [
            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _richText.RichText), {
                disableOverflow: true,
                content: props.text
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)(Arrow, {})
        ]
    });
};
var CitTooltip = function(props) {
    return /*#__PURE__*/ (0, _jsxRuntime.jsxs)(CitBaseTooltipStyle, {
        style: props.styles,
        children: [
            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _reactScrollbarsCustomDefault.default), {
                style: {
                    width: 285,
                    height: 143
                },
                children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _richText.RichText), {
                    disableOverflow: true,
                    content: props.text
                })
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)(Arrow, {})
        ]
    });
};
var PeuTooltip = function(props) {
    return /*#__PURE__*/ (0, _jsxRuntime.jsxs)(PeuBaseTooltipStyle, {
        style: props.styles,
        children: [
            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _reactScrollbarsCustomDefault.default), {
                style: {
                    width: 285,
                    height: 136
                },
                children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _richText.RichText), {
                    disableOverflow: true,
                    content: props.text
                })
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)(Arrow, {})
        ]
    });
};
var DsTooltip = function(props) {
    return /*#__PURE__*/ (0, _jsxRuntime.jsxs)(DsBaseTooltipStyle, {
        style: props.styles,
        children: [
            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _reactScrollbarsCustomDefault.default), {
                style: {
                    width: 304,
                    height: 220
                },
                children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _richText.RichText), {
                    disableOverflow: true,
                    content: props.text
                })
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)(Arrow, {
                borderColor: '#9d8c83'
            })
        ]
    });
};
var OpelTooltip = function(props) {
    return /*#__PURE__*/ (0, _jsxRuntime.jsxs)(OpelBaseTooltipStyle, {
        style: props.styles,
        children: [
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                style: {
                    width: 285,
                    maxHeight: 143,
                    overflowY: 'auto',
                    overflowX: 'hidden'
                },
                children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _richText.RichText), {
                    disableOverflow: true,
                    content: props.text
                })
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)(Arrow, {})
        ]
    });
};
var SsgTooltip = function(props) {
    return /*#__PURE__*/ (0, _jsxRuntime.jsxs)(SsgBaseTooltipStyle, {
        style: props.styles,
        children: [
            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _reactScrollbarsCustomDefault.default), {
                style: {
                    width: 285,
                    height: 108
                },
                children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _richText.RichText), {
                    disableOverflow: true,
                    content: props.text
                })
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)(Arrow, {})
        ]
    });
};
var IsuTooltip = function(props) {
    return /*#__PURE__*/ (0, _jsxRuntime.jsxs)(IsuBaseTooltipStyle, {
        style: props.styles,
        children: [
            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _reactScrollbarsCustomDefault.default), {
                style: {
                    width: 285,
                    height: 108
                },
                children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _richText.RichText), {
                    disableOverflow: true,
                    content: props.text
                })
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)(Arrow, {})
        ]
    });
};
var FiatTooltip = function(props) {
    return /*#__PURE__*/ (0, _jsxRuntime.jsxs)(FiatBaseTooltipStyle, {
        style: props.styles,
        children: [
            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _reactScrollbarsCustomDefault.default), {
                style: {
                    width: 285,
                    height: 143
                },
                children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _richText.RichText), {
                    disableOverflow: true,
                    content: props.text
                })
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)(Arrow, {})
        ]
    });
};
var LanciaTooltip = function(props) {
    return /*#__PURE__*/ (0, _jsxRuntime.jsxs)(LanciaBaseTooltipStyle, {
        style: props.styles,
        children: [
            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _reactScrollbarsCustomDefault.default), {
                style: {
                    width: 285,
                    height: 143
                },
                children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _richText.RichText), {
                    disableOverflow: true,
                    content: props.text
                })
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)(Arrow, {})
        ]
    });
};
var JeepTooltip = function(props) {
    return /*#__PURE__*/ (0, _jsxRuntime.jsxs)(JeepBaseTooltipStyle, {
        style: props.styles,
        children: [
            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _reactScrollbarsCustomDefault.default), {
                style: {
                    width: 285,
                    height: 234
                },
                children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _richText.RichText), {
                    disableOverflow: true,
                    content: props.text
                })
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)(Arrow, {})
        ]
    });
};
var AlfaTooltip = function(props) {
    return /*#__PURE__*/ (0, _jsxRuntime.jsxs)(AlfaBaseTooltipStyle, {
        style: props.styles,
        children: [
            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _reactScrollbarsCustomDefault.default), {
                style: {
                    width: 285,
                    height: 240
                },
                children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _richText.RichText), {
                    disableOverflow: true,
                    content: props.text
                })
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)(Arrow, {})
        ]
    });
};
var AdminTooltip = (0, _styledComponentsDefault.default)(BaseTooltip)(_templateObject14());
var CustomTooltip = function(param) {
    var text = param.text, brand = param.brand, styles = param.styles;
    switch(brand){
        case 'abarth':
            return /*#__PURE__*/ (0, _jsxRuntime.jsx)(AbarthTooltip, {
                styles: styles,
                text: text
            });
        case 'peugeot':
            return /*#__PURE__*/ (0, _jsxRuntime.jsx)(PeuTooltip, {
                styles: styles,
                text: text
            });
        case 'jeep':
            return /*#__PURE__*/ (0, _jsxRuntime.jsx)(JeepTooltip, {
                styles: styles,
                text: text
            });
        case 'alfaromeo':
            return /*#__PURE__*/ (0, _jsxRuntime.jsx)(AlfaTooltip, {
                styles: styles,
                text: text
            });
        case 'opelold':
        case 'opel':
            return /*#__PURE__*/ (0, _jsxRuntime.jsx)(OpelTooltip, {
                styles: styles,
                text: text
            });
        case 'ds':
            return /*#__PURE__*/ (0, _jsxRuntime.jsx)(DsTooltip, {
                styles: styles,
                text: text
            });
        case 'fiat':
            return /*#__PURE__*/ (0, _jsxRuntime.jsx)(FiatTooltip, {
                styles: styles,
                text: text
            });
        case 'citroen':
            return /*#__PURE__*/ (0, _jsxRuntime.jsx)(CitTooltip, {
                styles: styles,
                text: text
            });
        case 'ssangyong':
            return /*#__PURE__*/ (0, _jsxRuntime.jsx)(SsgTooltip, {
                styles: styles,
                text: text
            });
        case 'isuzu':
            return /*#__PURE__*/ (0, _jsxRuntime.jsx)(IsuTooltip, {
                styles: styles,
                text: text
            });
        case 'admin':
            return /*#__PURE__*/ (0, _jsxRuntime.jsx)(AdminTooltip, {
                styles: styles,
                text: text
            });
        case 'lancia':
            return /*#__PURE__*/ (0, _jsxRuntime.jsx)(LanciaTooltip, {
                styles: styles,
                text: text
            });
        default:
            return /*#__PURE__*/ (0, _jsxRuntime.jsx)(BaseTooltip, {
                styles: styles,
                text: text
            });
    }
};

},{"@swc/helpers/_/_tagged_template_literal":"8vvZL","react/jsx-runtime":"lhkWg","react":"gjea9","styled-components":"4QkKB","../rich-text/general/rich-text":"7salU","react-scrollbars-custom":"9z6ut","@parcel/transformer-js/src/esmodule-helpers.js":"g0Ia8"}],"7salU":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "RichText", function() {
    return RichText;
});
var _slicedToArray = require("@swc/helpers/_/_sliced_to_array");
var _taggedTemplateLiteral = require("@swc/helpers/_/_tagged_template_literal");
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _commonStyles = require("../../../common.styles");
var _dompurify = require("dompurify");
var _dompurifyDefault = parcelHelpers.interopDefault(_dompurify);
var _embedRoot = require("../../../../embedding/embed-root");
function _templateObject() {
    var data = (0, _taggedTemplateLiteral._)([
        "\n  width: 100%;\n  height: fit-content;\n  word-break: break-word;\n  max-height: ",
        ";\n  min-height: ",
        ";\n  overflow: ",
        ";\n  overflow-wrap: ",
        ";\n\n  /* for wicket added baseline vertical-align and don't work sup and sub tags */\n  p {\n    sub {\n      vertical-align: sub !important;\n    }\n\n    sup {\n      vertical-align: super !important;\n    }\n  }\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}
var RichtextContainer = (0, _commonStyles.styled).div(_templateObject(), function(p) {
    return p.minMaxHeight ? p.minMaxHeight + 'px' : 'fit-content';
}, function(p) {
    return p.minMaxHeight ? p.minMaxHeight + 'px' : 'auto';
}, function(p) {
    return p.disableOverflow ? 'unset' : 'auto';
}, function(p) {
    return p.overFlowWrap && p.overFlowWrap;
});
var DOMPurifyConfig = {
    ADD_ATTR: [
        'target',
        'rel',
        'onclick'
    ],
    ADD_TAGS: [
        'iframe'
    ],
    FORCE_BODY: true
};
/**
 * A lot of html template coming from the backend has unnecessary html comments inside style tags, so just remove them.
 */ var removeHtmlCommentsFromStyleTags = function(content) {
    return (content !== null && content !== void 0 ? content : '').split('<style><!--').join('<style>').split('--></style>').join('</style>');
};
var _richTextInstanceCounter = 0;
var traverseAndTransformContent = function(node, lang) {
    var elementStyle = window.getComputedStyle(node);
    var cssTextTransform = elementStyle.textTransform;
    if ((cssTextTransform === null || cssTextTransform === void 0 ? void 0 : cssTextTransform.toLowerCase()) === 'uppercase') node.innerText = node.innerText.toLocaleUpperCase(lang);
    if (node.children && node.children.length) Array.from(node.children).forEach(function(child) {
        traverseAndTransformContent(child, lang);
    });
};
var RichText = /*#__PURE__*/ (0, _reactDefault.default).forwardRef(function(props, ref) {
    var disableOverflow = props.disableOverflow || false;
    var htmlTabContent = (0, _react.useMemo)(function() {
        var preparedContent = removeHtmlCommentsFromStyleTags(props.content);
        preparedContent = preparedContent.replace('data-tooltip-id="global-brand-tooltip"', '');
        var _DOMPurify_sanitize;
        return {
            __html: (_DOMPurify_sanitize = (0, _dompurifyDefault.default) === null || (0, _dompurifyDefault.default) === void 0 ? void 0 : (0, _dompurifyDefault.default).sanitize(preparedContent, DOMPurifyConfig)) !== null && _DOMPurify_sanitize !== void 0 ? _DOMPurify_sanitize : ''
        };
    }, [
        props.content,
        (0, _dompurifyDefault.default)
    ]);
    var _useState = (0, _slicedToArray._)((0, _react.useState)(_richTextInstanceCounter++), 1), instanceId = _useState[0];
    var _useState1 = (0, _slicedToArray._)((0, _react.useState)(0), 2), refreshCount = _useState1[0], setRefreshCount = _useState1[1];
    var embedStore = (0, _react.useContext)((0, _embedRoot.EmbedContext));
    var textRef = (0, _react.useRef)(null);
    (0, _react.useEffect)(function() {
        var newRefreshCount = refreshCount + 1;
        var scriptElement = document.createElement('script');
        scriptElement.setAttribute('rich-text-content-' + instanceId + '-' + newRefreshCount, '');
        var additionalScriptElements = [];
        var scriptsRegex = /<script[^>]*>([\s\S]*?)<\/script>/gm;
        var scriptSrcRegex = /src=["']([^"']*)["']/gm;
        var cDataReplaceRegex = /\/\/ *<!\[CDATA\[(.*?)\/\/ *]]>/gm;
        var jquerySelectorsRegex = /\$\((?:("[^"]*")|('[^']*'))\)/gm;
        var styleTagRegex = /<style([^>]*)>/gm;
        setRefreshCount(newRefreshCount);
        var scriptContent = scriptsRegex.exec(props.content);
        while(scriptContent != null){
            var _scriptSrcRegex_exec;
            var src = (_scriptSrcRegex_exec = scriptSrcRegex.exec((scriptContent === null || scriptContent === void 0 ? void 0 : scriptContent[0]) || '')) === null || _scriptSrcRegex_exec === void 0 ? void 0 : _scriptSrcRegex_exec[1];
            if (src !== undefined) {
                var scriptToLoad = document.createElement('script');
                scriptToLoad.setAttribute('rich-text-content-' + instanceId + '-' + newRefreshCount, '');
                scriptToLoad.src = src;
                additionalScriptElements.push(scriptToLoad);
            }
            var content = scriptContent[1].replace(cDataReplaceRegex, '$1');
            var selectorMatch = jquerySelectorsRegex.exec(content);
            while(selectorMatch != null){
                var selector = selectorMatch[1] || selectorMatch[2];
                var strippedSelector = selector.replace(/['"]*/gm, '');
                if (strippedSelector.indexOf('body') !== 0 && strippedSelector.indexOf('head') !== 0) {
                    var encapsuleSelector = '.RichTextInstance' + instanceId + '-' + newRefreshCount + ' ';
                    var _selector_slice, _selector_slice1;
                    var replacedText = ((_selector_slice = selector === null || selector === void 0 ? void 0 : selector.slice(0, 1)) !== null && _selector_slice !== void 0 ? _selector_slice : '') + encapsuleSelector + ((_selector_slice1 = selector === null || selector === void 0 ? void 0 : selector.slice(1)) !== null && _selector_slice1 !== void 0 ? _selector_slice1 : '');
                    content = content.replace(selector, replacedText);
                }
                selectorMatch = jquerySelectorsRegex.exec(content);
            }
            var styleMatch = styleTagRegex.exec(content);
            while(styleMatch != null){
                content = content.replace(styleMatch[0], '<style rich-text-content-' + instanceId + '-' + newRefreshCount + ' ' + styleMatch[1] + '>');
                styleMatch = styleTagRegex.exec(content);
            }
            scriptElement.innerText += content;
            scriptContent = scriptsRegex.exec(props.content);
        }
        if (scriptElement.innerText) setTimeout(function() {
            document.body.appendChild(scriptElement);
        }, 300);
        if (additionalScriptElements.length > 0) setTimeout(function() {
            additionalScriptElements.forEach(function(additionalScriptElement) {
                document.body.appendChild(additionalScriptElement);
            });
        }, 300);
        setTimeout(function() {
            var htmlLang = document.getElementsByTagName('html')[0].getAttribute('lang') || 'en';
            // DWT-50020 - uppercased greek characters has some problems if uppercased with CSS - we uppercase it with toLocaleUpperCase()
            if (htmlLang === 'el') {
                var container = document.querySelector('.RichTextInstance' + instanceId + '-' + newRefreshCount);
                if (container) traverseAndTransformContent(container, htmlLang);
            }
        }, 300);
        return function() {
            setTimeout(function() {
                var elements = document.querySelectorAll('*[rich-text-content-' + instanceId + '-' + newRefreshCount + ']');
                elements.forEach(function(element) {
                    element.remove();
                });
            }, 300);
        };
    }, [
        props.content
    ]);
    // Clean up empty <p> tags
    var cleanEmptyPTags = function(text) {
        var _ref = (embedStore === null || embedStore === void 0 ? void 0 : embedStore.decodedJwtToken) || {}, countryCode = _ref.countryCode, brand = _ref.brand, dealerCode = _ref.dealerCode;
        if (countryCode === 'HU' && brand === 'FIAT' && dealerCode.includes('FIHU')) // For Hungary FIAT dealers, return simple text without cleaning empty <p> tags
        return text;
        return text.replace(/<p[^>]*>(\s|&nbsp;|&#160;)*<\/p>/gi, '');
    };
    // Handle new tooltips logic, new tooltip use react-tooltip package
    var newModifiedHtmlWithTooltip = (0, _react.useMemo)(function() {
        var newModifiedHtml = htmlTabContent.__html.replace(/class="richtext-tooltip"/g, function() {
            return 'class="richtext-tooltip" data-tooltip-id='.concat(embedStore.tooltipContainerId);
        });
        return cleanEmptyPTags(newModifiedHtml);
    }, [
        htmlTabContent.__html
    ]);
    (0, _react.useEffect)(function() {
        var handleKeyDown = function(event) {
            if (event.ctrlKey && event.key === 'a' && (textRef === null || textRef === void 0 ? void 0 : textRef.current)) {
                event.preventDefault();
                var range = document.createRange();
                range.selectNodeContents(textRef === null || textRef === void 0 ? void 0 : textRef.current);
                var selection = window.getSelection();
                selection === null || selection === void 0 ? void 0 : selection.removeAllRanges();
                selection === null || selection === void 0 ? void 0 : selection.addRange(range);
            }
        };
        var container = textRef === null || textRef === void 0 ? void 0 : textRef.current;
        if (container) container.addEventListener('click', function() {
            document.addEventListener('keydown', handleKeyDown);
        });
        return function() {
            document.removeEventListener('keydown', handleKeyDown);
        };
    }, []);
    if (!props.content || !(0, _dompurifyDefault.default) || !htmlTabContent) return null;
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _jsxRuntime.Fragment), {
        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)(RichtextContainer, {
            minMaxHeight: props.minMaxHeight,
            disableOverflow: disableOverflow,
            overFlowWrap: props.overFlowWrap,
            ref: ref || textRef,
            className: props.className !== undefined ? props.className + ' RichTextInstance' + instanceId + '-' + refreshCount : 'RichTextInstance' + instanceId + '-' + refreshCount,
            onClick: props.onClick,
            dangerouslySetInnerHTML: {
                __html: newModifiedHtmlWithTooltip.padStart(refreshCount - 1, ' ')
            }
        })
    });
});

},{"@swc/helpers/_/_sliced_to_array":"5Sh31","@swc/helpers/_/_tagged_template_literal":"8vvZL","react/jsx-runtime":"lhkWg","react":"gjea9","../../../common.styles":"9NP4o","dompurify":"2dYKW","../../../../embedding/embed-root":"fM9uU","@parcel/transformer-js/src/esmodule-helpers.js":"g0Ia8"}],"2dYKW":[function(require,module,exports,__globalThis) {
/*! @license DOMPurify 2.5.8 | (c) Cure53 and other contributors | Released under the Apache license 2.0 and Mozilla Public License 2.0 | github.com/cure53/DOMPurify/blob/2.5.8/LICENSE */ (function(global, factory) {
    module.exports = factory();
})(this, function() {
    'use strict';
    function _typeof(obj) {
        "@babel/helpers - typeof";
        return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function _typeof(obj) {
            return typeof obj;
        } : function(obj) {
            return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
        }, _typeof(obj);
    }
    function _setPrototypeOf(o, p) {
        _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) {
            o.__proto__ = p;
            return o;
        };
        return _setPrototypeOf(o, p);
    }
    function _isNativeReflectConstruct() {
        if (typeof Reflect === "undefined" || !Reflect.construct) return false;
        if (Reflect.construct.sham) return false;
        if (typeof Proxy === "function") return true;
        try {
            Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {}));
            return true;
        } catch (e) {
            return false;
        }
    }
    function _construct(Parent, args, Class) {
        if (_isNativeReflectConstruct()) _construct = Reflect.construct;
        else _construct = function _construct(Parent, args, Class) {
            var a = [
                null
            ];
            a.push.apply(a, args);
            var Constructor = Function.bind.apply(Parent, a);
            var instance = new Constructor();
            if (Class) _setPrototypeOf(instance, Class.prototype);
            return instance;
        };
        return _construct.apply(null, arguments);
    }
    function _toConsumableArray(arr) {
        return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _unsupportedIterableToArray(arr) || _nonIterableSpread();
    }
    function _arrayWithoutHoles(arr) {
        if (Array.isArray(arr)) return _arrayLikeToArray(arr);
    }
    function _iterableToArray(iter) {
        if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter);
    }
    function _unsupportedIterableToArray(o, minLen) {
        if (!o) return;
        if (typeof o === "string") return _arrayLikeToArray(o, minLen);
        var n = Object.prototype.toString.call(o).slice(8, -1);
        if (n === "Object" && o.constructor) n = o.constructor.name;
        if (n === "Map" || n === "Set") return Array.from(o);
        if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen);
    }
    function _arrayLikeToArray(arr, len) {
        if (len == null || len > arr.length) len = arr.length;
        for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
        return arr2;
    }
    function _nonIterableSpread() {
        throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
    }
    var hasOwnProperty = Object.hasOwnProperty, setPrototypeOf = Object.setPrototypeOf, isFrozen = Object.isFrozen, getPrototypeOf = Object.getPrototypeOf, getOwnPropertyDescriptor = Object.getOwnPropertyDescriptor;
    var freeze = Object.freeze, seal = Object.seal, create = Object.create; // eslint-disable-line import/no-mutable-exports
    var _ref = typeof Reflect !== 'undefined' && Reflect, apply = _ref.apply, construct = _ref.construct;
    if (!apply) apply = function apply(fun, thisValue, args) {
        return fun.apply(thisValue, args);
    };
    if (!freeze) freeze = function freeze(x) {
        return x;
    };
    if (!seal) seal = function seal(x) {
        return x;
    };
    if (!construct) construct = function construct(Func, args) {
        return _construct(Func, _toConsumableArray(args));
    };
    var arrayForEach = unapply(Array.prototype.forEach);
    var arrayPop = unapply(Array.prototype.pop);
    var arrayPush = unapply(Array.prototype.push);
    var stringToLowerCase = unapply(String.prototype.toLowerCase);
    var stringToString = unapply(String.prototype.toString);
    var stringMatch = unapply(String.prototype.match);
    var stringReplace = unapply(String.prototype.replace);
    var stringIndexOf = unapply(String.prototype.indexOf);
    var stringTrim = unapply(String.prototype.trim);
    var regExpTest = unapply(RegExp.prototype.test);
    var typeErrorCreate = unconstruct(TypeError);
    function unapply(func) {
        return function(thisArg) {
            for(var _len = arguments.length, args = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++)args[_key - 1] = arguments[_key];
            return apply(func, thisArg, args);
        };
    }
    function unconstruct(func) {
        return function() {
            for(var _len2 = arguments.length, args = new Array(_len2), _key2 = 0; _key2 < _len2; _key2++)args[_key2] = arguments[_key2];
            return construct(func, args);
        };
    }
    /* Add properties to a lookup table */ function addToSet(set, array, transformCaseFunc) {
        var _transformCaseFunc;
        transformCaseFunc = (_transformCaseFunc = transformCaseFunc) !== null && _transformCaseFunc !== void 0 ? _transformCaseFunc : stringToLowerCase;
        if (setPrototypeOf) // Make 'in' and truthy checks like Boolean(set.constructor)
        // independent of any properties defined on Object.prototype.
        // Prevent prototype setters from intercepting set as a this value.
        setPrototypeOf(set, null);
        var l = array.length;
        while(l--){
            var element = array[l];
            if (typeof element === 'string') {
                var lcElement = transformCaseFunc(element);
                if (lcElement !== element) {
                    // Config presets (e.g. tags.js, attrs.js) are immutable.
                    if (!isFrozen(array)) array[l] = lcElement;
                    element = lcElement;
                }
            }
            set[element] = true;
        }
        return set;
    }
    /* Shallow clone an object */ function clone(object) {
        var newObject = create(null);
        var property;
        for(property in object)if (apply(hasOwnProperty, object, [
            property
        ]) === true) newObject[property] = object[property];
        return newObject;
    }
    /* IE10 doesn't support __lookupGetter__ so lets'
   * simulate it. It also automatically checks
   * if the prop is function or getter and behaves
   * accordingly. */ function lookupGetter(object, prop) {
        while(object !== null){
            var desc = getOwnPropertyDescriptor(object, prop);
            if (desc) {
                if (desc.get) return unapply(desc.get);
                if (typeof desc.value === 'function') return unapply(desc.value);
            }
            object = getPrototypeOf(object);
        }
        function fallbackValue(element) {
            console.warn('fallback value for', element);
            return null;
        }
        return fallbackValue;
    }
    var html$1 = freeze([
        'a',
        'abbr',
        'acronym',
        'address',
        'area',
        'article',
        'aside',
        'audio',
        'b',
        'bdi',
        'bdo',
        'big',
        'blink',
        'blockquote',
        'body',
        'br',
        'button',
        'canvas',
        'caption',
        'center',
        'cite',
        'code',
        'col',
        'colgroup',
        'content',
        'data',
        'datalist',
        'dd',
        'decorator',
        'del',
        'details',
        'dfn',
        'dialog',
        'dir',
        'div',
        'dl',
        'dt',
        'element',
        'em',
        'fieldset',
        'figcaption',
        'figure',
        'font',
        'footer',
        'form',
        'h1',
        'h2',
        'h3',
        'h4',
        'h5',
        'h6',
        'head',
        'header',
        'hgroup',
        'hr',
        'html',
        'i',
        'img',
        'input',
        'ins',
        'kbd',
        'label',
        'legend',
        'li',
        'main',
        'map',
        'mark',
        'marquee',
        'menu',
        'menuitem',
        'meter',
        'nav',
        'nobr',
        'ol',
        'optgroup',
        'option',
        'output',
        'p',
        'picture',
        'pre',
        'progress',
        'q',
        'rp',
        'rt',
        'ruby',
        's',
        'samp',
        'section',
        'select',
        'shadow',
        'small',
        'source',
        'spacer',
        'span',
        'strike',
        'strong',
        'style',
        'sub',
        'summary',
        'sup',
        'table',
        'tbody',
        'td',
        'template',
        'textarea',
        'tfoot',
        'th',
        'thead',
        'time',
        'tr',
        'track',
        'tt',
        'u',
        'ul',
        'var',
        'video',
        'wbr'
    ]);
    // SVG
    var svg$1 = freeze([
        'svg',
        'a',
        'altglyph',
        'altglyphdef',
        'altglyphitem',
        'animatecolor',
        'animatemotion',
        'animatetransform',
        'circle',
        'clippath',
        'defs',
        'desc',
        'ellipse',
        'filter',
        'font',
        'g',
        'glyph',
        'glyphref',
        'hkern',
        'image',
        'line',
        'lineargradient',
        'marker',
        'mask',
        'metadata',
        'mpath',
        'path',
        'pattern',
        'polygon',
        'polyline',
        'radialgradient',
        'rect',
        'stop',
        'style',
        'switch',
        'symbol',
        'text',
        'textpath',
        'title',
        'tref',
        'tspan',
        'view',
        'vkern'
    ]);
    var svgFilters = freeze([
        'feBlend',
        'feColorMatrix',
        'feComponentTransfer',
        'feComposite',
        'feConvolveMatrix',
        'feDiffuseLighting',
        'feDisplacementMap',
        'feDistantLight',
        'feFlood',
        'feFuncA',
        'feFuncB',
        'feFuncG',
        'feFuncR',
        'feGaussianBlur',
        'feImage',
        'feMerge',
        'feMergeNode',
        'feMorphology',
        'feOffset',
        'fePointLight',
        'feSpecularLighting',
        'feSpotLight',
        'feTile',
        'feTurbulence'
    ]);
    // List of SVG elements that are disallowed by default.
    // We still need to know them so that we can do namespace
    // checks properly in case one wants to add them to
    // allow-list.
    var svgDisallowed = freeze([
        'animate',
        'color-profile',
        'cursor',
        'discard',
        'fedropshadow',
        'font-face',
        'font-face-format',
        'font-face-name',
        'font-face-src',
        'font-face-uri',
        'foreignobject',
        'hatch',
        'hatchpath',
        'mesh',
        'meshgradient',
        'meshpatch',
        'meshrow',
        'missing-glyph',
        'script',
        'set',
        'solidcolor',
        'unknown',
        'use'
    ]);
    var mathMl$1 = freeze([
        'math',
        'menclose',
        'merror',
        'mfenced',
        'mfrac',
        'mglyph',
        'mi',
        'mlabeledtr',
        'mmultiscripts',
        'mn',
        'mo',
        'mover',
        'mpadded',
        'mphantom',
        'mroot',
        'mrow',
        'ms',
        'mspace',
        'msqrt',
        'mstyle',
        'msub',
        'msup',
        'msubsup',
        'mtable',
        'mtd',
        'mtext',
        'mtr',
        'munder',
        'munderover'
    ]);
    // Similarly to SVG, we want to know all MathML elements,
    // even those that we disallow by default.
    var mathMlDisallowed = freeze([
        'maction',
        'maligngroup',
        'malignmark',
        'mlongdiv',
        'mscarries',
        'mscarry',
        'msgroup',
        'mstack',
        'msline',
        'msrow',
        'semantics',
        'annotation',
        'annotation-xml',
        'mprescripts',
        'none'
    ]);
    var text = freeze([
        '#text'
    ]);
    var html = freeze([
        'accept',
        'action',
        'align',
        'alt',
        'autocapitalize',
        'autocomplete',
        'autopictureinpicture',
        'autoplay',
        'background',
        'bgcolor',
        'border',
        'capture',
        'cellpadding',
        'cellspacing',
        'checked',
        'cite',
        'class',
        'clear',
        'color',
        'cols',
        'colspan',
        'controls',
        'controlslist',
        'coords',
        'crossorigin',
        'datetime',
        'decoding',
        'default',
        'dir',
        'disabled',
        'disablepictureinpicture',
        'disableremoteplayback',
        'download',
        'draggable',
        'enctype',
        'enterkeyhint',
        'face',
        'for',
        'headers',
        'height',
        'hidden',
        'high',
        'href',
        'hreflang',
        'id',
        'inputmode',
        'integrity',
        'ismap',
        'kind',
        'label',
        'lang',
        'list',
        'loading',
        'loop',
        'low',
        'max',
        'maxlength',
        'media',
        'method',
        'min',
        'minlength',
        'multiple',
        'muted',
        'name',
        'nonce',
        'noshade',
        'novalidate',
        'nowrap',
        'open',
        'optimum',
        'pattern',
        'placeholder',
        'playsinline',
        'poster',
        'preload',
        'pubdate',
        'radiogroup',
        'readonly',
        'rel',
        'required',
        'rev',
        'reversed',
        'role',
        'rows',
        'rowspan',
        'spellcheck',
        'scope',
        'selected',
        'shape',
        'size',
        'sizes',
        'span',
        'srclang',
        'start',
        'src',
        'srcset',
        'step',
        'style',
        'summary',
        'tabindex',
        'title',
        'translate',
        'type',
        'usemap',
        'valign',
        'value',
        'width',
        'xmlns',
        'slot'
    ]);
    var svg = freeze([
        'accent-height',
        'accumulate',
        'additive',
        'alignment-baseline',
        'ascent',
        'attributename',
        'attributetype',
        'azimuth',
        'basefrequency',
        'baseline-shift',
        'begin',
        'bias',
        'by',
        'class',
        'clip',
        'clippathunits',
        'clip-path',
        'clip-rule',
        'color',
        'color-interpolation',
        'color-interpolation-filters',
        'color-profile',
        'color-rendering',
        'cx',
        'cy',
        'd',
        'dx',
        'dy',
        'diffuseconstant',
        'direction',
        'display',
        'divisor',
        'dur',
        'edgemode',
        'elevation',
        'end',
        'fill',
        'fill-opacity',
        'fill-rule',
        'filter',
        'filterunits',
        'flood-color',
        'flood-opacity',
        'font-family',
        'font-size',
        'font-size-adjust',
        'font-stretch',
        'font-style',
        'font-variant',
        'font-weight',
        'fx',
        'fy',
        'g1',
        'g2',
        'glyph-name',
        'glyphref',
        'gradientunits',
        'gradienttransform',
        'height',
        'href',
        'id',
        'image-rendering',
        'in',
        'in2',
        'k',
        'k1',
        'k2',
        'k3',
        'k4',
        'kerning',
        'keypoints',
        'keysplines',
        'keytimes',
        'lang',
        'lengthadjust',
        'letter-spacing',
        'kernelmatrix',
        'kernelunitlength',
        'lighting-color',
        'local',
        'marker-end',
        'marker-mid',
        'marker-start',
        'markerheight',
        'markerunits',
        'markerwidth',
        'maskcontentunits',
        'maskunits',
        'max',
        'mask',
        'media',
        'method',
        'mode',
        'min',
        'name',
        'numoctaves',
        'offset',
        'operator',
        'opacity',
        'order',
        'orient',
        'orientation',
        'origin',
        'overflow',
        'paint-order',
        'path',
        'pathlength',
        'patterncontentunits',
        'patterntransform',
        'patternunits',
        'points',
        'preservealpha',
        'preserveaspectratio',
        'primitiveunits',
        'r',
        'rx',
        'ry',
        'radius',
        'refx',
        'refy',
        'repeatcount',
        'repeatdur',
        'restart',
        'result',
        'rotate',
        'scale',
        'seed',
        'shape-rendering',
        'specularconstant',
        'specularexponent',
        'spreadmethod',
        'startoffset',
        'stddeviation',
        'stitchtiles',
        'stop-color',
        'stop-opacity',
        'stroke-dasharray',
        'stroke-dashoffset',
        'stroke-linecap',
        'stroke-linejoin',
        'stroke-miterlimit',
        'stroke-opacity',
        'stroke',
        'stroke-width',
        'style',
        'surfacescale',
        'systemlanguage',
        'tabindex',
        'targetx',
        'targety',
        'transform',
        'transform-origin',
        'text-anchor',
        'text-decoration',
        'text-rendering',
        'textlength',
        'type',
        'u1',
        'u2',
        'unicode',
        'values',
        'viewbox',
        'visibility',
        'version',
        'vert-adv-y',
        'vert-origin-x',
        'vert-origin-y',
        'width',
        'word-spacing',
        'wrap',
        'writing-mode',
        'xchannelselector',
        'ychannelselector',
        'x',
        'x1',
        'x2',
        'xmlns',
        'y',
        'y1',
        'y2',
        'z',
        'zoomandpan'
    ]);
    var mathMl = freeze([
        'accent',
        'accentunder',
        'align',
        'bevelled',
        'close',
        'columnsalign',
        'columnlines',
        'columnspan',
        'denomalign',
        'depth',
        'dir',
        'display',
        'displaystyle',
        'encoding',
        'fence',
        'frame',
        'height',
        'href',
        'id',
        'largeop',
        'length',
        'linethickness',
        'lspace',
        'lquote',
        'mathbackground',
        'mathcolor',
        'mathsize',
        'mathvariant',
        'maxsize',
        'minsize',
        'movablelimits',
        'notation',
        'numalign',
        'open',
        'rowalign',
        'rowlines',
        'rowspacing',
        'rowspan',
        'rspace',
        'rquote',
        'scriptlevel',
        'scriptminsize',
        'scriptsizemultiplier',
        'selection',
        'separator',
        'separators',
        'stretchy',
        'subscriptshift',
        'supscriptshift',
        'symmetric',
        'voffset',
        'width',
        'xmlns'
    ]);
    var xml = freeze([
        'xlink:href',
        'xml:id',
        'xlink:title',
        'xml:space',
        'xmlns:xlink'
    ]);
    // eslint-disable-next-line unicorn/better-regex
    var MUSTACHE_EXPR = seal(/\{\{[\w\W]*|[\w\W]*\}\}/gm); // Specify template detection regex for SAFE_FOR_TEMPLATES mode
    var ERB_EXPR = seal(/<%[\w\W]*|[\w\W]*%>/gm);
    var TMPLIT_EXPR = seal(/\${[\w\W]*}/gm);
    var DATA_ATTR = seal(/^data-[\-\w.\u00B7-\uFFFF]+$/); // eslint-disable-line no-useless-escape
    var ARIA_ATTR = seal(/^aria-[\-\w]+$/); // eslint-disable-line no-useless-escape
    var IS_ALLOWED_URI = seal(/^(?:(?:(?:f|ht)tps?|mailto|tel|callto|cid|xmpp):|[^a-z]|[a-z+.\-]+(?:[^a-z+.\-:]|$))/i // eslint-disable-line no-useless-escape
    );
    var IS_SCRIPT_OR_DATA = seal(/^(?:\w+script|data):/i);
    var ATTR_WHITESPACE = seal(/[\u0000-\u0020\u00A0\u1680\u180E\u2000-\u2029\u205F\u3000]/g // eslint-disable-line no-control-regex
    );
    var DOCTYPE_NAME = seal(/^html$/i);
    var CUSTOM_ELEMENT = seal(/^[a-z][.\w]*(-[.\w]+)+$/i);
    var getGlobal = function getGlobal() {
        return typeof window === 'undefined' ? null : window;
    };
    /**
   * Creates a no-op policy for internal use only.
   * Don't export this function outside this module!
   * @param {?TrustedTypePolicyFactory} trustedTypes The policy factory.
   * @param {Document} document The document object (to determine policy name suffix)
   * @return {?TrustedTypePolicy} The policy created (or null, if Trusted Types
   * are not supported).
   */ var _createTrustedTypesPolicy = function _createTrustedTypesPolicy(trustedTypes, document) {
        if (_typeof(trustedTypes) !== 'object' || typeof trustedTypes.createPolicy !== 'function') return null;
        // Allow the callers to control the unique policy name
        // by adding a data-tt-policy-suffix to the script element with the DOMPurify.
        // Policy creation with duplicate names throws in Trusted Types.
        var suffix = null;
        var ATTR_NAME = 'data-tt-policy-suffix';
        if (document.currentScript && document.currentScript.hasAttribute(ATTR_NAME)) suffix = document.currentScript.getAttribute(ATTR_NAME);
        var policyName = 'dompurify' + (suffix ? '#' + suffix : '');
        try {
            return trustedTypes.createPolicy(policyName, {
                createHTML: function createHTML(html) {
                    return html;
                },
                createScriptURL: function createScriptURL(scriptUrl) {
                    return scriptUrl;
                }
            });
        } catch (_) {
            // Policy creation failed (most likely another DOMPurify script has
            // already run). Skip creating the policy, as this will only cause errors
            // if TT are enforced.
            console.warn('TrustedTypes policy ' + policyName + ' could not be created.');
            return null;
        }
    };
    function createDOMPurify() {
        var window1 = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : getGlobal();
        var DOMPurify = function DOMPurify(root) {
            return createDOMPurify(root);
        };
        /**
     * Version label, exposed for easier checks
     * if DOMPurify is up to date or not
     */ DOMPurify.version = '2.5.8';
        /**
     * Array of elements that DOMPurify removed during sanitation.
     * Empty if nothing was removed.
     */ DOMPurify.removed = [];
        if (!window1 || !window1.document || window1.document.nodeType !== 9) {
            // Not running in a browser, provide a factory function
            // so that you can pass your own Window
            DOMPurify.isSupported = false;
            return DOMPurify;
        }
        var originalDocument = window1.document;
        var document = window1.document;
        var DocumentFragment = window1.DocumentFragment, HTMLTemplateElement = window1.HTMLTemplateElement, Node = window1.Node, Element = window1.Element, NodeFilter = window1.NodeFilter, _window$NamedNodeMap = window1.NamedNodeMap, NamedNodeMap = _window$NamedNodeMap === void 0 ? window1.NamedNodeMap || window1.MozNamedAttrMap : _window$NamedNodeMap, HTMLFormElement = window1.HTMLFormElement, DOMParser = window1.DOMParser, trustedTypes = window1.trustedTypes;
        var ElementPrototype = Element.prototype;
        var cloneNode = lookupGetter(ElementPrototype, 'cloneNode');
        var getNextSibling = lookupGetter(ElementPrototype, 'nextSibling');
        var getChildNodes = lookupGetter(ElementPrototype, 'childNodes');
        var getParentNode = lookupGetter(ElementPrototype, 'parentNode');
        // As per issue #47, the web-components registry is inherited by a
        // new document created via createHTMLDocument. As per the spec
        // (http://w3c.github.io/webcomponents/spec/custom/#creating-and-passing-registries)
        // a new empty registry is used when creating a template contents owner
        // document, so we use that as our parent document to ensure nothing
        // is inherited.
        if (typeof HTMLTemplateElement === 'function') {
            var template = document.createElement('template');
            if (template.content && template.content.ownerDocument) document = template.content.ownerDocument;
        }
        var trustedTypesPolicy = _createTrustedTypesPolicy(trustedTypes, originalDocument);
        var emptyHTML = trustedTypesPolicy ? trustedTypesPolicy.createHTML('') : '';
        var _document = document, implementation = _document.implementation, createNodeIterator = _document.createNodeIterator, createDocumentFragment = _document.createDocumentFragment, getElementsByTagName = _document.getElementsByTagName;
        var importNode = originalDocument.importNode;
        var documentMode = {};
        try {
            documentMode = clone(document).documentMode ? document.documentMode : {};
        } catch (_) {}
        var hooks = {};
        /**
     * Expose whether this browser supports running the full DOMPurify.
     */ DOMPurify.isSupported = typeof getParentNode === 'function' && implementation && implementation.createHTMLDocument !== undefined && documentMode !== 9;
        var MUSTACHE_EXPR$1 = MUSTACHE_EXPR, ERB_EXPR$1 = ERB_EXPR, TMPLIT_EXPR$1 = TMPLIT_EXPR, DATA_ATTR$1 = DATA_ATTR, ARIA_ATTR$1 = ARIA_ATTR, IS_SCRIPT_OR_DATA$1 = IS_SCRIPT_OR_DATA, ATTR_WHITESPACE$1 = ATTR_WHITESPACE, CUSTOM_ELEMENT$1 = CUSTOM_ELEMENT;
        var IS_ALLOWED_URI$1 = IS_ALLOWED_URI;
        /**
     * We consider the elements and attributes below to be safe. Ideally
     * don't add any new ones but feel free to remove unwanted ones.
     */ /* allowed element names */ var ALLOWED_TAGS = null;
        var DEFAULT_ALLOWED_TAGS = addToSet({}, [].concat(_toConsumableArray(html$1), _toConsumableArray(svg$1), _toConsumableArray(svgFilters), _toConsumableArray(mathMl$1), _toConsumableArray(text)));
        /* Allowed attribute names */ var ALLOWED_ATTR = null;
        var DEFAULT_ALLOWED_ATTR = addToSet({}, [].concat(_toConsumableArray(html), _toConsumableArray(svg), _toConsumableArray(mathMl), _toConsumableArray(xml)));
        /*
     * Configure how DOMPUrify should handle custom elements and their attributes as well as customized built-in elements.
     * @property {RegExp|Function|null} tagNameCheck one of [null, regexPattern, predicate]. Default: `null` (disallow any custom elements)
     * @property {RegExp|Function|null} attributeNameCheck one of [null, regexPattern, predicate]. Default: `null` (disallow any attributes not on the allow list)
     * @property {boolean} allowCustomizedBuiltInElements allow custom elements derived from built-ins if they pass CUSTOM_ELEMENT_HANDLING.tagNameCheck. Default: `false`.
     */ var CUSTOM_ELEMENT_HANDLING = Object.seal(Object.create(null, {
            tagNameCheck: {
                writable: true,
                configurable: false,
                enumerable: true,
                value: null
            },
            attributeNameCheck: {
                writable: true,
                configurable: false,
                enumerable: true,
                value: null
            },
            allowCustomizedBuiltInElements: {
                writable: true,
                configurable: false,
                enumerable: true,
                value: false
            }
        }));
        /* Explicitly forbidden tags (overrides ALLOWED_TAGS/ADD_TAGS) */ var FORBID_TAGS = null;
        /* Explicitly forbidden attributes (overrides ALLOWED_ATTR/ADD_ATTR) */ var FORBID_ATTR = null;
        /* Decide if ARIA attributes are okay */ var ALLOW_ARIA_ATTR = true;
        /* Decide if custom data attributes are okay */ var ALLOW_DATA_ATTR = true;
        /* Decide if unknown protocols are okay */ var ALLOW_UNKNOWN_PROTOCOLS = false;
        /* Decide if self-closing tags in attributes are allowed.
     * Usually removed due to a mXSS issue in jQuery 3.0 */ var ALLOW_SELF_CLOSE_IN_ATTR = true;
        /* Output should be safe for common template engines.
     * This means, DOMPurify removes data attributes, mustaches and ERB
     */ var SAFE_FOR_TEMPLATES = false;
        /* Output should be safe even for XML used within HTML and alike.
     * This means, DOMPurify removes comments when containing risky content.
     */ var SAFE_FOR_XML = true;
        /* Decide if document with <html>... should be returned */ var WHOLE_DOCUMENT = false;
        /* Track whether config is already set on this instance of DOMPurify. */ var SET_CONFIG = false;
        /* Decide if all elements (e.g. style, script) must be children of
     * document.body. By default, browsers might move them to document.head */ var FORCE_BODY = false;
        /* Decide if a DOM `HTMLBodyElement` should be returned, instead of a html
     * string (or a TrustedHTML object if Trusted Types are supported).
     * If `WHOLE_DOCUMENT` is enabled a `HTMLHtmlElement` will be returned instead
     */ var RETURN_DOM = false;
        /* Decide if a DOM `DocumentFragment` should be returned, instead of a html
     * string  (or a TrustedHTML object if Trusted Types are supported) */ var RETURN_DOM_FRAGMENT = false;
        /* Try to return a Trusted Type object instead of a string, return a string in
     * case Trusted Types are not supported  */ var RETURN_TRUSTED_TYPE = false;
        /* Output should be free from DOM clobbering attacks?
     * This sanitizes markups named with colliding, clobberable built-in DOM APIs.
     */ var SANITIZE_DOM = true;
        /* Achieve full DOM Clobbering protection by isolating the namespace of named
     * properties and JS variables, mitigating attacks that abuse the HTML/DOM spec rules.
     *
     * HTML/DOM spec rules that enable DOM Clobbering:
     *   - Named Access on Window (§7.3.3)
     *   - DOM Tree Accessors (§3.1.5)
     *   - Form Element Parent-Child Relations (§4.10.3)
     *   - Iframe srcdoc / Nested WindowProxies (§4.8.5)
     *   - HTMLCollection (§4.2.10.2)
     *
     * Namespace isolation is implemented by prefixing `id` and `name` attributes
     * with a constant string, i.e., `user-content-`
     */ var SANITIZE_NAMED_PROPS = false;
        var SANITIZE_NAMED_PROPS_PREFIX = 'user-content-';
        /* Keep element content when removing element? */ var KEEP_CONTENT = true;
        /* If a `Node` is passed to sanitize(), then performs sanitization in-place instead
     * of importing it into a new Document and returning a sanitized copy */ var IN_PLACE = false;
        /* Allow usage of profiles like html, svg and mathMl */ var USE_PROFILES = {};
        /* Tags to ignore content of when KEEP_CONTENT is true */ var FORBID_CONTENTS = null;
        var DEFAULT_FORBID_CONTENTS = addToSet({}, [
            'annotation-xml',
            'audio',
            'colgroup',
            'desc',
            'foreignobject',
            'head',
            'iframe',
            'math',
            'mi',
            'mn',
            'mo',
            'ms',
            'mtext',
            'noembed',
            'noframes',
            'noscript',
            'plaintext',
            'script',
            'style',
            'svg',
            'template',
            'thead',
            'title',
            'video',
            'xmp'
        ]);
        /* Tags that are safe for data: URIs */ var DATA_URI_TAGS = null;
        var DEFAULT_DATA_URI_TAGS = addToSet({}, [
            'audio',
            'video',
            'img',
            'source',
            'image',
            'track'
        ]);
        /* Attributes safe for values like "javascript:" */ var URI_SAFE_ATTRIBUTES = null;
        var DEFAULT_URI_SAFE_ATTRIBUTES = addToSet({}, [
            'alt',
            'class',
            'for',
            'id',
            'label',
            'name',
            'pattern',
            'placeholder',
            'role',
            'summary',
            'title',
            'value',
            'style',
            'xmlns'
        ]);
        var MATHML_NAMESPACE = 'http://www.w3.org/1998/Math/MathML';
        var SVG_NAMESPACE = 'http://www.w3.org/2000/svg';
        var HTML_NAMESPACE = 'http://www.w3.org/1999/xhtml';
        /* Document namespace */ var NAMESPACE = HTML_NAMESPACE;
        var IS_EMPTY_INPUT = false;
        /* Allowed XHTML+XML namespaces */ var ALLOWED_NAMESPACES = null;
        var DEFAULT_ALLOWED_NAMESPACES = addToSet({}, [
            MATHML_NAMESPACE,
            SVG_NAMESPACE,
            HTML_NAMESPACE
        ], stringToString);
        /* Parsing of strict XHTML documents */ var PARSER_MEDIA_TYPE;
        var SUPPORTED_PARSER_MEDIA_TYPES = [
            'application/xhtml+xml',
            'text/html'
        ];
        var DEFAULT_PARSER_MEDIA_TYPE = 'text/html';
        var transformCaseFunc;
        /* Keep a reference to config to pass to hooks */ var CONFIG = null;
        /* Ideally, do not touch anything below this line */ /* ______________________________________________ */ var formElement = document.createElement('form');
        var isRegexOrFunction = function isRegexOrFunction(testValue) {
            return testValue instanceof RegExp || testValue instanceof Function;
        };
        /**
     * _parseConfig
     *
     * @param  {Object} cfg optional config literal
     */ // eslint-disable-next-line complexity
        var _parseConfig = function _parseConfig(cfg) {
            if (CONFIG && CONFIG === cfg) return;
            /* Shield configuration object from tampering */ if (!cfg || _typeof(cfg) !== 'object') cfg = {};
            /* Shield configuration object from prototype pollution */ cfg = clone(cfg);
            PARSER_MEDIA_TYPE = // eslint-disable-next-line unicorn/prefer-includes
            SUPPORTED_PARSER_MEDIA_TYPES.indexOf(cfg.PARSER_MEDIA_TYPE) === -1 ? PARSER_MEDIA_TYPE = DEFAULT_PARSER_MEDIA_TYPE : PARSER_MEDIA_TYPE = cfg.PARSER_MEDIA_TYPE;
            // HTML tags and attributes are not case-sensitive, converting to lowercase. Keeping XHTML as is.
            transformCaseFunc = PARSER_MEDIA_TYPE === 'application/xhtml+xml' ? stringToString : stringToLowerCase;
            /* Set configuration parameters */ ALLOWED_TAGS = 'ALLOWED_TAGS' in cfg ? addToSet({}, cfg.ALLOWED_TAGS, transformCaseFunc) : DEFAULT_ALLOWED_TAGS;
            ALLOWED_ATTR = 'ALLOWED_ATTR' in cfg ? addToSet({}, cfg.ALLOWED_ATTR, transformCaseFunc) : DEFAULT_ALLOWED_ATTR;
            ALLOWED_NAMESPACES = 'ALLOWED_NAMESPACES' in cfg ? addToSet({}, cfg.ALLOWED_NAMESPACES, stringToString) : DEFAULT_ALLOWED_NAMESPACES;
            URI_SAFE_ATTRIBUTES = 'ADD_URI_SAFE_ATTR' in cfg ? addToSet(clone(DEFAULT_URI_SAFE_ATTRIBUTES), // eslint-disable-line indent
            cfg.ADD_URI_SAFE_ATTR, // eslint-disable-line indent
            transformCaseFunc // eslint-disable-line indent
            ) // eslint-disable-line indent
             : DEFAULT_URI_SAFE_ATTRIBUTES;
            DATA_URI_TAGS = 'ADD_DATA_URI_TAGS' in cfg ? addToSet(clone(DEFAULT_DATA_URI_TAGS), // eslint-disable-line indent
            cfg.ADD_DATA_URI_TAGS, // eslint-disable-line indent
            transformCaseFunc // eslint-disable-line indent
            ) // eslint-disable-line indent
             : DEFAULT_DATA_URI_TAGS;
            FORBID_CONTENTS = 'FORBID_CONTENTS' in cfg ? addToSet({}, cfg.FORBID_CONTENTS, transformCaseFunc) : DEFAULT_FORBID_CONTENTS;
            FORBID_TAGS = 'FORBID_TAGS' in cfg ? addToSet({}, cfg.FORBID_TAGS, transformCaseFunc) : {};
            FORBID_ATTR = 'FORBID_ATTR' in cfg ? addToSet({}, cfg.FORBID_ATTR, transformCaseFunc) : {};
            USE_PROFILES = 'USE_PROFILES' in cfg ? cfg.USE_PROFILES : false;
            ALLOW_ARIA_ATTR = cfg.ALLOW_ARIA_ATTR !== false; // Default true
            ALLOW_DATA_ATTR = cfg.ALLOW_DATA_ATTR !== false; // Default true
            ALLOW_UNKNOWN_PROTOCOLS = cfg.ALLOW_UNKNOWN_PROTOCOLS || false; // Default false
            ALLOW_SELF_CLOSE_IN_ATTR = cfg.ALLOW_SELF_CLOSE_IN_ATTR !== false; // Default true
            SAFE_FOR_TEMPLATES = cfg.SAFE_FOR_TEMPLATES || false; // Default false
            SAFE_FOR_XML = cfg.SAFE_FOR_XML !== false; // Default true
            WHOLE_DOCUMENT = cfg.WHOLE_DOCUMENT || false; // Default false
            RETURN_DOM = cfg.RETURN_DOM || false; // Default false
            RETURN_DOM_FRAGMENT = cfg.RETURN_DOM_FRAGMENT || false; // Default false
            RETURN_TRUSTED_TYPE = cfg.RETURN_TRUSTED_TYPE || false; // Default false
            FORCE_BODY = cfg.FORCE_BODY || false; // Default false
            SANITIZE_DOM = cfg.SANITIZE_DOM !== false; // Default true
            SANITIZE_NAMED_PROPS = cfg.SANITIZE_NAMED_PROPS || false; // Default false
            KEEP_CONTENT = cfg.KEEP_CONTENT !== false; // Default true
            IN_PLACE = cfg.IN_PLACE || false; // Default false
            IS_ALLOWED_URI$1 = cfg.ALLOWED_URI_REGEXP || IS_ALLOWED_URI$1;
            NAMESPACE = cfg.NAMESPACE || HTML_NAMESPACE;
            CUSTOM_ELEMENT_HANDLING = cfg.CUSTOM_ELEMENT_HANDLING || {};
            if (cfg.CUSTOM_ELEMENT_HANDLING && isRegexOrFunction(cfg.CUSTOM_ELEMENT_HANDLING.tagNameCheck)) CUSTOM_ELEMENT_HANDLING.tagNameCheck = cfg.CUSTOM_ELEMENT_HANDLING.tagNameCheck;
            if (cfg.CUSTOM_ELEMENT_HANDLING && isRegexOrFunction(cfg.CUSTOM_ELEMENT_HANDLING.attributeNameCheck)) CUSTOM_ELEMENT_HANDLING.attributeNameCheck = cfg.CUSTOM_ELEMENT_HANDLING.attributeNameCheck;
            if (cfg.CUSTOM_ELEMENT_HANDLING && typeof cfg.CUSTOM_ELEMENT_HANDLING.allowCustomizedBuiltInElements === 'boolean') CUSTOM_ELEMENT_HANDLING.allowCustomizedBuiltInElements = cfg.CUSTOM_ELEMENT_HANDLING.allowCustomizedBuiltInElements;
            if (SAFE_FOR_TEMPLATES) ALLOW_DATA_ATTR = false;
            if (RETURN_DOM_FRAGMENT) RETURN_DOM = true;
            /* Parse profile info */ if (USE_PROFILES) {
                ALLOWED_TAGS = addToSet({}, _toConsumableArray(text));
                ALLOWED_ATTR = [];
                if (USE_PROFILES.html === true) {
                    addToSet(ALLOWED_TAGS, html$1);
                    addToSet(ALLOWED_ATTR, html);
                }
                if (USE_PROFILES.svg === true) {
                    addToSet(ALLOWED_TAGS, svg$1);
                    addToSet(ALLOWED_ATTR, svg);
                    addToSet(ALLOWED_ATTR, xml);
                }
                if (USE_PROFILES.svgFilters === true) {
                    addToSet(ALLOWED_TAGS, svgFilters);
                    addToSet(ALLOWED_ATTR, svg);
                    addToSet(ALLOWED_ATTR, xml);
                }
                if (USE_PROFILES.mathMl === true) {
                    addToSet(ALLOWED_TAGS, mathMl$1);
                    addToSet(ALLOWED_ATTR, mathMl);
                    addToSet(ALLOWED_ATTR, xml);
                }
            }
            /* Merge configuration parameters */ if (cfg.ADD_TAGS) {
                if (ALLOWED_TAGS === DEFAULT_ALLOWED_TAGS) ALLOWED_TAGS = clone(ALLOWED_TAGS);
                addToSet(ALLOWED_TAGS, cfg.ADD_TAGS, transformCaseFunc);
            }
            if (cfg.ADD_ATTR) {
                if (ALLOWED_ATTR === DEFAULT_ALLOWED_ATTR) ALLOWED_ATTR = clone(ALLOWED_ATTR);
                addToSet(ALLOWED_ATTR, cfg.ADD_ATTR, transformCaseFunc);
            }
            if (cfg.ADD_URI_SAFE_ATTR) addToSet(URI_SAFE_ATTRIBUTES, cfg.ADD_URI_SAFE_ATTR, transformCaseFunc);
            if (cfg.FORBID_CONTENTS) {
                if (FORBID_CONTENTS === DEFAULT_FORBID_CONTENTS) FORBID_CONTENTS = clone(FORBID_CONTENTS);
                addToSet(FORBID_CONTENTS, cfg.FORBID_CONTENTS, transformCaseFunc);
            }
            /* Add #text in case KEEP_CONTENT is set to true */ if (KEEP_CONTENT) ALLOWED_TAGS['#text'] = true;
            /* Add html, head and body to ALLOWED_TAGS in case WHOLE_DOCUMENT is true */ if (WHOLE_DOCUMENT) addToSet(ALLOWED_TAGS, [
                'html',
                'head',
                'body'
            ]);
            /* Add tbody to ALLOWED_TAGS in case tables are permitted, see #286, #365 */ if (ALLOWED_TAGS.table) {
                addToSet(ALLOWED_TAGS, [
                    'tbody'
                ]);
                delete FORBID_TAGS.tbody;
            }
            // Prevent further manipulation of configuration.
            // Not available in IE8, Safari 5, etc.
            if (freeze) freeze(cfg);
            CONFIG = cfg;
        };
        var MATHML_TEXT_INTEGRATION_POINTS = addToSet({}, [
            'mi',
            'mo',
            'mn',
            'ms',
            'mtext'
        ]);
        var HTML_INTEGRATION_POINTS = addToSet({}, [
            'annotation-xml'
        ]);
        // Certain elements are allowed in both SVG and HTML
        // namespace. We need to specify them explicitly
        // so that they don't get erroneously deleted from
        // HTML namespace.
        var COMMON_SVG_AND_HTML_ELEMENTS = addToSet({}, [
            'title',
            'style',
            'font',
            'a',
            'script'
        ]);
        /* Keep track of all possible SVG and MathML tags
     * so that we can perform the namespace checks
     * correctly. */ var ALL_SVG_TAGS = addToSet({}, svg$1);
        addToSet(ALL_SVG_TAGS, svgFilters);
        addToSet(ALL_SVG_TAGS, svgDisallowed);
        var ALL_MATHML_TAGS = addToSet({}, mathMl$1);
        addToSet(ALL_MATHML_TAGS, mathMlDisallowed);
        /**
     *
     *
     * @param  {Element} element a DOM element whose namespace is being checked
     * @returns {boolean} Return false if the element has a
     *  namespace that a spec-compliant parser would never
     *  return. Return true otherwise.
     */ var _checkValidNamespace = function _checkValidNamespace(element) {
            var parent = getParentNode(element);
            // In JSDOM, if we're inside shadow DOM, then parentNode
            // can be null. We just simulate parent in this case.
            if (!parent || !parent.tagName) parent = {
                namespaceURI: NAMESPACE,
                tagName: 'template'
            };
            var tagName = stringToLowerCase(element.tagName);
            var parentTagName = stringToLowerCase(parent.tagName);
            if (!ALLOWED_NAMESPACES[element.namespaceURI]) return false;
            if (element.namespaceURI === SVG_NAMESPACE) {
                // The only way to switch from HTML namespace to SVG
                // is via <svg>. If it happens via any other tag, then
                // it should be killed.
                if (parent.namespaceURI === HTML_NAMESPACE) return tagName === 'svg';
                // The only way to switch from MathML to SVG is via`
                // svg if parent is either <annotation-xml> or MathML
                // text integration points.
                if (parent.namespaceURI === MATHML_NAMESPACE) return tagName === 'svg' && (parentTagName === 'annotation-xml' || MATHML_TEXT_INTEGRATION_POINTS[parentTagName]);
                // We only allow elements that are defined in SVG
                // spec. All others are disallowed in SVG namespace.
                return Boolean(ALL_SVG_TAGS[tagName]);
            }
            if (element.namespaceURI === MATHML_NAMESPACE) {
                // The only way to switch from HTML namespace to MathML
                // is via <math>. If it happens via any other tag, then
                // it should be killed.
                if (parent.namespaceURI === HTML_NAMESPACE) return tagName === 'math';
                // The only way to switch from SVG to MathML is via
                // <math> and HTML integration points
                if (parent.namespaceURI === SVG_NAMESPACE) return tagName === 'math' && HTML_INTEGRATION_POINTS[parentTagName];
                // We only allow elements that are defined in MathML
                // spec. All others are disallowed in MathML namespace.
                return Boolean(ALL_MATHML_TAGS[tagName]);
            }
            if (element.namespaceURI === HTML_NAMESPACE) {
                // The only way to switch from SVG to HTML is via
                // HTML integration points, and from MathML to HTML
                // is via MathML text integration points
                if (parent.namespaceURI === SVG_NAMESPACE && !HTML_INTEGRATION_POINTS[parentTagName]) return false;
                if (parent.namespaceURI === MATHML_NAMESPACE && !MATHML_TEXT_INTEGRATION_POINTS[parentTagName]) return false;
                // We disallow tags that are specific for MathML
                // or SVG and should never appear in HTML namespace
                return !ALL_MATHML_TAGS[tagName] && (COMMON_SVG_AND_HTML_ELEMENTS[tagName] || !ALL_SVG_TAGS[tagName]);
            }
            // For XHTML and XML documents that support custom namespaces
            if (PARSER_MEDIA_TYPE === 'application/xhtml+xml' && ALLOWED_NAMESPACES[element.namespaceURI]) return true;
            // The code should never reach this place (this means
            // that the element somehow got namespace that is not
            // HTML, SVG, MathML or allowed via ALLOWED_NAMESPACES).
            // Return false just in case.
            return false;
        };
        /**
     * _forceRemove
     *
     * @param  {Node} node a DOM node
     */ var _forceRemove = function _forceRemove(node) {
            arrayPush(DOMPurify.removed, {
                element: node
            });
            try {
                // eslint-disable-next-line unicorn/prefer-dom-node-remove
                node.parentNode.removeChild(node);
            } catch (_) {
                try {
                    node.outerHTML = emptyHTML;
                } catch (_) {
                    node.remove();
                }
            }
        };
        /**
     * _removeAttribute
     *
     * @param  {String} name an Attribute name
     * @param  {Node} node a DOM node
     */ var _removeAttribute = function _removeAttribute(name, node) {
            try {
                arrayPush(DOMPurify.removed, {
                    attribute: node.getAttributeNode(name),
                    from: node
                });
            } catch (_) {
                arrayPush(DOMPurify.removed, {
                    attribute: null,
                    from: node
                });
            }
            node.removeAttribute(name);
            // We void attribute values for unremovable "is"" attributes
            if (name === 'is' && !ALLOWED_ATTR[name]) {
                if (RETURN_DOM || RETURN_DOM_FRAGMENT) try {
                    _forceRemove(node);
                } catch (_) {}
                else try {
                    node.setAttribute(name, '');
                } catch (_) {}
            }
        };
        /**
     * _initDocument
     *
     * @param  {String} dirty a string of dirty markup
     * @return {Document} a DOM, filled with the dirty markup
     */ var _initDocument = function _initDocument(dirty) {
            /* Create a HTML document */ var doc;
            var leadingWhitespace;
            if (FORCE_BODY) dirty = '<remove></remove>' + dirty;
            else {
                /* If FORCE_BODY isn't used, leading whitespace needs to be preserved manually */ var matches = stringMatch(dirty, /^[\r\n\t ]+/);
                leadingWhitespace = matches && matches[0];
            }
            if (PARSER_MEDIA_TYPE === 'application/xhtml+xml' && NAMESPACE === HTML_NAMESPACE) // Root of XHTML doc must contain xmlns declaration (see https://www.w3.org/TR/xhtml1/normative.html#strict)
            dirty = '<html xmlns="http://www.w3.org/1999/xhtml"><head></head><body>' + dirty + '</body></html>';
            var dirtyPayload = trustedTypesPolicy ? trustedTypesPolicy.createHTML(dirty) : dirty;
            /*
       * Use the DOMParser API by default, fallback later if needs be
       * DOMParser not work for svg when has multiple root element.
       */ if (NAMESPACE === HTML_NAMESPACE) try {
                doc = new DOMParser().parseFromString(dirtyPayload, PARSER_MEDIA_TYPE);
            } catch (_) {}
            /* Use createHTMLDocument in case DOMParser is not available */ if (!doc || !doc.documentElement) {
                doc = implementation.createDocument(NAMESPACE, 'template', null);
                try {
                    doc.documentElement.innerHTML = IS_EMPTY_INPUT ? emptyHTML : dirtyPayload;
                } catch (_) {
                // Syntax error if dirtyPayload is invalid xml
                }
            }
            var body = doc.body || doc.documentElement;
            if (dirty && leadingWhitespace) body.insertBefore(document.createTextNode(leadingWhitespace), body.childNodes[0] || null);
            /* Work on whole document or just its body */ if (NAMESPACE === HTML_NAMESPACE) return getElementsByTagName.call(doc, WHOLE_DOCUMENT ? 'html' : 'body')[0];
            return WHOLE_DOCUMENT ? doc.documentElement : body;
        };
        /**
     * _createIterator
     *
     * @param  {Document} root document/fragment to create iterator for
     * @return {Iterator} iterator instance
     */ var _createIterator = function _createIterator(root) {
            return createNodeIterator.call(root.ownerDocument || root, root, // eslint-disable-next-line no-bitwise
            NodeFilter.SHOW_ELEMENT | NodeFilter.SHOW_COMMENT | NodeFilter.SHOW_TEXT | NodeFilter.SHOW_PROCESSING_INSTRUCTION | NodeFilter.SHOW_CDATA_SECTION, null, false);
        };
        /**
     * _isClobbered
     *
     * @param  {Node} elm element to check for clobbering attacks
     * @return {Boolean} true if clobbered, false if safe
     */ var _isClobbered = function _isClobbered(elm) {
            return elm instanceof HTMLFormElement && (typeof elm.nodeName !== 'string' || typeof elm.textContent !== 'string' || typeof elm.removeChild !== 'function' || !(elm.attributes instanceof NamedNodeMap) || typeof elm.removeAttribute !== 'function' || typeof elm.setAttribute !== 'function' || typeof elm.namespaceURI !== 'string' || typeof elm.insertBefore !== 'function' || typeof elm.hasChildNodes !== 'function');
        };
        /**
     * _isNode
     *
     * @param  {Node} obj object to check whether it's a DOM node
     * @return {Boolean} true is object is a DOM node
     */ var _isNode = function _isNode(object) {
            return _typeof(Node) === 'object' ? object instanceof Node : object && _typeof(object) === 'object' && typeof object.nodeType === 'number' && typeof object.nodeName === 'string';
        };
        /**
     * _executeHook
     * Execute user configurable hooks
     *
     * @param  {String} entryPoint  Name of the hook's entry point
     * @param  {Node} currentNode node to work on with the hook
     * @param  {Object} data additional hook parameters
     */ var _executeHook = function _executeHook(entryPoint, currentNode, data) {
            if (!hooks[entryPoint]) return;
            arrayForEach(hooks[entryPoint], function(hook) {
                hook.call(DOMPurify, currentNode, data, CONFIG);
            });
        };
        /**
     * _sanitizeElements
     *
     * @protect nodeName
     * @protect textContent
     * @protect removeChild
     *
     * @param   {Node} currentNode to check for permission to exist
     * @return  {Boolean} true if node was killed, false if left alive
     */ var _sanitizeElements = function _sanitizeElements(currentNode) {
            var content;
            /* Execute a hook if present */ _executeHook('beforeSanitizeElements', currentNode, null);
            /* Check if element is clobbered or can clobber */ if (_isClobbered(currentNode)) {
                _forceRemove(currentNode);
                return true;
            }
            /* Check if tagname contains Unicode */ if (regExpTest(/[\u0080-\uFFFF]/, currentNode.nodeName)) {
                _forceRemove(currentNode);
                return true;
            }
            /* Now let's check the element's type and name */ var tagName = transformCaseFunc(currentNode.nodeName);
            /* Execute a hook if present */ _executeHook('uponSanitizeElement', currentNode, {
                tagName: tagName,
                allowedTags: ALLOWED_TAGS
            });
            /* Detect mXSS attempts abusing namespace confusion */ if (currentNode.hasChildNodes() && !_isNode(currentNode.firstElementChild) && (!_isNode(currentNode.content) || !_isNode(currentNode.content.firstElementChild)) && regExpTest(/<[/\w]/g, currentNode.innerHTML) && regExpTest(/<[/\w]/g, currentNode.textContent)) {
                _forceRemove(currentNode);
                return true;
            }
            /* Mitigate a problem with templates inside select */ if (tagName === 'select' && regExpTest(/<template/i, currentNode.innerHTML)) {
                _forceRemove(currentNode);
                return true;
            }
            /* Remove any ocurrence of processing instructions */ if (currentNode.nodeType === 7) {
                _forceRemove(currentNode);
                return true;
            }
            /* Remove any kind of possibly harmful comments */ if (SAFE_FOR_XML && currentNode.nodeType === 8 && regExpTest(/<[/\w]/g, currentNode.data)) {
                _forceRemove(currentNode);
                return true;
            }
            /* Remove element if anything forbids its presence */ if (!ALLOWED_TAGS[tagName] || FORBID_TAGS[tagName]) {
                /* Check if we have a custom element to handle */ if (!FORBID_TAGS[tagName] && _basicCustomElementTest(tagName)) {
                    if (CUSTOM_ELEMENT_HANDLING.tagNameCheck instanceof RegExp && regExpTest(CUSTOM_ELEMENT_HANDLING.tagNameCheck, tagName)) return false;
                    if (CUSTOM_ELEMENT_HANDLING.tagNameCheck instanceof Function && CUSTOM_ELEMENT_HANDLING.tagNameCheck(tagName)) return false;
                }
                /* Keep content except for bad-listed elements */ if (KEEP_CONTENT && !FORBID_CONTENTS[tagName]) {
                    var parentNode = getParentNode(currentNode) || currentNode.parentNode;
                    var childNodes = getChildNodes(currentNode) || currentNode.childNodes;
                    if (childNodes && parentNode) {
                        var childCount = childNodes.length;
                        for(var i = childCount - 1; i >= 0; --i){
                            var childClone = cloneNode(childNodes[i], true);
                            childClone.__removalCount = (currentNode.__removalCount || 0) + 1;
                            parentNode.insertBefore(childClone, getNextSibling(currentNode));
                        }
                    }
                }
                _forceRemove(currentNode);
                return true;
            }
            /* Check whether element has a valid namespace */ if (currentNode instanceof Element && !_checkValidNamespace(currentNode)) {
                _forceRemove(currentNode);
                return true;
            }
            /* Make sure that older browsers don't get fallback-tag mXSS */ if ((tagName === 'noscript' || tagName === 'noembed' || tagName === 'noframes') && regExpTest(/<\/no(script|embed|frames)/i, currentNode.innerHTML)) {
                _forceRemove(currentNode);
                return true;
            }
            /* Sanitize element content to be template-safe */ if (SAFE_FOR_TEMPLATES && currentNode.nodeType === 3) {
                /* Get the element's text content */ content = currentNode.textContent;
                content = stringReplace(content, MUSTACHE_EXPR$1, ' ');
                content = stringReplace(content, ERB_EXPR$1, ' ');
                content = stringReplace(content, TMPLIT_EXPR$1, ' ');
                if (currentNode.textContent !== content) {
                    arrayPush(DOMPurify.removed, {
                        element: currentNode.cloneNode()
                    });
                    currentNode.textContent = content;
                }
            }
            /* Execute a hook if present */ _executeHook('afterSanitizeElements', currentNode, null);
            return false;
        };
        /**
     * _isValidAttribute
     *
     * @param  {string} lcTag Lowercase tag name of containing element.
     * @param  {string} lcName Lowercase attribute name.
     * @param  {string} value Attribute value.
     * @return {Boolean} Returns true if `value` is valid, otherwise false.
     */ // eslint-disable-next-line complexity
        var _isValidAttribute = function _isValidAttribute(lcTag, lcName, value) {
            /* Make sure attribute cannot clobber */ if (SANITIZE_DOM && (lcName === 'id' || lcName === 'name') && (value in document || value in formElement)) return false;
            /* Allow valid data-* attributes: At least one character after "-"
          (https://html.spec.whatwg.org/multipage/dom.html#embedding-custom-non-visible-data-with-the-data-*-attributes)
          XML-compatible (https://html.spec.whatwg.org/multipage/infrastructure.html#xml-compatible and http://www.w3.org/TR/xml/#d0e804)
          We don't need to check the value; it's always URI safe. */ if (ALLOW_DATA_ATTR && !FORBID_ATTR[lcName] && regExpTest(DATA_ATTR$1, lcName)) ;
            else if (ALLOW_ARIA_ATTR && regExpTest(ARIA_ATTR$1, lcName)) ;
            else if (!ALLOWED_ATTR[lcName] || FORBID_ATTR[lcName]) {
                if (// First condition does a very basic check if a) it's basically a valid custom element tagname AND
                // b) if the tagName passes whatever the user has configured for CUSTOM_ELEMENT_HANDLING.tagNameCheck
                // and c) if the attribute name passes whatever the user has configured for CUSTOM_ELEMENT_HANDLING.attributeNameCheck
                _basicCustomElementTest(lcTag) && (CUSTOM_ELEMENT_HANDLING.tagNameCheck instanceof RegExp && regExpTest(CUSTOM_ELEMENT_HANDLING.tagNameCheck, lcTag) || CUSTOM_ELEMENT_HANDLING.tagNameCheck instanceof Function && CUSTOM_ELEMENT_HANDLING.tagNameCheck(lcTag)) && (CUSTOM_ELEMENT_HANDLING.attributeNameCheck instanceof RegExp && regExpTest(CUSTOM_ELEMENT_HANDLING.attributeNameCheck, lcName) || CUSTOM_ELEMENT_HANDLING.attributeNameCheck instanceof Function && CUSTOM_ELEMENT_HANDLING.attributeNameCheck(lcName)) || // Alternative, second condition checks if it's an `is`-attribute, AND
                // the value passes whatever the user has configured for CUSTOM_ELEMENT_HANDLING.tagNameCheck
                lcName === 'is' && CUSTOM_ELEMENT_HANDLING.allowCustomizedBuiltInElements && (CUSTOM_ELEMENT_HANDLING.tagNameCheck instanceof RegExp && regExpTest(CUSTOM_ELEMENT_HANDLING.tagNameCheck, value) || CUSTOM_ELEMENT_HANDLING.tagNameCheck instanceof Function && CUSTOM_ELEMENT_HANDLING.tagNameCheck(value))) ;
                else return false;
            /* Check value is safe. First, is attr inert? If so, is safe */ } else if (URI_SAFE_ATTRIBUTES[lcName]) ;
            else if (regExpTest(IS_ALLOWED_URI$1, stringReplace(value, ATTR_WHITESPACE$1, ''))) ;
            else if ((lcName === 'src' || lcName === 'xlink:href' || lcName === 'href') && lcTag !== 'script' && stringIndexOf(value, 'data:') === 0 && DATA_URI_TAGS[lcTag]) ;
            else if (ALLOW_UNKNOWN_PROTOCOLS && !regExpTest(IS_SCRIPT_OR_DATA$1, stringReplace(value, ATTR_WHITESPACE$1, ''))) ;
            else if (value) return false;
            return true;
        };
        /**
     * _basicCustomElementCheck
     * checks if at least one dash is included in tagName, and it's not the first char
     * for more sophisticated checking see https://github.com/sindresorhus/validate-element-name
     * @param {string} tagName name of the tag of the node to sanitize
     */ var _basicCustomElementTest = function _basicCustomElementTest(tagName) {
            return tagName !== 'annotation-xml' && stringMatch(tagName, CUSTOM_ELEMENT$1);
        };
        /**
     * _sanitizeAttributes
     *
     * @protect attributes
     * @protect nodeName
     * @protect removeAttribute
     * @protect setAttribute
     *
     * @param  {Node} currentNode to sanitize
     */ var _sanitizeAttributes = function _sanitizeAttributes(currentNode) {
            var attr;
            var value;
            var lcName;
            var l;
            /* Execute a hook if present */ _executeHook('beforeSanitizeAttributes', currentNode, null);
            var attributes = currentNode.attributes;
            /* Check if we have attributes; if not we might have a text node */ if (!attributes || _isClobbered(currentNode)) return;
            var hookEvent = {
                attrName: '',
                attrValue: '',
                keepAttr: true,
                allowedAttributes: ALLOWED_ATTR
            };
            l = attributes.length;
            /* Go backwards over all attributes; safely remove bad ones */ while(l--){
                attr = attributes[l];
                var _attr = attr, name = _attr.name, namespaceURI = _attr.namespaceURI;
                value = name === 'value' ? attr.value : stringTrim(attr.value);
                lcName = transformCaseFunc(name);
                /* Execute a hook if present */ hookEvent.attrName = lcName;
                hookEvent.attrValue = value;
                hookEvent.keepAttr = true;
                hookEvent.forceKeepAttr = undefined; // Allows developers to see this is a property they can set
                _executeHook('uponSanitizeAttribute', currentNode, hookEvent);
                value = hookEvent.attrValue;
                /* Did the hooks approve of the attribute? */ if (hookEvent.forceKeepAttr) continue;
                /* Remove attribute */ _removeAttribute(name, currentNode);
                /* Did the hooks approve of the attribute? */ if (!hookEvent.keepAttr) continue;
                /* Work around a security issue in jQuery 3.0 */ if (!ALLOW_SELF_CLOSE_IN_ATTR && regExpTest(/\/>/i, value)) {
                    _removeAttribute(name, currentNode);
                    continue;
                }
                /* Sanitize attribute content to be template-safe */ if (SAFE_FOR_TEMPLATES) {
                    value = stringReplace(value, MUSTACHE_EXPR$1, ' ');
                    value = stringReplace(value, ERB_EXPR$1, ' ');
                    value = stringReplace(value, TMPLIT_EXPR$1, ' ');
                }
                /* Is `value` valid for this attribute? */ var lcTag = transformCaseFunc(currentNode.nodeName);
                if (!_isValidAttribute(lcTag, lcName, value)) continue;
                /* Full DOM Clobbering protection via namespace isolation,
         * Prefix id and name attributes with `user-content-`
         */ if (SANITIZE_NAMED_PROPS && (lcName === 'id' || lcName === 'name')) {
                    // Remove the attribute with this value
                    _removeAttribute(name, currentNode);
                    // Prefix the value and later re-create the attribute with the sanitized value
                    value = SANITIZE_NAMED_PROPS_PREFIX + value;
                }
                /* Work around a security issue with comments inside attributes */ if (SAFE_FOR_XML && regExpTest(/((--!?|])>)|<\/(style|title)/i, value)) {
                    _removeAttribute(name, currentNode);
                    continue;
                }
                /* Handle attributes that require Trusted Types */ if (trustedTypesPolicy && _typeof(trustedTypes) === 'object' && typeof trustedTypes.getAttributeType === 'function') {
                    if (namespaceURI) ;
                    else switch(trustedTypes.getAttributeType(lcTag, lcName)){
                        case 'TrustedHTML':
                            value = trustedTypesPolicy.createHTML(value);
                            break;
                        case 'TrustedScriptURL':
                            value = trustedTypesPolicy.createScriptURL(value);
                            break;
                    }
                }
                /* Handle invalid data-* attribute set by try-catching it */ try {
                    if (namespaceURI) currentNode.setAttributeNS(namespaceURI, name, value);
                    else /* Fallback to setAttribute() for browser-unrecognized namespaces e.g. "x-schema". */ currentNode.setAttribute(name, value);
                    if (_isClobbered(currentNode)) _forceRemove(currentNode);
                    else arrayPop(DOMPurify.removed);
                } catch (_) {}
            }
            /* Execute a hook if present */ _executeHook('afterSanitizeAttributes', currentNode, null);
        };
        /**
     * _sanitizeShadowDOM
     *
     * @param  {DocumentFragment} fragment to iterate over recursively
     */ var _sanitizeShadowDOM = function _sanitizeShadowDOM(fragment) {
            var shadowNode;
            var shadowIterator = _createIterator(fragment);
            /* Execute a hook if present */ _executeHook('beforeSanitizeShadowDOM', fragment, null);
            while(shadowNode = shadowIterator.nextNode()){
                /* Execute a hook if present */ _executeHook('uponSanitizeShadowNode', shadowNode, null);
                /* Sanitize tags and elements */ _sanitizeElements(shadowNode);
                /* Check attributes next */ _sanitizeAttributes(shadowNode);
                /* Deep shadow DOM detected */ if (shadowNode.content instanceof DocumentFragment) _sanitizeShadowDOM(shadowNode.content);
            }
            /* Execute a hook if present */ _executeHook('afterSanitizeShadowDOM', fragment, null);
        };
        /**
     * Sanitize
     * Public method providing core sanitation functionality
     *
     * @param {String|Node} dirty string or DOM node
     * @param {Object} configuration object
     */ // eslint-disable-next-line complexity
        DOMPurify.sanitize = function(dirty) {
            var cfg = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
            var body;
            var importedNode;
            var currentNode;
            var oldNode;
            var returnNode;
            /* Make sure we have a string to sanitize.
        DO NOT return early, as this will return the wrong type if
        the user has requested a DOM object rather than a string */ IS_EMPTY_INPUT = !dirty;
            if (IS_EMPTY_INPUT) dirty = '<!-->';
            /* Stringify, in case dirty is an object */ if (typeof dirty !== 'string' && !_isNode(dirty)) {
                if (typeof dirty.toString === 'function') {
                    dirty = dirty.toString();
                    if (typeof dirty !== 'string') throw typeErrorCreate('dirty is not a string, aborting');
                } else throw typeErrorCreate('toString is not a function');
            }
            /* Check we can run. Otherwise fall back or ignore */ if (!DOMPurify.isSupported) {
                if (_typeof(window1.toStaticHTML) === 'object' || typeof window1.toStaticHTML === 'function') {
                    if (typeof dirty === 'string') return window1.toStaticHTML(dirty);
                    if (_isNode(dirty)) return window1.toStaticHTML(dirty.outerHTML);
                }
                return dirty;
            }
            /* Assign config vars */ if (!SET_CONFIG) _parseConfig(cfg);
            /* Clean up removed elements */ DOMPurify.removed = [];
            /* Check if dirty is correctly typed for IN_PLACE */ if (typeof dirty === 'string') IN_PLACE = false;
            if (IN_PLACE) /* Do some early pre-sanitization to avoid unsafe root nodes */ {
                if (dirty.nodeName) {
                    var tagName = transformCaseFunc(dirty.nodeName);
                    if (!ALLOWED_TAGS[tagName] || FORBID_TAGS[tagName]) throw typeErrorCreate('root node is forbidden and cannot be sanitized in-place');
                }
            } else if (dirty instanceof Node) {
                /* If dirty is a DOM element, append to an empty document to avoid
           elements being stripped by the parser */ body = _initDocument('<!---->');
                importedNode = body.ownerDocument.importNode(dirty, true);
                if (importedNode.nodeType === 1 && importedNode.nodeName === 'BODY') /* Node is already a body, use as is */ body = importedNode;
                else if (importedNode.nodeName === 'HTML') body = importedNode;
                else // eslint-disable-next-line unicorn/prefer-dom-node-append
                body.appendChild(importedNode);
            } else {
                /* Exit directly if we have nothing to do */ if (!RETURN_DOM && !SAFE_FOR_TEMPLATES && !WHOLE_DOCUMENT && // eslint-disable-next-line unicorn/prefer-includes
                dirty.indexOf('<') === -1) return trustedTypesPolicy && RETURN_TRUSTED_TYPE ? trustedTypesPolicy.createHTML(dirty) : dirty;
                /* Initialize the document to work on */ body = _initDocument(dirty);
                /* Check we have a DOM node from the data */ if (!body) return RETURN_DOM ? null : RETURN_TRUSTED_TYPE ? emptyHTML : '';
            }
            /* Remove first element node (ours) if FORCE_BODY is set */ if (body && FORCE_BODY) _forceRemove(body.firstChild);
            /* Get node iterator */ var nodeIterator = _createIterator(IN_PLACE ? dirty : body);
            /* Now start iterating over the created document */ while(currentNode = nodeIterator.nextNode()){
                /* Fix IE's strange behavior with manipulated textNodes #89 */ if (currentNode.nodeType === 3 && currentNode === oldNode) continue;
                /* Sanitize tags and elements */ _sanitizeElements(currentNode);
                /* Check attributes next */ _sanitizeAttributes(currentNode);
                /* Shadow DOM detected, sanitize it */ if (currentNode.content instanceof DocumentFragment) _sanitizeShadowDOM(currentNode.content);
                oldNode = currentNode;
            }
            oldNode = null;
            /* If we sanitized `dirty` in-place, return it. */ if (IN_PLACE) return dirty;
            /* Return sanitized string or DOM */ if (RETURN_DOM) {
                if (RETURN_DOM_FRAGMENT) {
                    returnNode = createDocumentFragment.call(body.ownerDocument);
                    while(body.firstChild)// eslint-disable-next-line unicorn/prefer-dom-node-append
                    returnNode.appendChild(body.firstChild);
                } else returnNode = body;
                if (ALLOWED_ATTR.shadowroot || ALLOWED_ATTR.shadowrootmod) /*
            AdoptNode() is not used because internal state is not reset
            (e.g. the past names map of a HTMLFormElement), this is safe
            in theory but we would rather not risk another attack vector.
            The state that is cloned by importNode() is explicitly defined
            by the specs.
          */ returnNode = importNode.call(originalDocument, returnNode, true);
                return returnNode;
            }
            var serializedHTML = WHOLE_DOCUMENT ? body.outerHTML : body.innerHTML;
            /* Serialize doctype if allowed */ if (WHOLE_DOCUMENT && ALLOWED_TAGS['!doctype'] && body.ownerDocument && body.ownerDocument.doctype && body.ownerDocument.doctype.name && regExpTest(DOCTYPE_NAME, body.ownerDocument.doctype.name)) serializedHTML = '<!DOCTYPE ' + body.ownerDocument.doctype.name + '>\n' + serializedHTML;
            /* Sanitize final string template-safe */ if (SAFE_FOR_TEMPLATES) {
                serializedHTML = stringReplace(serializedHTML, MUSTACHE_EXPR$1, ' ');
                serializedHTML = stringReplace(serializedHTML, ERB_EXPR$1, ' ');
                serializedHTML = stringReplace(serializedHTML, TMPLIT_EXPR$1, ' ');
            }
            return trustedTypesPolicy && RETURN_TRUSTED_TYPE ? trustedTypesPolicy.createHTML(serializedHTML) : serializedHTML;
        };
        /**
     * Public method to set the configuration once
     * setConfig
     *
     * @param {Object} cfg configuration object
     */ DOMPurify.setConfig = function(cfg) {
            _parseConfig(cfg);
            SET_CONFIG = true;
        };
        /**
     * Public method to remove the configuration
     * clearConfig
     *
     */ DOMPurify.clearConfig = function() {
            CONFIG = null;
            SET_CONFIG = false;
        };
        /**
     * Public method to check if an attribute value is valid.
     * Uses last set config, if any. Otherwise, uses config defaults.
     * isValidAttribute
     *
     * @param  {string} tag Tag name of containing element.
     * @param  {string} attr Attribute name.
     * @param  {string} value Attribute value.
     * @return {Boolean} Returns true if `value` is valid. Otherwise, returns false.
     */ DOMPurify.isValidAttribute = function(tag, attr, value) {
            /* Initialize shared config vars if necessary. */ if (!CONFIG) _parseConfig({});
            var lcTag = transformCaseFunc(tag);
            var lcName = transformCaseFunc(attr);
            return _isValidAttribute(lcTag, lcName, value);
        };
        /**
     * AddHook
     * Public method to add DOMPurify hooks
     *
     * @param {String} entryPoint entry point for the hook to add
     * @param {Function} hookFunction function to execute
     */ DOMPurify.addHook = function(entryPoint, hookFunction) {
            if (typeof hookFunction !== 'function') return;
            hooks[entryPoint] = hooks[entryPoint] || [];
            arrayPush(hooks[entryPoint], hookFunction);
        };
        /**
     * RemoveHook
     * Public method to remove a DOMPurify hook at a given entryPoint
     * (pops it from the stack of hooks if more are present)
     *
     * @param {String} entryPoint entry point for the hook to remove
     * @return {Function} removed(popped) hook
     */ DOMPurify.removeHook = function(entryPoint) {
            if (hooks[entryPoint]) return arrayPop(hooks[entryPoint]);
        };
        /**
     * RemoveHooks
     * Public method to remove all DOMPurify hooks at a given entryPoint
     *
     * @param  {String} entryPoint entry point for the hooks to remove
     */ DOMPurify.removeHooks = function(entryPoint) {
            if (hooks[entryPoint]) hooks[entryPoint] = [];
        };
        /**
     * RemoveAllHooks
     * Public method to remove all DOMPurify hooks
     *
     */ DOMPurify.removeAllHooks = function() {
            hooks = {};
        };
        return DOMPurify;
    }
    var purify = createDOMPurify();
    return purify;
});

},{}],"9z6ut":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "Scrollbar", function() {
    return Scrollbar;
});
parcelHelpers.export(exports, "ScrollbarContext", function() {
    return ScrollbarContext;
});
parcelHelpers.export(exports, "default", function() {
    return Scrollbar;
});
var _cnbuilder = require("cnbuilder");
var _react = require("react");
var _zoomLevel = require("zoom-level");
var _reactDraggable = require("react-draggable");
/******************************************************************************
Copyright (c) Microsoft Corporation.

Permission to use, copy, modify, and/or distribute this software for any
purpose with or without fee is hereby granted.

THE SOFTWARE IS PROVIDED "AS IS" AND THE AUTHOR DISCLAIMS ALL WARRANTIES WITH
REGARD TO THIS SOFTWARE INCLUDING ALL IMPLIED WARRANTIES OF MERCHANTABILITY
AND FITNESS. IN NO EVENT SHALL THE AUTHOR BE LIABLE FOR ANY SPECIAL, DIRECT,
INDIRECT, OR CONSEQUENTIAL DAMAGES OR ANY DAMAGES WHATSOEVER RESULTING FROM
LOSS OF USE, DATA OR PROFITS, WHETHER IN AN ACTION OF CONTRACT, NEGLIGENCE OR
OTHER TORTIOUS ACTION, ARISING OUT OF OR IN CONNECTION WITH THE USE OR
PERFORMANCE OF THIS SOFTWARE.
***************************************************************************** */ /* global Reflect, Promise */ var extendStatics = function extendStatics1(d, b) {
    extendStatics = Object.setPrototypeOf || ({
        __proto__: []
    }) instanceof Array && function(d, b) {
        d.__proto__ = b;
    } || function(d, b) {
        for(var p in b)if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p];
    };
    return extendStatics(d, b);
};
function __extends(d, b) {
    if (typeof b !== "function" && b !== null) throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
    extendStatics(d, b);
    function __() {
        this.constructor = d;
    }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
}
var __assign = function __assign1() {
    __assign = Object.assign || function __assign(t) {
        for(var s, i = 1, n = arguments.length; i < n; i++){
            s = arguments[i];
            for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
function __rest(s, e) {
    var t = {};
    for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function") {
        for(var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++)if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
    }
    return t;
}
function __spreadArray(to, from, pack) {
    if (pack || arguments.length === 2) {
        for(var i = 0, l = from.length, ar; i < l; i++)if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
}
function _typeof(obj) {
    "@babel/helpers - typeof";
    return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function _typeof(obj) {
        return typeof obj;
    } : function(obj) {
        return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
    }, _typeof(obj);
}
var doc = (typeof document === "undefined" ? "undefined" : _typeof(document)) === 'object' ? document : null;
var isBrowser = typeof window !== 'undefined' && typeof navigator !== 'undefined' && typeof document !== 'undefined';
var isUndef = function isUndef(v) {
    return typeof v === 'undefined';
};
var isFun = function isFun(v) {
    return typeof v === 'function';
};
var isNum = function isNum(v) {
    return typeof v === 'number';
};
/**
 * @description Will return renderer result if presented, div element otherwise.
 * If renderer is presented it'll receive `elementRef` function which should be used as HTMLElement's ref.
 *
 * @param props {ElementPropsWithElementRefAndRenderer}
 * @param elementRef {ElementRef}
 */ var renderDivWithRenderer = function renderDivWithRenderer(props, elementRef) {
    if (isFun(props.renderer)) {
        props.elementRef = elementRef;
        var renderer = props.renderer;
        delete props.renderer;
        return renderer(props);
    }
    delete props.elementRef;
    return _react.createElement("div", __assign({}, props, {
        ref: elementRef
    }));
};
var getInnerSize = function getInnerSize(el, dimension, padding1, padding2) {
    var styles = getComputedStyle(el);
    if (styles.boxSizing === 'border-box') return Math.max(0, (Number.parseFloat(styles[dimension]) || 0) - (Number.parseFloat(styles[padding1]) || 0) - (Number.parseFloat(styles[padding2]) || 0));
    return Number.parseFloat(styles[dimension]) || 0;
};
/**
 * @description Return element's height without padding
 */ var getInnerHeight = function getInnerHeight(el) {
    return getInnerSize(el, 'height', 'paddingTop', 'paddingBottom');
};
/**
 * @description Return element's width without padding
 */ var getInnerWidth = function getInnerWidth(el) {
    return getInnerSize(el, 'width', 'paddingLeft', 'paddingRight');
};
/**
 * @description Return unique UUID v4
 */ var uuid = function uuid() {
    // eslint-disable-next-line @typescript-eslint/no-shadow
    var uuid = '';
    for(var i = 0; i < 32; i++)switch(i){
        case 8:
        case 20:
            uuid += "-".concat(Math.trunc(Math.random() * 16).toString(16));
            break;
        case 12:
            uuid += '-4';
            break;
        case 16:
            uuid += "-".concat((Math.random() * 16 | 8).toString(16));
            break;
        default:
            uuid += Math.trunc(Math.random() * 16).toString(16);
    }
    return uuid;
};
/**
 * @description Calculate thumb size for given viewport and track parameters
 *
 * @param {number} contentSize - Scrollable content size
 * @param {number} viewportSize - Viewport size
 * @param {number} trackSize - Track size thumb can move
 * @param {number} minimalSize - Minimal thumb's size
 * @param {number} maximalSize - Maximal thumb's size
 */ var calcThumbSize = function calcThumbSize(contentSize, viewportSize, trackSize, minimalSize, maximalSize) {
    if (viewportSize >= contentSize) return 0;
    var thumbSize = viewportSize / contentSize * trackSize;
    if (isNum(maximalSize)) thumbSize = Math.min(maximalSize, thumbSize);
    if (isNum(minimalSize)) thumbSize = Math.max(minimalSize, thumbSize);
    return thumbSize;
};
/**
 * @description Calculate thumb offset for given viewport, track and thumb parameters
 *
 * @param {number} contentSize - Scrollable content size
 * @param {number} viewportSize - Viewport size
 * @param {number} trackSize - Track size thumb can move
 * @param {number} thumbSize - Thumb size
 * @param {number} scroll - Scroll value to represent
 */ var calcThumbOffset = function calcThumbOffset(contentSize, viewportSize, trackSize, thumbSize, scroll) {
    if (!scroll || !thumbSize || viewportSize >= contentSize) return 0;
    return (trackSize - thumbSize) * scroll / (contentSize - viewportSize);
};
/**
 * @description Calculate scroll for given viewport, track and thumb parameters
 *
 * @param {number} contentSize - Scrollable content size
 * @param {number} viewportSize - Viewport size
 * @param {number} trackSize - Track size thumb can move
 * @param {number} thumbSize - Thumb size
 * @param {number} thumbOffset - Thumb's offset representing the scroll
 */ var calcScrollForThumbOffset = function calcScrollForThumbOffset(contentSize, viewportSize, trackSize, thumbSize, thumbOffset) {
    if (!thumbOffset || !thumbSize || viewportSize >= contentSize) return 0;
    return thumbOffset * (contentSize - viewportSize) / (trackSize - thumbSize);
};
/**
 * @description Returns scrollbar width specific for current environment. Can return undefined if DOM is not ready yet.
 */ var getScrollbarWidth = function getScrollbarWidth(force) {
    if (force === void 0) force = false;
    if (!doc) {
        getScrollbarWidth._cache = 0;
        return getScrollbarWidth._cache;
    }
    if (!force && !isUndef(getScrollbarWidth._cache)) return getScrollbarWidth._cache;
    var el = doc.createElement('div');
    el.setAttribute('style', 'position:absolute;width:100px;height:100px;top:-999px;left:-999px;overflow:scroll;');
    doc.body.append(el);
    /* istanbul ignore next */ if (el.clientWidth === 0) {
        // Do not even cache this value because there is no calculations. Issue https://github.com/xobotyi/react-scrollbars-custom/issues/123
        el.remove();
        return;
    }
    getScrollbarWidth._cache = 100 - el.clientWidth;
    el.remove();
    return getScrollbarWidth._cache;
};
/**
 * @description Detect need of horizontal scroll reverse while RTL.
 */ var shouldReverseRtlScroll = function shouldReverseRtlScroll(force) {
    if (force === void 0) force = false;
    if (!force && !isUndef(shouldReverseRtlScroll._cache)) return shouldReverseRtlScroll._cache;
    if (!doc) {
        shouldReverseRtlScroll._cache = false;
        return shouldReverseRtlScroll._cache;
    }
    var el = doc.createElement('div');
    var child = doc.createElement('div');
    el.append(child);
    el.setAttribute('style', 'position:absolute;width:100px;height:100px;top:-999px;left:-999px;overflow:scroll;direction:rtl');
    child.setAttribute('style', 'width:1000px;height:1000px');
    doc.body.append(el);
    el.scrollLeft = -50;
    shouldReverseRtlScroll._cache = el.scrollLeft === -50;
    el.remove();
    return shouldReverseRtlScroll._cache;
};
var Emittr = /** @class */ function() {
    function Emittr(maxHandlers) {
        if (maxHandlers === void 0) maxHandlers = 10;
        this.setMaxHandlers(maxHandlers);
        this._handlers = Object.create(null);
    }
    Emittr._callEventHandlers = function(emitter, handlers, args) {
        if (!handlers.length) return;
        if (handlers.length === 1) {
            Reflect.apply(handlers[0], emitter, args);
            return;
        }
        handlers = __spreadArray([], handlers, true);
        var idx;
        for(idx = 0; idx < handlers.length; idx++)Reflect.apply(handlers[idx], emitter, args);
    };
    Emittr.prototype.setMaxHandlers = function(count) {
        if (!isNum(count) || count <= 0) throw new TypeError("Expected maxHandlers to be a positive number, got '".concat(count, "' of type ").concat(_typeof(count)));
        this._maxHandlers = count;
        return this;
    };
    Emittr.prototype.getMaxHandlers = function() {
        return this._maxHandlers;
    };
    Emittr.prototype.emit = function(name) {
        var args = [];
        for(var _i = 1; _i < arguments.length; _i++)args[_i - 1] = arguments[_i];
        if (_typeof(this._handlers[name]) !== 'object' || !Array.isArray(this._handlers[name])) return false;
        Emittr._callEventHandlers(this, this._handlers[name], args);
        return true;
    };
    Emittr.prototype.on = function(name, handler) {
        Emittr._addHandler(this, name, handler);
        return this;
    };
    Emittr.prototype.prependOn = function(name, handler) {
        Emittr._addHandler(this, name, handler, true);
        return this;
    };
    Emittr.prototype.once = function(name, handler) {
        if (!isFun(handler)) throw new TypeError("Expected event handler to be a function, got ".concat(_typeof(handler)));
        Emittr._addHandler(this, name, this._wrapOnceHandler(name, handler));
        return this;
    };
    Emittr.prototype.prependOnce = function(name, handler) {
        if (!isFun(handler)) throw new TypeError("Expected event handler to be a function, got ".concat(_typeof(handler)));
        Emittr._addHandler(this, name, this._wrapOnceHandler(name, handler), true);
        return this;
    };
    Emittr.prototype.off = function(name, handler) {
        Emittr._removeHandler(this, name, handler);
        return this;
    };
    Emittr.prototype.removeAllHandlers = function() {
        var handlers = this._handlers;
        this._handlers = Object.create(null);
        var removeHandlers = handlers.removeHandler;
        delete handlers.removeHandler;
        var idx;
        var eventName; // eslint-disable-next-line guard-for-in,no-restricted-syntax
        for(eventName in handlers)for(idx = handlers[eventName].length - 1; idx >= 0; idx--)Emittr._callEventHandlers(this, removeHandlers, [
            eventName,
            handlers[eventName][idx].handler || handlers[eventName][idx]
        ]);
        return this;
    };
    Emittr.prototype._wrapOnceHandler = function(name, handler) {
        var onceState = {
            fired: false,
            handler: handler,
            wrappedHandler: undefined,
            emitter: this,
            event: name
        };
        var wrappedHandler = Emittr._onceWrapper.bind(onceState);
        onceState.wrappedHandler = wrappedHandler;
        wrappedHandler.handler = handler;
        wrappedHandler.event = name;
        return wrappedHandler;
    };
    Emittr._addHandler = function(emitter, name, handler, prepend) {
        if (prepend === void 0) prepend = false;
        if (!isFun(handler)) throw new TypeError("Expected event handler to be a function, got ".concat(_typeof(handler)));
        emitter._handlers[name] = emitter._handlers[name] || [];
        emitter.emit('addHandler', name, handler);
        if (prepend) emitter._handlers[name].unshift(handler);
        else emitter._handlers[name].push(handler);
        return emitter;
    };
    Emittr._onceWrapper = function _onceWrapper() {
        var args = [];
        for(var _i = 0; _i < arguments.length; _i++)args[_i] = arguments[_i];
        if (!this.fired) {
            this.fired = true;
            this.emitter.off(this.event, this.wrappedHandler);
            Reflect.apply(this.handler, this.emitter, args);
        }
    };
    Emittr._removeHandler = function(emitter, name, handler) {
        if (!isFun(handler)) throw new TypeError("Expected event handler to be a function, got ".concat(_typeof(handler)));
        if (isUndef(emitter._handlers[name]) || !emitter._handlers[name].length) return emitter;
        var idx = -1;
        if (emitter._handlers[name].length === 1) {
            if (emitter._handlers[name][0] === handler || emitter._handlers[name][0].handler === handler) {
                idx = 0;
                handler = emitter._handlers[name][0].handler || emitter._handlers[name][0];
            }
        } else {
            for(idx = emitter._handlers[name].length - 1; idx >= 0; idx--)if (emitter._handlers[name][idx] === handler || emitter._handlers[name][idx].handler === handler) {
                handler = emitter._handlers[name][idx].handler || emitter._handlers[name][idx];
                break;
            }
        }
        if (idx === -1) return emitter;
        if (idx === 0) emitter._handlers[name].shift();
        else emitter._handlers[name].splice(idx, 1);
        emitter.emit('removeHandler', name, handler);
        return emitter;
    };
    return Emittr;
}();
var RAFLoop = /** @class */ function() {
    function RAFLoop() {
        var _this = this;
        /**
     * @description List of targets to update
     */ this.targets = [];
        /**
     * @description ID of requested animation frame. Valuable only if loop is active and has items to iterate.
     */ this.animationFrameID = 0;
        /**
     * @description Loop's state.
     */ this._isActive = false;
        /**
     * @description Start the loop if it wasn't yet.
     */ this.start = function() {
            if (!_this._isActive && _this.targets.length) {
                _this._isActive = true;
                if (_this.animationFrameID) cancelAnimationFrame(_this.animationFrameID);
                _this.animationFrameID = requestAnimationFrame(_this.rafCallback);
            }
            return _this;
        };
        /**
     * @description Stop the loop if is was active.
     */ this.stop = function() {
            if (_this._isActive) {
                _this._isActive = false;
                if (_this.animationFrameID) cancelAnimationFrame(_this.animationFrameID);
                _this.animationFrameID = 0;
            }
            return _this;
        };
        /**
     * @description Add target to the iteration list if it's not there.
     */ this.addTarget = function(target, silent) {
            if (silent === void 0) silent = false;
            if (!_this.targets.includes(target)) {
                _this.targets.push(target);
                if (_this.targets.length === 1 && !silent) _this.start();
            }
            return _this;
        };
        /**
     * @description Remove target from iteration list if it was there.
     */ this.removeTarget = function(target) {
            var idx = _this.targets.indexOf(target);
            if (idx !== -1) {
                _this.targets.splice(idx, 1);
                if (_this.targets.length === 0) _this.stop();
            }
            return _this;
        };
        /**
     * @description Callback that called each animation frame.
     */ this.rafCallback = function() {
            if (!_this._isActive) return 0;
            for(var i = 0; i < _this.targets.length; i++)if (!_this.targets[i]._unmounted) _this.targets[i].update();
            _this.animationFrameID = requestAnimationFrame(_this.rafCallback);
            return _this.animationFrameID;
        };
    }
    Object.defineProperty(RAFLoop.prototype, "isActive", {
        /**
     * @description Loop's state.
     */ get: function get() {
            return this._isActive;
        },
        enumerable: false,
        configurable: true
    });
    return RAFLoop;
}();
var Loop = new RAFLoop();
var AXIS_DIRECTION;
(function(AXIS_DIRECTION) {
    AXIS_DIRECTION["X"] = "x";
    AXIS_DIRECTION["Y"] = "y";
})(AXIS_DIRECTION || (AXIS_DIRECTION = {}));
var TRACK_CLICK_BEHAVIOR;
(function(TRACK_CLICK_BEHAVIOR) {
    TRACK_CLICK_BEHAVIOR["JUMP"] = "jump";
    TRACK_CLICK_BEHAVIOR["STEP"] = "step";
})(TRACK_CLICK_BEHAVIOR || (TRACK_CLICK_BEHAVIOR = {}));
var ScrollbarThumb = /** @class */ function(_super) {
    __extends(ScrollbarThumb, _super);
    function ScrollbarThumb() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.element = null;
        _this.initialOffsetX = 0;
        _this.initialOffsetY = 0;
        _this.elementRefHack = _react.createRef();
        _this.lastDragData = {
            x: 0,
            y: 0,
            deltaX: 0,
            deltaY: 0,
            lastX: 0,
            lastY: 0
        };
        _this.handleOnDragStart = function(ev, data) {
            if (!_this.element) {
                _this.handleOnDragStop(ev, data);
                return;
            }
            if (isBrowser) {
                _this.prevUserSelect = document.body.style.userSelect;
                document.body.style.userSelect = 'none';
                _this.prevOnSelectStart = document.onselectstart;
                document.addEventListener('selectstart', ScrollbarThumb.selectStartReplacer);
            }
            if (_this.props.onDragStart) _this.props.onDragStart(_this.lastDragData = {
                x: data.x - _this.initialOffsetX,
                y: data.y - _this.initialOffsetY,
                lastX: data.lastX - _this.initialOffsetX,
                lastY: data.lastY - _this.initialOffsetY,
                deltaX: data.deltaX,
                deltaY: data.deltaY
            });
            _this.element.classList.add('dragging');
        };
        _this.handleOnDrag = function(ev, data) {
            if (!_this.element) {
                _this.handleOnDragStop(ev, data);
                return;
            }
            if (_this.props.onDrag) _this.props.onDrag(_this.lastDragData = {
                x: data.x - _this.initialOffsetX,
                y: data.y - _this.initialOffsetY,
                lastX: data.lastX - _this.initialOffsetX,
                lastY: data.lastY - _this.initialOffsetY,
                deltaX: data.deltaX,
                deltaY: data.deltaY
            });
        };
        _this.handleOnDragStop = function(ev, data) {
            var resultData = data ? {
                x: data.x - _this.initialOffsetX,
                y: data.y - _this.initialOffsetY,
                lastX: data.lastX - _this.initialOffsetX,
                lastY: data.lastY - _this.initialOffsetY,
                deltaX: data.deltaX,
                deltaY: data.deltaY
            } : _this.lastDragData;
            if (_this.props.onDragEnd) _this.props.onDragEnd(resultData);
            if (_this.element) _this.element.classList.remove('dragging');
            if (isBrowser) {
                document.body.style.userSelect = _this.prevUserSelect;
                if (_this.prevOnSelectStart) document.addEventListener('selectstart', _this.prevOnSelectStart);
                _this.prevOnSelectStart = null;
            }
            _this.initialOffsetX = 0;
            _this.initialOffsetY = 0;
            _this.lastDragData = {
                x: 0,
                y: 0,
                deltaX: 0,
                deltaY: 0,
                lastX: 0,
                lastY: 0
            };
        };
        _this.handleOnMouseDown = function(ev) {
            if (!_this.element) return;
            ev.preventDefault();
            ev.stopPropagation();
            if (!isUndef(ev.offsetX)) {
                /* istanbul ignore next */ _this.initialOffsetX = ev.offsetX;
                /* istanbul ignore next */ _this.initialOffsetY = ev.offsetY;
            } else {
                var rect = _this.element.getBoundingClientRect();
                _this.initialOffsetX = (ev.clientX || ev.touches[0].clientX) - rect.left;
                _this.initialOffsetY = (ev.clientY || ev.touches[0].clientY) - rect.top;
            }
        };
        _this.elementRef = function(ref) {
            if (isFun(_this.props.elementRef)) _this.props.elementRef(ref);
            _this.element = ref; // eslint-disable-next-line @typescript-eslint/ban-ts-comment
            // @ts-ignore
            _this.elementRefHack.current = ref;
        };
        return _this;
    }
    ScrollbarThumb.prototype.componentDidMount = function() {
        if (!this.element) this.setState(function() {
            throw new Error("<ScrollbarThumb> Element was not created. Possibly you haven't provided HTMLDivElement to renderer's `elementRef` function.");
        });
    };
    ScrollbarThumb.prototype.componentWillUnmount = function() {
        this.handleOnDragStop();
        this.elementRef(null);
    };
    ScrollbarThumb.prototype.render = function() {
        var _a = this.props;
        // eslint-disable-next-line @typescript-eslint/no-unused-vars
        _a.elementRef;
        var axis = _a.axis;
        // eslint-disable-next-line @typescript-eslint/no-unused-vars
        _a.onDrag;
        // eslint-disable-next-line @typescript-eslint/no-unused-vars
        _a.onDragEnd;
        // eslint-disable-next-line @typescript-eslint/no-unused-vars
        _a.onDragStart;
        var props = __rest(_a, [
            "elementRef",
            "axis",
            "onDrag",
            "onDragEnd",
            "onDragStart"
        ]);
        props.className = (0, _cnbuilder.cnb)('ScrollbarsCustom-Thumb', axis === AXIS_DIRECTION.X ? 'ScrollbarsCustom-ThumbX' : 'ScrollbarsCustom-ThumbY', props.className);
        if (props.renderer) props.axis = axis;
        return _react.createElement((0, _reactDraggable.DraggableCore), {
            allowAnyClick: false,
            enableUserSelectHack: false,
            onMouseDown: this.handleOnMouseDown,
            onDrag: this.handleOnDrag,
            onStart: this.handleOnDragStart,
            onStop: this.handleOnDragStop,
            nodeRef: this.elementRefHack
        }, renderDivWithRenderer(props, this.elementRef));
    };
    ScrollbarThumb.selectStartReplacer = function() {
        return false;
    };
    return ScrollbarThumb;
}(_react.Component);
var ScrollbarTrack = /** @class */ function(_super) {
    __extends(ScrollbarTrack, _super);
    function ScrollbarTrack() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.element = null;
        _this.elementRef = function(ref) {
            if (isFun(_this.props.elementRef)) _this.props.elementRef(ref);
            _this.element = ref;
        };
        _this.handleClick = function(ev) {
            if (!ev || !_this.element || ev.button !== 0) return;
            if (isFun(_this.props.onClick) && ev.target === _this.element) {
                if (!isUndef(ev.offsetX)) _this.props.onClick(ev, {
                    axis: _this.props.axis,
                    offset: _this.props.axis === AXIS_DIRECTION.X ? ev.offsetX : ev.offsetY
                });
                else {
                    // support for old browsers
                    /* istanbul ignore next */ var rect = _this.element.getBoundingClientRect();
                    /* istanbul ignore next */ _this.props.onClick(ev, {
                        axis: _this.props.axis,
                        offset: _this.props.axis === AXIS_DIRECTION.X ? (ev.clientX || ev.touches[0].clientX) - rect.left : (ev.clientY || ev.touches[0].clientY) - rect.top
                    });
                }
            }
            return true;
        };
        return _this;
    }
    ScrollbarTrack.prototype.componentDidMount = function() {
        if (!this.element) {
            this.setState(function() {
                throw new Error("Element was not created. Possibly you haven't provided HTMLDivElement to renderer's `elementRef` function.");
            });
            return;
        }
        this.element.addEventListener('click', this.handleClick);
    };
    ScrollbarTrack.prototype.componentWillUnmount = function() {
        if (this.element) {
            this.element.removeEventListener('click', this.handleClick);
            this.element = null;
            this.elementRef(null);
        }
    };
    ScrollbarTrack.prototype.render = function() {
        var _a = this.props;
        // eslint-disable-next-line @typescript-eslint/no-unused-vars
        _a.elementRef;
        var axis = _a.axis;
        // eslint-disable-next-line @typescript-eslint/no-unused-vars
        _a.onClick;
        var props = __rest(_a, [
            "elementRef",
            "axis",
            "onClick"
        ]);
        props.className = (0, _cnbuilder.cnb)('ScrollbarsCustom-Track', axis === AXIS_DIRECTION.X ? 'ScrollbarsCustom-TrackX' : 'ScrollbarsCustom-TrackY', props.className);
        if (props.renderer) props.axis = axis;
        return renderDivWithRenderer(props, this.elementRef);
    };
    return ScrollbarTrack;
}(_react.Component);
var style = {
    holder: {
        position: 'relative',
        width: '100%',
        height: '100%'
    },
    wrapper: {
        position: 'absolute',
        top: 0,
        left: 0,
        bottom: 0,
        right: 0
    },
    content: {
        boxSizing: 'border-box'
    },
    track: {
        common: {
            position: 'absolute',
            overflow: 'hidden',
            borderRadius: 4,
            background: 'rgba(0,0,0,.1)',
            userSelect: 'none'
        },
        x: {
            height: 10,
            width: 'calc(100% - 20px)',
            bottom: 0,
            left: 10
        },
        y: {
            width: 10,
            height: 'calc(100% - 20px)',
            top: 10
        }
    },
    thumb: {
        common: {
            cursor: 'pointer',
            borderRadius: 4,
            background: 'rgba(0,0,0,.4)'
        },
        x: {
            height: '100%',
            width: 0
        },
        y: {
            width: '100%',
            height: 0
        }
    }
};
var pageZoomLevel = isBrowser ? (0, _zoomLevel.zoomLevel)() : 1;
if (isBrowser) window.addEventListener('resize', function() {
    pageZoomLevel = (0, _zoomLevel.zoomLevel)();
}, {
    passive: true
});
var ScrollbarContext = _react.createContext({
    parentScrollbar: null
});
var Scrollbar = /** @class */ function(_super) {
    __extends(Scrollbar, _super);
    function Scrollbar(props) {
        var _this = _super.call(this, props) || this;
        /**
     * @description Get current scroll-related values.<br/>
     * If <i>force</i> if truthy - will recalculate them instead of returning cached values.
     *
     * @return ScrollState
     */ _this.getScrollState = function(force) {
            if (force === void 0) force = false;
            if (_this.scrollValues && !force) return __assign({}, _this.scrollValues);
            var scrollState = {
                clientHeight: 0,
                clientWidth: 0,
                contentScrollHeight: 0,
                contentScrollWidth: 0,
                scrollHeight: 0,
                scrollWidth: 0,
                scrollTop: 0,
                scrollLeft: 0,
                scrollYBlocked: false,
                scrollXBlocked: false,
                scrollYPossible: false,
                scrollXPossible: false,
                trackYVisible: false,
                trackXVisible: false,
                zoomLevel: pageZoomLevel * 1,
                isRTL: undefined
            };
            var _$props = _this.props;
            scrollState.isRTL = _this.state.isRTL;
            scrollState.scrollYBlocked = _$props.noScroll || _$props.noScrollY;
            scrollState.scrollXBlocked = _$props.noScroll || _$props.noScrollX;
            if (_this.scrollerElement) {
                scrollState.clientHeight = _this.scrollerElement.clientHeight;
                scrollState.clientWidth = _this.scrollerElement.clientWidth;
                scrollState.scrollHeight = _this.scrollerElement.scrollHeight;
                scrollState.scrollWidth = _this.scrollerElement.scrollWidth;
                scrollState.scrollTop = _this.scrollerElement.scrollTop;
                scrollState.scrollLeft = _this.scrollerElement.scrollLeft;
                scrollState.scrollYPossible = !scrollState.scrollYBlocked && scrollState.scrollHeight > scrollState.clientHeight;
                scrollState.scrollXPossible = !scrollState.scrollXBlocked && scrollState.scrollWidth > scrollState.clientWidth;
                scrollState.trackYVisible = scrollState.scrollYPossible || _$props.permanentTracks || _$props.permanentTrackY;
                scrollState.trackXVisible = scrollState.scrollXPossible || _$props.permanentTracks || _$props.permanentTrackX;
            }
            if (_this.contentElement) {
                scrollState.contentScrollHeight = _this.contentElement.scrollHeight;
                scrollState.contentScrollWidth = _this.contentElement.scrollWidth;
            }
            return scrollState;
        };
        /**
     * @description Scroll to top border
     */ _this.scrollToTop = function() {
            if (_this.scrollerElement) _this.scrollerElement.scrollTop = 0;
            return _this;
        };
        /**
     * @description Scroll to left border
     */ _this.scrollToLeft = function() {
            if (_this.scrollerElement) _this.scrollerElement.scrollLeft = 0;
            return _this;
        };
        /**
     * @description Scroll to bottom border
     */ _this.scrollToBottom = function() {
            if (_this.scrollerElement) _this.scrollerElement.scrollTop = _this.scrollerElement.scrollHeight - _this.scrollerElement.clientHeight;
            return _this;
        };
        /**
     * @description Scroll to right border
     */ _this.scrollToRight = function() {
            if (_this.scrollerElement) _this.scrollerElement.scrollLeft = _this.scrollerElement.scrollWidth - _this.scrollerElement.clientWidth;
            return _this;
        };
        /**
     * @description Set the scrolls at given coordinates.<br/>
     * If coordinate is undefined - current scroll value will persist.
     */ _this.scrollTo = function(x, y) {
            if (_this.scrollerElement) {
                if (isNum(x)) _this.scrollerElement.scrollLeft = x;
                if (isNum(y)) _this.scrollerElement.scrollTop = y;
            }
            return _this;
        };
        /**
     * @description Center the viewport at given coordinates.<br/>
     * If coordinate is undefined - current scroll value will persist.
     */ _this.centerAt = function(x, y) {
            if (_this.scrollerElement) {
                if (isNum(x)) _this.scrollerElement.scrollLeft = x - _this.scrollerElement.clientWidth / 2;
                if (isNum(y)) _this.scrollerElement.scrollTop = y - _this.scrollerElement.clientHeight / 2;
            }
            return _this;
        };
        _this.update = function(force) {
            if (force === void 0) force = false;
            if (!_this.scrollerElement) return;
             // autodetect direction if not defined
            if (isUndef(_this.state.isRTL)) {
                _this.setState({
                    isRTL: getComputedStyle(_this.scrollerElement).direction === 'rtl'
                });
                return _this.getScrollState();
            }
            var scrollState = _this.getScrollState(true);
            var prevScrollState = __assign({}, _this.scrollValues);
            var _$props = _this.props;
            var bitmask = 0;
            if (!force) {
                if (prevScrollState.clientHeight !== scrollState.clientHeight) bitmask |= Math.trunc(1);
                if (prevScrollState.clientWidth !== scrollState.clientWidth) bitmask |= 2;
                if (prevScrollState.scrollHeight !== scrollState.scrollHeight) bitmask |= 4;
                if (prevScrollState.scrollWidth !== scrollState.scrollWidth) bitmask |= 8;
                if (prevScrollState.scrollTop !== scrollState.scrollTop) bitmask |= 16;
                if (prevScrollState.scrollLeft !== scrollState.scrollLeft) bitmask |= 32;
                if (prevScrollState.scrollYBlocked !== scrollState.scrollYBlocked) bitmask |= 64;
                if (prevScrollState.scrollXBlocked !== scrollState.scrollXBlocked) bitmask |= 128;
                if (prevScrollState.scrollYPossible !== scrollState.scrollYPossible) bitmask |= 256;
                if (prevScrollState.scrollXPossible !== scrollState.scrollXPossible) bitmask |= 512;
                if (prevScrollState.trackYVisible !== scrollState.trackYVisible) bitmask |= 1024;
                if (prevScrollState.trackXVisible !== scrollState.trackXVisible) bitmask |= 2048;
                if (prevScrollState.isRTL !== scrollState.isRTL) bitmask |= 4096;
                if (prevScrollState.contentScrollHeight !== scrollState.contentScrollHeight) bitmask |= 8192;
                if (prevScrollState.contentScrollWidth !== scrollState.contentScrollWidth) bitmask |= 16384;
                if (prevScrollState.zoomLevel !== scrollState.zoomLevel) bitmask |= 32768; // if not forced and nothing has changed - skip this update
                if (bitmask === 0) return prevScrollState;
            } else bitmask = 32767;
            if (!_$props.native && _this.holderElement) {
                if (bitmask & 8192 && (_$props.translateContentSizesToHolder || _$props.translateContentSizeYToHolder)) _this.holderElement.style.height = "".concat(scrollState.contentScrollHeight, "px");
                if (bitmask & 16384 && (_$props.translateContentSizesToHolder || _$props.translateContentSizeXToHolder)) _this.holderElement.style.width = "".concat(scrollState.contentScrollWidth, "px");
                if (_$props.translateContentSizesToHolder || _$props.translateContentSizeYToHolder || _$props.translateContentSizeXToHolder) {
                    if (!scrollState.clientHeight && scrollState.contentScrollHeight || !scrollState.clientWidth && scrollState.contentScrollWidth) return;
                }
            } // if scrollbars visibility has changed
            if (bitmask & 1024 || bitmask & 2048) {
                prevScrollState.scrollYBlocked = scrollState.scrollYBlocked;
                prevScrollState.scrollXBlocked = scrollState.scrollXBlocked;
                prevScrollState.scrollYPossible = scrollState.scrollYPossible;
                prevScrollState.scrollXPossible = scrollState.scrollXPossible;
                if (_this.trackYElement && bitmask & 1024) _this.trackYElement.style.display = scrollState.trackYVisible ? '' : 'none';
                if (_this.trackXElement && bitmask & 2048) _this.trackXElement.style.display = scrollState.trackXVisible ? '' : 'none';
                _this.scrollValues = prevScrollState;
                _this.setState({
                    trackYVisible: _this.scrollValues.trackYVisible = scrollState.trackYVisible,
                    trackXVisible: _this.scrollValues.trackXVisible = scrollState.trackXVisible
                });
                return;
            }
            (_$props.native ? _this.updaterNative : _this.updaterCustom)(bitmask, scrollState);
            _this.scrollValues = scrollState;
            if (!_$props.native && bitmask & 32768) {
                getScrollbarWidth(true);
                _this.forceUpdate();
            }
            _this.eventEmitter.emit('update', __assign({}, scrollState), prevScrollState);
            if (bitmask & 16 || bitmask & 32) _this.eventEmitter.emit('scroll', __assign({}, scrollState), prevScrollState);
            return _this.scrollValues;
        }; // eslint-disable-next-line class-methods-use-this
        _this.updaterNative = function() {
            // just for future
            return true;
        };
        _this.updaterCustom = function(bitmask, scrollValues) {
            var _$props = _this.props;
            if (_this.trackYElement) {
                if (_this.thumbYElement && (bitmask & Math.trunc(1) || bitmask & 4 || bitmask & 16 || bitmask & 64 || bitmask & 256)) {
                    if (scrollValues.scrollYPossible) {
                        var trackInnerSize = getInnerHeight(_this.trackYElement);
                        var thumbSize = calcThumbSize(scrollValues.scrollHeight, scrollValues.clientHeight, trackInnerSize, _$props.minimalThumbYSize || _$props.minimalThumbSize, _$props.maximalThumbYSize || _$props.maximalThumbSize);
                        var thumbOffset = calcThumbOffset(scrollValues.scrollHeight, scrollValues.clientHeight, trackInnerSize, thumbSize, scrollValues.scrollTop);
                        _this.thumbYElement.style.transform = "translateY(".concat(thumbOffset, "px)");
                        _this.thumbYElement.style.height = "".concat(thumbSize, "px");
                        _this.thumbYElement.style.display = '';
                    } else {
                        _this.thumbYElement.style.transform = '';
                        _this.thumbYElement.style.height = '0px';
                        _this.thumbYElement.style.display = 'none';
                    }
                }
            }
            if (_this.trackXElement) {
                if (_this.thumbXElement && (bitmask & 2 || bitmask & 8 || bitmask & 32 || bitmask & 128 || bitmask & 512 || bitmask & 4096)) {
                    if (scrollValues.scrollXPossible) {
                        var trackInnerSize = getInnerWidth(_this.trackXElement);
                        var thumbSize = calcThumbSize(scrollValues.scrollWidth, scrollValues.clientWidth, trackInnerSize, _$props.minimalThumbXSize || _$props.minimalThumbSize, _$props.maximalThumbXSize || _$props.maximalThumbSize);
                        var thumbOffset = calcThumbOffset(scrollValues.scrollWidth, scrollValues.clientWidth, trackInnerSize, thumbSize, scrollValues.scrollLeft);
                        if (_this.state.isRTL && shouldReverseRtlScroll()) thumbOffset += trackInnerSize - thumbSize;
                        _this.thumbXElement.style.transform = "translateX(".concat(thumbOffset, "px)");
                        _this.thumbXElement.style.width = "".concat(thumbSize, "px");
                        _this.thumbXElement.style.display = '';
                    } else {
                        _this.thumbXElement.style.transform = '';
                        _this.thumbXElement.style.width = '0px';
                        _this.thumbXElement.style.display = 'none';
                    }
                }
            }
            return true;
        };
        _this.elementRefHolder = function(ref) {
            _this.holderElement = ref;
            if (isFun(_this.props.elementRef)) _this.props.elementRef(ref);
        };
        _this.elementRefWrapper = function(ref) {
            _this.wrapperElement = ref;
            if (isFun(_this.props.wrapperProps.elementRef)) _this.props.wrapperProps.elementRef(ref);
        };
        _this.elementRefScroller = function(ref) {
            _this.scrollerElement = ref;
            if (isFun(_this.props.scrollerProps.elementRef)) _this.props.scrollerProps.elementRef(ref);
        };
        _this.elementRefContent = function(ref) {
            _this.contentElement = ref;
            if (isFun(_this.props.contentProps.elementRef)) _this.props.contentProps.elementRef(ref);
        };
        _this.elementRefTrackX = function(ref) {
            _this.trackXElement = ref;
            if (isFun(_this.props.trackXProps.elementRef)) _this.props.trackXProps.elementRef(ref);
        };
        _this.elementRefTrackY = function(ref) {
            _this.trackYElement = ref;
            if (isFun(_this.props.trackYProps.elementRef)) _this.props.trackYProps.elementRef(ref);
        };
        _this.elementRefThumbX = function(ref) {
            _this.thumbXElement = ref;
            if (isFun(_this.props.thumbXProps.elementRef)) _this.props.thumbXProps.elementRef(ref);
        };
        _this.elementRefThumbY = function(ref) {
            _this.thumbYElement = ref;
            if (isFun(_this.props.thumbYProps.elementRef)) _this.props.thumbYProps.elementRef(ref);
        };
        _this.handleTrackXClick = function(ev, values) {
            if (_this.props.trackXProps.onClick) _this.props.trackXProps.onClick(ev, values);
            if (!_this.scrollerElement || !_this.trackXElement || !_this.thumbXElement || !_this.scrollValues || !_this.scrollValues.scrollXPossible) return;
            _this._scrollDetection();
            var thumbSize = _this.thumbXElement.clientWidth;
            var trackInnerSize = getInnerWidth(_this.trackXElement);
            var thumbOffset = (_this.scrollValues.isRTL && shouldReverseRtlScroll() ? values.offset + thumbSize / 2 - trackInnerSize : values.offset - thumbSize / 2) - (Number.parseFloat(getComputedStyle(_this.trackXElement).paddingLeft) || 0);
            var target = calcScrollForThumbOffset(_this.scrollValues.scrollWidth, _this.scrollValues.clientWidth, trackInnerSize, thumbSize, thumbOffset);
            if (_this.props.trackClickBehavior === TRACK_CLICK_BEHAVIOR.STEP) target = (_this.scrollValues.isRTL ? _this.scrollValues.scrollLeft > target : _this.scrollValues.scrollLeft < target) ? _this.scrollValues.scrollLeft + _this.scrollValues.clientWidth : _this.scrollValues.scrollLeft - _this.scrollValues.clientWidth;
            _this.scrollerElement.scrollLeft = target;
        };
        _this.handleTrackYClick = function(ev, values) {
            if (_this.props.trackYProps.onClick) _this.props.trackYProps.onClick(ev, values);
            if (!_this.scrollerElement || !_this.trackYElement || !_this.thumbYElement || !_this.scrollValues || !_this.scrollValues.scrollYPossible) return;
            _this._scrollDetection();
            var thumbSize = _this.thumbYElement.clientHeight;
            var target = calcScrollForThumbOffset(_this.scrollValues.scrollHeight, _this.scrollValues.clientHeight, getInnerHeight(_this.trackYElement), thumbSize, values.offset - thumbSize / 2) - (Number.parseFloat(getComputedStyle(_this.trackYElement).paddingTop) || 0);
            if (_this.props.trackClickBehavior === TRACK_CLICK_BEHAVIOR.JUMP) _this.scrollerElement.scrollTop = target;
            else _this.scrollerElement.scrollTop = _this.scrollValues.scrollTop < target ? _this.scrollValues.scrollTop + _this.scrollValues.clientHeight : _this.scrollValues.scrollTop - _this.scrollValues.clientHeight;
        };
        _this.handleTrackYMouseWheel = function(ev) {
            var _$props = _this.props;
            if (_$props.trackYProps && _$props.trackYProps.onWheel) _$props.trackYProps.onWheel(ev);
            if (_$props.disableTracksMousewheelScrolling || _$props.disableTrackYMousewheelScrolling) return;
            _this._scrollDetection();
            if (!_this.scrollerElement || _this.scrollValues.scrollYBlocked) return;
            _this.scrollTop += ev.deltaY;
        };
        _this.handleTrackXMouseWheel = function(ev) {
            var _$props = _this.props;
            if (_$props.trackXProps && _$props.trackXProps.onWheel) _$props.trackXProps.onWheel(ev);
            if (_$props.disableTracksMousewheelScrolling || _$props.disableTrackXMousewheelScrolling) return;
            _this._scrollDetection();
            if (!_this.scrollerElement || _this.scrollValues.scrollXBlocked) return;
            _this.scrollLeft += ev.deltaX;
        };
        _this.handleThumbXDrag = function(data) {
            var _a;
            if (!_this.trackXElement || !_this.thumbXElement || !_this.scrollerElement || !_this.scrollValues || !_this.scrollValues.scrollXPossible) return;
            _this._scrollDetection();
            var trackRect = _this.trackXElement.getBoundingClientRect();
            var styles = getComputedStyle(_this.trackXElement);
            var paddingLeft = Number.parseFloat(styles.paddingLeft) || 0;
            var paddingRight = Number.parseFloat(styles.paddingRight) || 0;
            var trackInnerSize = trackRect.width - paddingLeft - paddingRight;
            var thumbSize = _this.thumbXElement.clientWidth;
            var offset = _this.scrollValues.isRTL && shouldReverseRtlScroll() ? data.x + thumbSize - trackInnerSize + paddingLeft : data.lastX - paddingLeft;
            _this.scrollerElement.scrollLeft = calcScrollForThumbOffset(_this.scrollValues.scrollWidth, _this.scrollValues.clientWidth, trackInnerSize, thumbSize, offset);
            if ((_a = _this.props.thumbXProps) === null || _a === void 0 ? void 0 : _a.onDrag) _this.props.thumbXProps.onDrag(data);
        };
        _this.handleThumbXDragEnd = function(data) {
            var _a;
            _this.handleThumbXDrag(data);
            if ((_a = _this.props.thumbXProps) === null || _a === void 0 ? void 0 : _a.onDragEnd) _this.props.thumbXProps.onDragEnd(data);
        };
        _this.handleThumbYDrag = function(data) {
            var _a;
            if (!_this.scrollerElement || !_this.trackYElement || !_this.thumbYElement || !_this.scrollValues || !_this.scrollValues.scrollYPossible) return;
            _this._scrollDetection();
            var trackRect = _this.trackYElement.getBoundingClientRect();
            var styles = getComputedStyle(_this.trackYElement);
            var paddingTop = Number.parseFloat(styles.paddingTop) || 0;
            var paddingBottom = Number.parseFloat(styles.paddingBottom) || 0;
            var trackInnerSize = trackRect.height - paddingTop - paddingBottom;
            var thumbSize = _this.thumbYElement.clientHeight;
            var offset = data.y - paddingTop;
            _this.scrollerElement.scrollTop = calcScrollForThumbOffset(_this.scrollValues.scrollHeight, _this.scrollValues.clientHeight, trackInnerSize, thumbSize, offset);
            if ((_a = _this.props.thumbYProps) === null || _a === void 0 ? void 0 : _a.onDrag) _this.props.thumbYProps.onDrag(data);
        };
        _this.handleThumbYDragEnd = function(data) {
            var _a;
            _this.handleThumbYDrag(data);
            if ((_a = _this.props.thumbYProps) === null || _a === void 0 ? void 0 : _a.onDragEnd) _this.props.thumbYProps.onDragEnd(data);
        };
        _this.handleScrollerScroll = function() {
            _this._scrollDetection();
        };
        _this._scrollDetection = function() {
            if (!_this._scrollDetectionTO) _this.eventEmitter.emit('scrollStart', _this.getScrollState());
            else if (isBrowser) window.clearTimeout(_this._scrollDetectionTO);
            _this._scrollDetectionTO = isBrowser ? window.setTimeout(_this._scrollDetectionCallback, _this.props.scrollDetectionThreshold || 0) : null;
        };
        _this._scrollDetectionCallback = function() {
            _this._scrollDetectionTO = null;
            _this.eventEmitter.emit('scrollStop', _this.getScrollState());
        };
        _this.state = {
            trackXVisible: false,
            trackYVisible: false,
            isRTL: props.rtl
        };
        _this.scrollValues = _this.getScrollState(true);
        _this.eventEmitter = new Emittr(15);
        if (props.onUpdate) _this.eventEmitter.on('update', props.onUpdate);
        if (props.onScroll) _this.eventEmitter.on('scroll', props.onScroll);
        if (props.onScrollStart) _this.eventEmitter.on('scrollStart', props.onScrollStart);
        if (props.onScrollStop) _this.eventEmitter.on('scrollStop', props.onScrollStop);
        _this.id = uuid();
        return _this;
    }
    Object.defineProperty(Scrollbar.prototype, "scrollTop", {
        // eslint-disable-next-line react/sort-comp
        get: function get() {
            if (this.scrollerElement) return this.scrollerElement.scrollTop;
            return 0;
        },
        set: function set(top) {
            if (this.scrollerElement) {
                this.scrollerElement.scrollTop = top;
                this.update();
            }
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(Scrollbar.prototype, "scrollLeft", {
        get: function get() {
            if (this.scrollerElement) return this.scrollerElement.scrollLeft;
            return 0;
        },
        set: function set(left) {
            if (this.scrollerElement) this.scrollerElement.scrollLeft = left;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(Scrollbar.prototype, "scrollHeight", {
        get: function get() {
            if (this.scrollerElement) return this.scrollerElement.scrollHeight;
            return 0;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(Scrollbar.prototype, "scrollWidth", {
        get: function get() {
            if (this.scrollerElement) return this.scrollerElement.scrollWidth;
            return 0;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(Scrollbar.prototype, "clientHeight", {
        get: function get() {
            if (this.scrollerElement) return this.scrollerElement.clientHeight;
            return 0;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(Scrollbar.prototype, "clientWidth", {
        get: function get() {
            if (this.scrollerElement) return this.scrollerElement.clientWidth;
            return 0;
        },
        enumerable: false,
        configurable: true
    }); // eslint-disable-next-line react/sort-comp
    Scrollbar.calculateStyles = function(props, state, scrollValues, scrollbarWidth) {
        var _a, _b, _c, _d;
        var useDefaultStyles = !props.noDefaultStyles;
        return {
            holder: __assign(__assign(__assign({}, useDefaultStyles && style.holder), {
                position: 'relative'
            }), props.style),
            wrapper: __assign(__assign(__assign({}, useDefaultStyles && __assign(__assign(__assign({}, style.wrapper), !props.disableTracksWidthCompensation && !props.disableTrackYWidthCompensation && (_a = {}, _a[state.isRTL ? 'left' : 'right'] = state.trackYVisible ? 10 : 0, _a)), !props.disableTracksWidthCompensation && !props.disableTrackXWidthCompensation && {
                bottom: state.trackXVisible ? 10 : 0
            })), props.wrapperProps.style), {
                position: 'absolute',
                overflow: 'hidden'
            }),
            content: __assign(__assign(__assign(__assign(__assign({}, useDefaultStyles && style.content), props.translateContentSizesToHolder || props.translateContentSizeYToHolder || props.translateContentSizeXToHolder ? {
                display: 'table-cell'
            } : {
                padding: 0.05 // needed to disable margin collapsing without flexboxes, other possible solutions here: https://stackoverflow.com/questions/19718634/how-to-disable-margin-collapsing
            }), useDefaultStyles && !(props.translateContentSizesToHolder || props.translateContentSizeYToHolder) && {
                minHeight: '100%'
            }), useDefaultStyles && !(props.translateContentSizesToHolder || props.translateContentSizeXToHolder) && {
                minWidth: '100%'
            }), props.contentProps.style),
            scroller: __assign(__assign(__assign(__assign((_b = {
                position: 'absolute',
                top: 0,
                left: 0,
                bottom: 0,
                right: 0,
                paddingBottom: !scrollbarWidth && scrollValues.scrollXPossible ? props.fallbackScrollbarWidth : undefined
            }, _b[state.isRTL ? 'paddingLeft' : 'paddingRight'] = !scrollbarWidth && scrollValues.scrollYPossible ? props.fallbackScrollbarWidth : undefined, _b), props.scrollerProps.style), !isUndef(props.rtl) && {
                direction: props.rtl ? 'rtl' : 'ltr'
            }), props.momentum && {
                WebkitOverflowScrolling: 'touch'
            }), (_c = {
                overflowY: scrollValues.scrollYPossible ? 'scroll' : 'hidden',
                overflowX: scrollValues.scrollXPossible ? 'scroll' : 'hidden',
                marginBottom: scrollValues.scrollXPossible ? -(scrollbarWidth || props.fallbackScrollbarWidth) - Number(scrollValues.zoomLevel !== 1) : undefined
            }, _c[state.isRTL ? 'marginLeft' : 'marginRight'] = scrollValues.scrollYPossible ? -(scrollbarWidth || props.fallbackScrollbarWidth) - Number(scrollValues.zoomLevel !== 1) : undefined, _c)),
            trackX: __assign(__assign(__assign(__assign({}, useDefaultStyles && style.track.common), useDefaultStyles && style.track.x), props.trackXProps.style), !state.trackXVisible && {
                display: 'none'
            }),
            trackY: __assign(__assign(__assign(__assign(__assign({}, useDefaultStyles && style.track.common), useDefaultStyles && style.track.y), useDefaultStyles && (_d = {}, _d[state.isRTL ? 'left' : 'right'] = 0, _d)), props.trackYProps.style), !state.trackYVisible && {
                display: 'none'
            }),
            thumbX: __assign(__assign(__assign({}, useDefaultStyles && style.thumb.common), useDefaultStyles && style.thumb.x), props.thumbXProps.style),
            thumbY: __assign(__assign(__assign({}, useDefaultStyles && style.thumb.common), useDefaultStyles && style.thumb.y), props.thumbYProps.style)
        };
    };
    Scrollbar.prototype.componentDidMount = function() {
        if (!this.scrollerElement) {
            this.setState(function() {
                throw new Error("scroller element was not created. Possibly you haven't provided HTMLDivElement to renderer's `elementRef` function.");
            });
            return;
        }
        if (!this.contentElement) {
            this.setState(function() {
                throw new Error("content element was not created. Possibly you haven't provided HTMLDivElement to renderer's `elementRef` function.");
            });
            return;
        }
        var props = this.props;
        if (!props.native && !props.mobileNative) {
            // ToDo: move native state to the state so it can be synchronized
            if (!this.holderElement) {
                this.setState(function() {
                    throw new Error("holder element was not created. Possibly you haven't provided HTMLDivElement to renderer's `elementRef` function.");
                });
                return;
            }
            if (!this.wrapperElement) {
                this.setState(function() {
                    throw new Error("wrapper element was not created. Possibly you haven't provided HTMLDivElement to renderer's `elementRef` function.");
                });
                return;
            }
        }
        Loop.addTarget(this);
        if (!isUndef(props.scrollTop)) this.scrollerElement.scrollTop = props.scrollTop;
        if (!isUndef(props.scrollLeft)) this.scrollerElement.scrollLeft = props.scrollLeft;
        this.update(true);
    };
    Scrollbar.prototype.componentWillUnmount = function() {
        Loop.removeTarget(this);
    };
    Scrollbar.prototype.componentDidUpdate = function(prevProps, prevState) {
        if (!this.scrollerElement) return;
        var props = this.props;
        if (props.rtl !== prevProps.rtl && props.rtl !== this.state.isRTL) this.setState({
            isRTL: props.rtl
        });
        if (this.state.isRTL !== prevState.isRTL) this.update();
        if (!isUndef(props.scrollTop) && props.scrollTop !== this.scrollerElement.scrollTop) this.scrollerElement.scrollTop = props.scrollTop;
        if (!isUndef(props.scrollLeft) && props.scrollLeft !== this.scrollerElement.scrollLeft) this.scrollerElement.scrollLeft = props.scrollLeft;
        if (prevProps.onUpdate !== props.onUpdate) {
            if (prevProps.onUpdate) this.eventEmitter.off('update', prevProps.onUpdate);
            if (props.onUpdate) this.eventEmitter.on('update', props.onUpdate);
        }
        if (prevProps.onScroll !== props.onScroll) {
            if (prevProps.onScroll) this.eventEmitter.off('scroll', prevProps.onScroll);
            if (props.onScroll) this.eventEmitter.on('scroll', props.onScroll);
        }
        if (prevProps.onScrollStart !== props.onScrollStart) {
            if (prevProps.onScrollStart) this.eventEmitter.off('scrollStart', prevProps.onScrollStart);
            if (props.onScrollStart) this.eventEmitter.on('scrollStart', props.onScrollStart);
        }
        if (prevProps.onScrollStop !== props.onScrollStop) {
            if (prevProps.onScrollStop) this.eventEmitter.off('scrollStop', prevProps.onScrollStop);
            if (props.onScrollStop) this.eventEmitter.on('scrollStop', props.onScrollStop);
        }
    }; // eslint-disable-next-line react/sort-comp
    Scrollbar.prototype.render = function() {
        var _a = this.props, createContext = _a.createContext, rtl = _a.rtl, native = _a.native, mobileNative = _a.mobileNative, momentum = _a.momentum;
        // eslint-disable-next-line @typescript-eslint/no-unused-vars
        _a.noDefaultStyles;
        var disableTracksMousewheelScrolling = _a.disableTracksMousewheelScrolling, disableTrackXMousewheelScrolling = _a.disableTrackXMousewheelScrolling, disableTrackYMousewheelScrolling = _a.disableTrackYMousewheelScrolling;
        // eslint-disable-next-line @typescript-eslint/no-unused-vars
        _a.disableTracksWidthCompensation;
        // eslint-disable-next-line @typescript-eslint/no-unused-vars
        _a.disableTrackXWidthCompensation;
        // eslint-disable-next-line @typescript-eslint/no-unused-vars
        _a.disableTrackYWidthCompensation;
        var noScrollX = _a.noScrollX, noScrollY = _a.noScrollY, noScroll = _a.noScroll, permanentTrackX = _a.permanentTrackX, permanentTrackY = _a.permanentTrackY, permanentTracks = _a.permanentTracks, removeTracksWhenNotUsed = _a.removeTracksWhenNotUsed, removeTrackYWhenNotUsed = _a.removeTrackYWhenNotUsed, removeTrackXWhenNotUsed = _a.removeTrackXWhenNotUsed;
        // eslint-disable-next-line @typescript-eslint/no-unused-vars
        _a.minimalThumbSize;
        // eslint-disable-next-line @typescript-eslint/no-unused-vars
        _a.maximalThumbSize;
        // eslint-disable-next-line @typescript-eslint/no-unused-vars
        _a.minimalThumbXSize;
        // eslint-disable-next-line @typescript-eslint/no-unused-vars
        _a.maximalThumbXSize;
        // eslint-disable-next-line @typescript-eslint/no-unused-vars
        _a.minimalThumbYSize;
        // eslint-disable-next-line @typescript-eslint/no-unused-vars
        _a.maximalThumbYSize;
        // eslint-disable-next-line @typescript-eslint/no-unused-vars
        _a.fallbackScrollbarWidth;
        // eslint-disable-next-line @typescript-eslint/no-unused-vars
        _a.scrollTop;
        // eslint-disable-next-line @typescript-eslint/no-unused-vars
        _a.scrollLeft;
        // eslint-disable-next-line @typescript-eslint/no-unused-vars
        _a.trackClickBehavior;
        // eslint-disable-next-line @typescript-eslint/no-unused-vars
        _a.scrollDetectionThreshold;
        var propsWrapperProps = _a.wrapperProps, propsScrollerProps = _a.scrollerProps, propsContentProps = _a.contentProps, propsTrackXProps = _a.trackXProps, propsTrackYProps = _a.trackYProps, propsThumbXProps = _a.thumbXProps, propsThumbYProps = _a.thumbYProps, propsScrollbarWidth = _a.scrollbarWidth;
        // eslint-disable-next-line @typescript-eslint/no-unused-vars
        _a.elementRef;
        // eslint-disable-next-line @typescript-eslint/no-unused-vars
        _a.onUpdate;
        // eslint-disable-next-line @typescript-eslint/no-unused-vars
        _a.onScroll;
        // eslint-disable-next-line @typescript-eslint/no-unused-vars
        _a.onScrollStart;
        // eslint-disable-next-line @typescript-eslint/no-unused-vars
        _a.onScrollStop;
        // eslint-disable-next-line @typescript-eslint/no-unused-vars
        _a.translateContentSizesToHolder;
        // eslint-disable-next-line @typescript-eslint/no-unused-vars
        _a.translateContentSizeYToHolder;
        // eslint-disable-next-line @typescript-eslint/no-unused-vars
        _a.translateContentSizeXToHolder;
        var children = _a.children, propsHolderProps = __rest(_a, [
            "createContext",
            "rtl",
            "native",
            "mobileNative",
            "momentum",
            "noDefaultStyles",
            "disableTracksMousewheelScrolling",
            "disableTrackXMousewheelScrolling",
            "disableTrackYMousewheelScrolling",
            "disableTracksWidthCompensation",
            "disableTrackXWidthCompensation",
            "disableTrackYWidthCompensation",
            "noScrollX",
            "noScrollY",
            "noScroll",
            "permanentTrackX",
            "permanentTrackY",
            "permanentTracks",
            "removeTracksWhenNotUsed",
            "removeTrackYWhenNotUsed",
            "removeTrackXWhenNotUsed",
            "minimalThumbSize",
            "maximalThumbSize",
            "minimalThumbXSize",
            "maximalThumbXSize",
            "minimalThumbYSize",
            "maximalThumbYSize",
            "fallbackScrollbarWidth",
            "scrollTop",
            "scrollLeft",
            "trackClickBehavior",
            "scrollDetectionThreshold",
            "wrapperProps",
            "scrollerProps",
            "contentProps",
            "trackXProps",
            "trackYProps",
            "thumbXProps",
            "thumbYProps",
            "scrollbarWidth",
            "elementRef",
            "onUpdate",
            "onScroll",
            "onScrollStart",
            "onScrollStop",
            "translateContentSizesToHolder",
            "translateContentSizeYToHolder",
            "translateContentSizeXToHolder",
            "children"
        ]);
        var scrollbarWidth = !isUndef(propsScrollbarWidth) ? propsScrollbarWidth : getScrollbarWidth() || 0;
        if (native || !scrollbarWidth && mobileNative) {
            this.elementRefHolder(null);
            this.elementRefWrapper(null);
            this.elementRefTrackX(null);
            this.elementRefTrackY(null);
            this.elementRefThumbX(null);
            this.elementRefThumbY(null);
            var contentProps_1 = __assign(__assign({}, propsContentProps), {
                key: 'ScrollbarsCustom-Content',
                className: (0, _cnbuilder.cnb)('ScrollbarsCustom-Content', propsContentProps.className),
                children: children
            });
            var scrollerProps_1 = __assign(__assign({}, propsHolderProps), {
                className: (0, _cnbuilder.cnb)('ScrollbarsCustom native', this.state.trackYVisible && 'trackYVisible', this.state.trackXVisible && 'trackXVisible', this.state.isRTL && 'rtl', propsHolderProps.className),
                style: __assign(__assign(__assign(__assign({}, propsHolderProps.style), !isUndef(rtl) && {
                    direction: rtl ? 'rtl' : 'ltr'
                }), momentum && {
                    WebkitOverflowScrolling: 'touch'
                }), {
                    overflowX: noScroll || noScrollX ? 'hidden' : permanentTracks || permanentTrackX ? 'scroll' : 'auto',
                    overflowY: noScroll || noScrollY ? 'hidden' : permanentTracks || permanentTrackY ? 'scroll' : 'auto'
                }),
                onScroll: this.handleScrollerScroll,
                children: renderDivWithRenderer(contentProps_1, this.elementRefContent),
                renderer: propsScrollerProps.renderer,
                elementRef: propsScrollerProps.elementRef
            });
            return renderDivWithRenderer(scrollerProps_1, this.elementRefScroller);
        }
        var styles = Scrollbar.calculateStyles(this.props, this.state, this.scrollValues, scrollbarWidth);
        var holderChildren = [];
        var contentProps = __assign(__assign({}, propsContentProps), {
            key: 'ScrollbarsCustom-Content',
            className: (0, _cnbuilder.cnb)('ScrollbarsCustom-Content', propsContentProps.className),
            style: styles.content,
            children: createContext ? _react.createElement(ScrollbarContext.Provider, {
                value: {
                    parentScrollbar: this
                }
            }, children) : children
        });
        var scrollerProps = __assign(__assign({}, propsScrollerProps), {
            key: 'ScrollbarsCustom-Scroller',
            className: (0, _cnbuilder.cnb)('ScrollbarsCustom-Scroller', propsScrollerProps.className),
            style: styles.scroller,
            children: renderDivWithRenderer(contentProps, this.elementRefContent),
            onScroll: this.handleScrollerScroll
        });
        var wrapperProps = __assign(__assign({}, propsWrapperProps), {
            key: 'ScrollbarsCustom-Wrapper',
            className: (0, _cnbuilder.cnb)('ScrollbarsCustom-Wrapper', propsWrapperProps.className),
            style: styles.wrapper,
            children: renderDivWithRenderer(scrollerProps, this.elementRefScroller)
        });
        holderChildren.push(renderDivWithRenderer(wrapperProps, this.elementRefWrapper));
        if (this.state.trackYVisible || !removeTracksWhenNotUsed && !removeTrackYWhenNotUsed) {
            var thumbYProps = __assign(__assign({}, propsThumbYProps), {
                key: 'ScrollbarsCustom-ThumbY',
                style: styles.thumbY,
                elementRef: this.elementRefThumbY,
                onDrag: this.handleThumbYDrag,
                onDragEnd: this.handleThumbYDragEnd,
                axis: AXIS_DIRECTION.Y
            });
            var trackYProps = __assign(__assign(__assign(__assign({}, propsTrackYProps), {
                key: 'ScrollbarsCustom-TrackY',
                style: styles.trackY,
                elementRef: this.elementRefTrackY,
                onClick: this.handleTrackYClick
            }), (disableTracksMousewheelScrolling || disableTrackYMousewheelScrolling) && {
                onWheel: this.handleTrackYMouseWheel
            }), {
                axis: AXIS_DIRECTION.Y
            });
            trackYProps.children = _react.createElement(ScrollbarThumb, __assign({}, thumbYProps));
            holderChildren.push(_react.createElement(ScrollbarTrack, __assign({}, trackYProps)));
        } else {
            this.elementRefTrackY(null);
            this.elementRefThumbY(null);
        }
        if (this.state.trackXVisible || !removeTracksWhenNotUsed && !removeTrackXWhenNotUsed) {
            var thumbXProps = __assign(__assign({}, propsThumbXProps), {
                key: 'ScrollbarsCustom-ThumbX',
                style: styles.thumbX,
                elementRef: this.elementRefThumbX,
                onDrag: this.handleThumbXDrag,
                onDragEnd: this.handleThumbXDragEnd,
                axis: AXIS_DIRECTION.X
            });
            var trackXProps = __assign(__assign(__assign(__assign({}, propsTrackXProps), {
                key: 'ScrollbarsCustom-TrackX',
                style: styles.trackX,
                elementRef: this.elementRefTrackX,
                onClick: this.handleTrackXClick
            }), (disableTracksMousewheelScrolling || disableTrackXMousewheelScrolling) && {
                onWheel: this.handleTrackXMouseWheel
            }), {
                axis: AXIS_DIRECTION.X
            });
            trackXProps.children = _react.createElement(ScrollbarThumb, __assign({}, thumbXProps));
            holderChildren.push(_react.createElement(ScrollbarTrack, __assign({}, trackXProps)));
        } else {
            this.elementRefTrackX(null);
            this.elementRefThumbX(null);
        }
        var holderProps = __assign(__assign({}, propsHolderProps), {
            className: (0, _cnbuilder.cnb)('ScrollbarsCustom', this.state.trackYVisible && 'trackYVisible', this.state.trackXVisible && 'trackXVisible', this.state.isRTL && 'rtl', propsHolderProps.className),
            style: styles.holder,
            children: holderChildren
        });
        return renderDivWithRenderer(holderProps, this.elementRefHolder);
    }; // eslint-disable-next-line react/static-property-placement
    Scrollbar.contextType = ScrollbarContext; // eslint-disable-next-line react/static-property-placement
    Scrollbar.defaultProps = {
        momentum: true,
        minimalThumbSize: 30,
        fallbackScrollbarWidth: 20,
        trackClickBehavior: TRACK_CLICK_BEHAVIOR.JUMP,
        scrollDetectionThreshold: 100,
        wrapperProps: {},
        scrollerProps: {},
        contentProps: {},
        trackXProps: {},
        trackYProps: {},
        thumbXProps: {},
        thumbYProps: {}
    };
    return Scrollbar;
}(_react.Component);

},{"cnbuilder":"e2S9G","react":"gjea9","zoom-level":"7j0fp","react-draggable":"fJ2oz","@parcel/transformer-js/src/esmodule-helpers.js":"g0Ia8"}],"e2S9G":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "cnb", function() {
    return 0, _cnbJs.cnb;
});
parcelHelpers.export(exports, "dcnb", function() {
    return 0, _dcnbJs.dcnb;
});
var _cnbJs = require("./cnb.js");
var _dcnbJs = require("./dcnb.js");

},{"./cnb.js":"40VhC","./dcnb.js":false,"@parcel/transformer-js/src/esmodule-helpers.js":"g0Ia8"}],"40VhC":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "cnb", function() {
    return cnb;
});
var _typeOf = require("@swc/helpers/_/_type_of");
var isArray = Array.isArray;
var toClassName = function toClassName1(val) {
    var str = '';
    if (typeof val === 'string') str += val;
    else if ((typeof val === "undefined" ? "undefined" : (0, _typeOf._)(val)) === 'object') {
        var tmp = void 0;
        if (isArray(val)) {
            var i = 0;
            var l = val.length;
            while(i < l){
                tmp = toClassName(val[i++]);
                if (tmp) {
                    if (str) str += ' ';
                    str += tmp;
                }
            }
        } else {
            // eslint-disable-next-line guard-for-in
            for(tmp in val)if (tmp && val[tmp]) {
                if (str) str += ' ';
                str += tmp;
            }
        }
    }
    return str;
};
function cnb() {
    var l = arguments.length;
    var i = 0;
    var n;
    var tmp;
    var str = '';
    while(i < l){
        n = arguments[i++];
        if (n) {
            tmp = toClassName(n);
            if (tmp) {
                if (str) str += ' ';
                str += tmp;
            }
        }
    }
    return str;
}

},{"@swc/helpers/_/_type_of":"cYs4R","@parcel/transformer-js/src/esmodule-helpers.js":"g0Ia8"}],"7j0fp":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "elementZoomLevel", function() {
    return t;
});
parcelHelpers.export(exports, "zoomLevel", function() {
    return i;
});
function e(e, i, t, o) {
    for(; i >= t && !e("(min-resolution: " + i / o + "dppx)").matches;)i--;
    return i;
}
function i(i) {
    if (void 0 === i && (i = window), !i) return 1;
    if (void 0 !== i.devicePixelRatio) return i.devicePixelRatio;
    var t = i.document.frames;
    return void 0 !== t ? void 0 !== t.devicePixelRatio ? t.devicePixelRatio : t.screen.deviceXDPI / t.screen.systemXDPI : void 0 !== i.matchMedia ? function(i) {
        for(var t = i.matchMedia, o = 10, n = .1, r = 1, a = o, c = 0; c < 4; c++)o = (a = 10 * e(t, o, n, r)) + 9, n = a, r *= 10;
        return a / r;
    }(i) : 1;
}
function t(e, t) {
    var o = (e instanceof Element ? getComputedStyle(e).zoom : e.zoom) || 1;
    return i(t) * ("string" == typeof o ? parseFloat(o) : o);
}

},{"@parcel/transformer-js/src/esmodule-helpers.js":"g0Ia8"}],"fJ2oz":[function(require,module,exports,__globalThis) {
"use strict";
var _require = require("39b5312b4b7f8b31"), Draggable = _require.default, DraggableCore = _require.DraggableCore;
// Previous versions of this lib exported <Draggable> as the root export. As to no-// them, or TypeScript, we export *both* as the root and as 'default'.
// See https://github.com/mzabriskie/react-draggable/pull/254
// and https://github.com/mzabriskie/react-draggable/issues/266
module.exports = Draggable;
module.exports.default = Draggable;
module.exports.DraggableCore = DraggableCore;

},{"39b5312b4b7f8b31":"aPniN"}],"aPniN":[function(require,module,exports,__globalThis) {
var _callSuper = require("@swc/helpers/_/_call_super");
var _classCallCheck = require("@swc/helpers/_/_class_call_check");
var _createClass = require("@swc/helpers/_/_create_class");
var _defineProperty = require("@swc/helpers/_/_define_property");
var _inherits = require("@swc/helpers/_/_inherits");
var _objectSpread = require("@swc/helpers/_/_object_spread");
var _objectSpreadProps = require("@swc/helpers/_/_object_spread_props");
var _objectWithoutProperties = require("@swc/helpers/_/_object_without_properties");
var _slicedToArray = require("@swc/helpers/_/_sliced_to_array");
var _typeOf = require("@swc/helpers/_/_type_of");
"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
Object.defineProperty(exports, "DraggableCore", {
    enumerable: true,
    get: function get() {
        return _DraggableCore.default;
    }
});
exports.default = void 0;
var React = _interopRequireWildcard(require("f06ad358256d46ae"));
var _propTypes = _interopRequireDefault(require("9f8816d66633a995"));
var _reactDom = _interopRequireDefault(require("fd97d82c5bf54e9d"));
var _clsx = _interopRequireDefault(require("26060e24796bfa96"));
var _domFns = require("4e40e768124450c6");
var _positionFns = require("6ac2262d9826d85d");
var _shims = require("2838a27078c4cbed");
var _DraggableCore = _interopRequireDefault(require("2ae804dc0d7f535c"));
var _log = _interopRequireDefault(require("6e73015298a24ef9"));
function _interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
function _getRequireWildcardCache(nodeInterop) {
    if (typeof WeakMap !== "function") return null;
    var cacheBabelInterop = new WeakMap();
    var cacheNodeInterop = new WeakMap();
    return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) {
        return nodeInterop ? cacheNodeInterop : cacheBabelInterop;
    })(nodeInterop);
}
function _interopRequireWildcard(obj, nodeInterop) {
    if (!nodeInterop && obj && obj.__esModule) return obj;
    if (obj === null || (typeof obj === "undefined" ? "undefined" : (0, _typeOf._)(obj)) !== "object" && typeof obj !== "function") return {
        default: obj
    };
    var cache = _getRequireWildcardCache(nodeInterop);
    if (cache && cache.has(obj)) return cache.get(obj);
    var newObj = {};
    var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor;
    for(var key in obj)if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) {
        var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null;
        if (desc && (desc.get || desc.set)) Object.defineProperty(newObj, key, desc);
        else newObj[key] = obj[key];
    }
    newObj.default = obj;
    if (cache) cache.set(obj, newObj);
    return newObj;
}
function _extends() {
    _extends = Object.assign ? Object.assign.bind() : function _extends(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
        }
        return target;
    };
    return _extends.apply(this, arguments);
}
function _defineProperty1(obj, key, value) {
    key = _toPropertyKey(key);
    if (key in obj) Object.defineProperty(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
    });
    else obj[key] = value;
    return obj;
}
function _toPropertyKey(arg) {
    var key = _toPrimitive(arg, "string");
    return (typeof key === "undefined" ? "undefined" : (0, _typeOf._)(key)) === "symbol" ? key : String(key);
}
function _toPrimitive(input, hint) {
    if ((typeof input === "undefined" ? "undefined" : (0, _typeOf._)(input)) !== "object" || input === null) return input;
    var prim = input[Symbol.toPrimitive];
    if (prim !== undefined) {
        var res = prim.call(input, hint || "default");
        if ((typeof res === "undefined" ? "undefined" : (0, _typeOf._)(res)) !== "object") return res;
        throw new TypeError("@@toPrimitive must return a primitive value.");
    }
    return (hint === "string" ? String : Number)(input);
} /*:: import type {ControlPosition, PositionOffsetControlPosition, DraggableCoreProps, DraggableCoreDefaultProps} from './DraggableCore';*/ 
/*:: import type {Bounds, DraggableEventHandler} from './utils/types';*/ /*:: import type {Element as ReactElement} from 'react';*/ /*:: type DraggableState = {
  dragging: boolean,
  dragged: boolean,
  x: number, y: number,
  slackX: number, slackY: number,
  isElementSVG: boolean,
  prevPropsPosition: ?ControlPosition,
};*/ /*:: export type DraggableDefaultProps = {
  ...DraggableCoreDefaultProps,
  axis: 'both' | 'x' | 'y' | 'none',
  bounds: Bounds | string | false,
  defaultClassName: string,
  defaultClassNameDragging: string,
  defaultClassNameDragged: string,
  defaultPosition: ControlPosition,
  scale: number,
};*/ /*:: export type DraggableProps = {
  ...DraggableCoreProps,
  ...DraggableDefaultProps,
  positionOffset: PositionOffsetControlPosition,
  position: ControlPosition,
};*/ //
// Define <Draggable>
//
var Draggable = /*#__PURE__*/ function(_React_Component) {
    (0, _inherits._)(Draggable, _React_Component);
    function Draggable(props /*: DraggableProps*/ ) {
        (0, _classCallCheck._)(this, Draggable);
        var _this;
        _this = (0, _callSuper._)(this, Draggable, [
            props
        ]);
        _defineProperty1(_this, "onDragStart", function(e, coreData) {
            (0, _log.default)('Draggable: onDragStart: %j', coreData);
            // Short-circuit if user's callback killed it.
            var shouldStart = _this.props.onStart(e, (0, _positionFns.createDraggableData)(_this, coreData));
            // Kills start event on core as well, so move handlers are never bound.
            if (shouldStart === false) return false;
            _this.setState({
                dragging: true,
                dragged: true
            });
        });
        _defineProperty1(_this, "onDrag", function(e, coreData) {
            if (!_this.state.dragging) return false;
            (0, _log.default)('Draggable: onDrag: %j', coreData);
            var uiData = (0, _positionFns.createDraggableData)(_this, coreData);
            var newState = {
                x: uiData.x,
                y: uiData.y,
                slackX: 0,
                slackY: 0
            };
            // Keep within bounds.
            if (_this.props.bounds) {
                // Save original x and y.
                var x = newState.x, y = newState.y;
                // Add slack to the values used to calculate bound position. This will ensure that if
                // we start removing slack, the element won't react to it right away until it's been
                // completely removed.
                newState.x += _this.state.slackX;
                newState.y += _this.state.slackY;
                // Get bound position. This will ceil/floor the x and y within the boundaries.
                var _ref = (0, _slicedToArray._)((0, _positionFns.getBoundPosition)(_this, newState.x, newState.y), 2), newStateX = _ref[0], newStateY = _ref[1];
                newState.x = newStateX;
                newState.y = newStateY;
                // Recalculate slack by noting how much was shaved by the boundPosition handler.
                newState.slackX = _this.state.slackX + (x - newState.x);
                newState.slackY = _this.state.slackY + (y - newState.y);
                // Update the event we fire to reflect what really happened after bounds took effect.
                uiData.x = newState.x;
                uiData.y = newState.y;
                uiData.deltaX = newState.x - _this.state.x;
                uiData.deltaY = newState.y - _this.state.y;
            }
            // Short-circuit if user's callback killed it.
            var shouldUpdate = _this.props.onDrag(e, uiData);
            if (shouldUpdate === false) return false;
            _this.setState(newState);
        });
        _defineProperty1(_this, "onDragStop", function(e, coreData) {
            if (!_this.state.dragging) return false;
            // Short-circuit if user's callback killed it.
            var shouldContinue = _this.props.onStop(e, (0, _positionFns.createDraggableData)(_this, coreData));
            if (shouldContinue === false) return false;
            (0, _log.default)('Draggable: onDragStop: %j', coreData);
            var newState /*: Partial<DraggableState>*/  = {
                dragging: false,
                slackX: 0,
                slackY: 0
            };
            // If this is a controlled component, the result of this operation will be to
            // revert back to the old position. We expect a handler on `onDragStop`, at the least.
            var controlled = Boolean(_this.props.position);
            if (controlled) {
                var _this_props_position = _this.props.position, x = _this_props_position.x, y = _this_props_position.y;
                newState.x = x;
                newState.y = y;
            }
            _this.setState(newState);
        });
        _this.state = {
            // Whether or not we are currently dragging.
            dragging: false,
            // Whether or not we have been dragged before.
            dragged: false,
            // Current transform x and y.
            x: props.position ? props.position.x : props.defaultPosition.x,
            y: props.position ? props.position.y : props.defaultPosition.y,
            prevPropsPosition: (0, _objectSpread._)({}, props.position),
            // Used for compensating for out-of-bounds drags
            slackX: 0,
            slackY: 0,
            // Can only determine if SVG after mounting
            isElementSVG: false
        };
        if (props.position && !(props.onDrag || props.onStop)) // eslint-disable-next-line no-console
        console.warn("A `position` was applied to this <Draggable>, without drag handlers. This will make this component effectively undraggable. Please attach `onDrag` or `onStop` handlers so you can adjust the `position` of this element.");
        return _this;
    }
    (0, _createClass._)(Draggable, [
        {
            key: "componentDidMount",
            value: function componentDidMount() {
                // Check to see if the element passed is an instanceof SVGElement
                if (typeof window.SVGElement !== 'undefined' && this.findDOMNode() instanceof window.SVGElement) this.setState({
                    isElementSVG: true
                });
            }
        },
        {
            key: "componentWillUnmount",
            value: function componentWillUnmount() {
                this.setState({
                    dragging: false
                }); // prevents invariant if unmounted while dragging
            }
        },
        {
            // React Strict Mode compatibility: if `nodeRef` is passed, we will use it instead of trying to find
            // the underlying DOM node ourselves. See the README for more information.
            key: "findDOMNode",
            value: function findDOMNode() /*: ?HTMLElement*/ {
                var _this$props$nodeRef$c, _this$props;
                return (_this$props$nodeRef$c = (_this$props = this.props) === null || _this$props === void 0 || (_this$props = _this$props.nodeRef) === null || _this$props === void 0 ? void 0 : _this$props.current) !== null && _this$props$nodeRef$c !== void 0 ? _this$props$nodeRef$c : _reactDom.default.findDOMNode(this);
            }
        },
        {
            key: "render",
            value: function render() /*: ReactElement<any>*/ {
                var _this_props = this.props, axis = _this_props.axis, bounds = _this_props.bounds, children = _this_props.children, defaultPosition = _this_props.defaultPosition, defaultClassName = _this_props.defaultClassName, defaultClassNameDragging = _this_props.defaultClassNameDragging, defaultClassNameDragged = _this_props.defaultClassNameDragged, position = _this_props.position, positionOffset = _this_props.positionOffset, scale = _this_props.scale, draggableCoreProps = (0, _objectWithoutProperties._)(_this_props, [
                    "axis",
                    "bounds",
                    "children",
                    "defaultPosition",
                    "defaultClassName",
                    "defaultClassNameDragging",
                    "defaultClassNameDragged",
                    "position",
                    "positionOffset",
                    "scale"
                ]);
                var style = {};
                var svgTransform = null;
                // If this is controlled, we don't want to move it - unless it's dragging.
                var controlled = Boolean(position);
                var draggable = !controlled || this.state.dragging;
                var validPosition = position || defaultPosition;
                var transformOpts = {
                    // Set left if horizontal drag is enabled
                    x: (0, _positionFns.canDragX)(this) && draggable ? this.state.x : validPosition.x,
                    // Set top if vertical drag is enabled
                    y: (0, _positionFns.canDragY)(this) && draggable ? this.state.y : validPosition.y
                };
                // If this element was SVG, we use the `transform` attribute.
                if (this.state.isElementSVG) svgTransform = (0, _domFns.createSVGTransform)(transformOpts, positionOffset);
                else // Add a CSS transform to move the element around. This allows us to move the element around
                // without worrying about whether or not it is relatively or absolutely positioned.
                // If the item you are dragging already has a transform set, wrap it in a <span> so <Draggable>
                // has a clean slate.
                style = (0, _domFns.createCSSTransform)(transformOpts, positionOffset);
                var _obj;
                // Mark with class while dragging
                var className = (0, _clsx.default)(children.props.className || '', defaultClassName, (_obj = {}, (0, _defineProperty._)(_obj, defaultClassNameDragging, this.state.dragging), (0, _defineProperty._)(_obj, defaultClassNameDragged, this.state.dragged), _obj));
                // Reuse the child provided
                // This makes it flexible to use whatever element is wanted (div, ul, etc)
                return /*#__PURE__*/ React.createElement(_DraggableCore.default, _extends({}, draggableCoreProps, {
                    onStart: this.onDragStart,
                    onDrag: this.onDrag,
                    onStop: this.onDragStop
                }), /*#__PURE__*/ React.cloneElement(React.Children.only(children), {
                    className: className,
                    style: (0, _objectSpread._)({}, children.props.style, style),
                    transform: svgTransform
                }));
            }
        }
    ], [
        {
            key: "getDerivedStateFromProps",
            value: // React 16.3+
            // Arity (props, state)
            function getDerivedStateFromProps(_ref /*:: */ , _ref2 /*:: */ ) /*: ?Partial<DraggableState>*/ {
                var position = _ref /*: DraggableProps*/ .position;
                var prevPropsPosition = _ref2 /*: DraggableState*/ .prevPropsPosition;
                // Set x/y if a new position is provided in props that is different than the previous.
                if (position && (!prevPropsPosition || position.x !== prevPropsPosition.x || position.y !== prevPropsPosition.y)) {
                    (0, _log.default)('Draggable: getDerivedStateFromProps %j', {
                        position: position,
                        prevPropsPosition: prevPropsPosition
                    });
                    return {
                        x: position.x,
                        y: position.y,
                        prevPropsPosition: (0, _objectSpread._)({}, position)
                    };
                }
                return null;
            }
        }
    ]);
    return Draggable;
}(React.Component /*:: <DraggableProps, DraggableState>*/ );
exports.default = Draggable;
_defineProperty1(Draggable, "displayName", 'Draggable');
_defineProperty1(Draggable, "propTypes", (0, _objectSpreadProps._)((0, _objectSpread._)({}, _DraggableCore.default.propTypes), {
    /**
   * `axis` determines which axis the draggable can move.
   *
   *  Note that all callbacks will still return data as normal. This only
   *  controls flushing to the DOM.
   *
   * 'both' allows movement horizontally and vertically.
   * 'x' limits movement to horizontal axis.
   * 'y' limits movement to vertical axis.
   * 'none' limits all movement.
   *
   * Defaults to 'both'.
   */ axis: _propTypes.default.oneOf([
        'both',
        'x',
        'y',
        'none'
    ]),
    /**
   * `bounds` determines the range of movement available to the element.
   * Available values are:
   *
   * 'parent' restricts movement within the Draggable's parent node.
   *
   * Alternatively, pass an object with the following properties, all of which are optional:
   *
   * {left: LEFT_BOUND, right: RIGHT_BOUND, bottom: BOTTOM_BOUND, top: TOP_BOUND}
   *
   * All values are in px.
   *
   * Example:
   *
   * ```jsx
   *   let App = React.createClass({
   *       render: function () {
   *         return (
   *            <Draggable bounds={{right: 300, bottom: 300}}>
   *              <div>Content</div>
   *           </Draggable>
   *         );
   *       }
   *   });
   * ```
   */ bounds: _propTypes.default.oneOfType([
        _propTypes.default.shape({
            left: _propTypes.default.number,
            right: _propTypes.default.number,
            top: _propTypes.default.number,
            bottom: _propTypes.default.number
        }),
        _propTypes.default.string,
        _propTypes.default.oneOf([
            false
        ])
    ]),
    defaultClassName: _propTypes.default.string,
    defaultClassNameDragging: _propTypes.default.string,
    defaultClassNameDragged: _propTypes.default.string,
    /**
   * `defaultPosition` specifies the x and y that the dragged item should start at
   *
   * Example:
   *
   * ```jsx
   *      let App = React.createClass({
   *          render: function () {
   *              return (
   *                  <Draggable defaultPosition={{x: 25, y: 25}}>
   *                      <div>I start with transformX: 25px and transformY: 25px;</div>
   *                  </Draggable>
   *              );
   *          }
   *      });
   * ```
   */ defaultPosition: _propTypes.default.shape({
        x: _propTypes.default.number,
        y: _propTypes.default.number
    }),
    positionOffset: _propTypes.default.shape({
        x: _propTypes.default.oneOfType([
            _propTypes.default.number,
            _propTypes.default.string
        ]),
        y: _propTypes.default.oneOfType([
            _propTypes.default.number,
            _propTypes.default.string
        ])
    }),
    /**
   * `position`, if present, defines the current position of the element.
   *
   *  This is similar to how form elements in React work - if no `position` is supplied, the component
   *  is uncontrolled.
   *
   * Example:
   *
   * ```jsx
   *      let App = React.createClass({
   *          render: function () {
   *              return (
   *                  <Draggable position={{x: 25, y: 25}}>
   *                      <div>I start with transformX: 25px and transformY: 25px;</div>
   *                  </Draggable>
   *              );
   *          }
   *      });
   * ```
   */ position: _propTypes.default.shape({
        x: _propTypes.default.number,
        y: _propTypes.default.number
    }),
    /**
   * These properties should be defined on the child, not here.
   */ className: _shims.dontSetMe,
    style: _shims.dontSetMe,
    transform: _shims.dontSetMe
}));
_defineProperty1(Draggable, "defaultProps", (0, _objectSpreadProps._)((0, _objectSpread._)({}, _DraggableCore.default.defaultProps), {
    axis: 'both',
    bounds: false,
    defaultClassName: 'react-draggable',
    defaultClassNameDragging: 'react-draggable-dragging',
    defaultClassNameDragged: 'react-draggable-dragged',
    defaultPosition: {
        x: 0,
        y: 0
    },
    scale: 1
}));

},{"@swc/helpers/_/_call_super":"6D4Bs","@swc/helpers/_/_class_call_check":"4fJVn","@swc/helpers/_/_create_class":"LhYkq","@swc/helpers/_/_define_property":"dmvty","@swc/helpers/_/_inherits":"YAPwf","@swc/helpers/_/_object_spread":"7ZOov","@swc/helpers/_/_object_spread_props":"8MPJG","@swc/helpers/_/_object_without_properties":"1FjsY","@swc/helpers/_/_sliced_to_array":"5Sh31","@swc/helpers/_/_type_of":"cYs4R","f06ad358256d46ae":"gjea9","9f8816d66633a995":"kMWEB","fd97d82c5bf54e9d":"b9022","26060e24796bfa96":"k3NUC","4e40e768124450c6":"azx9g","6ac2262d9826d85d":"69Uv7","2838a27078c4cbed":"79bOz","2ae804dc0d7f535c":"8qL5z","6e73015298a24ef9":"iVF5L"}],"kMWEB":[function(require,module,exports,__globalThis) {
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ var ReactIs, throwOnDirectAccess;
// By explicitly using `prop-types` you are opting into new production behavior.
// http://fb.me/prop-types-in-prod
module.exports = require("e98516c5bab4526")();

},{"e98516c5bab4526":"9coC1"}],"9coC1":[function(require,module,exports,__globalThis) {
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ 'use strict';
var ReactPropTypesSecret = require("bf7f43a19ae1b960");
function emptyFunction() {}
function emptyFunctionWithReset() {}
emptyFunctionWithReset.resetWarningCache = emptyFunction;
module.exports = function() {
    function shim(props, propName, componentName, location, propFullName, secret) {
        if (secret === ReactPropTypesSecret) // It is still safe when called from React.
        return;
        var err = new Error("Calling PropTypes validators directly is not supported by the `prop-types` package. Use PropTypes.checkPropTypes() to call them. Read more at http://fb.me/use-check-prop-types");
        err.name = 'Invariant Violation';
        throw err;
    }
    shim.isRequired = shim;
    function getShim() {
        return shim;
    }
    // Important!
    // Keep this list in sync with production version in `./factoryWithTypeCheckers.js`.
    var ReactPropTypes = {
        array: shim,
        bigint: shim,
        bool: shim,
        func: shim,
        number: shim,
        object: shim,
        string: shim,
        symbol: shim,
        any: shim,
        arrayOf: getShim,
        element: shim,
        elementType: shim,
        instanceOf: getShim,
        node: shim,
        objectOf: getShim,
        oneOf: getShim,
        oneOfType: getShim,
        shape: getShim,
        exact: getShim,
        checkPropTypes: emptyFunctionWithReset,
        resetWarningCache: emptyFunction
    };
    ReactPropTypes.PropTypes = ReactPropTypes;
    return ReactPropTypes;
};

},{"bf7f43a19ae1b960":"1DIht"}],"1DIht":[function(require,module,exports,__globalThis) {
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ 'use strict';
var ReactPropTypesSecret = 'SECRET_DO_NOT_PASS_THIS_OR_YOU_WILL_BE_FIRED';
module.exports = ReactPropTypesSecret;

},{}],"k3NUC":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "clsx", function() {
    return clsx;
});
var _typeOf = require("@swc/helpers/_/_type_of");
function r(e) {
    var t, f, n = "";
    if ("string" == typeof e || "number" == typeof e) n += e;
    else if ("object" == (typeof e === "undefined" ? "undefined" : (0, _typeOf._)(e))) {
        if (Array.isArray(e)) for(t = 0; t < e.length; t++)e[t] && (f = r(e[t])) && (n && (n += " "), n += f);
        else for(t in e)e[t] && (n && (n += " "), n += t);
    }
    return n;
}
function clsx() {
    for(var e, t, f = 0, n = ""; f < arguments.length;)(e = arguments[f++]) && (t = r(e)) && (n && (n += " "), n += t);
    return n;
}
exports.default = clsx;

},{"@swc/helpers/_/_type_of":"cYs4R","@parcel/transformer-js/src/esmodule-helpers.js":"g0Ia8"}],"azx9g":[function(require,module,exports,__globalThis) {
var _defineProperty = require("@swc/helpers/_/_define_property");
var _objectSpread = require("@swc/helpers/_/_object_spread");
var _typeOf = require("@swc/helpers/_/_type_of");
"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.addClassName = addClassName;
exports.addEvent = addEvent;
exports.addUserSelectStyles = addUserSelectStyles;
exports.createCSSTransform = createCSSTransform;
exports.createSVGTransform = createSVGTransform;
exports.getTouch = getTouch;
exports.getTouchIdentifier = getTouchIdentifier;
exports.getTranslation = getTranslation;
exports.innerHeight = innerHeight;
exports.innerWidth = innerWidth;
exports.matchesSelector = matchesSelector;
exports.matchesSelectorAndParentsTo = matchesSelectorAndParentsTo;
exports.offsetXYFromParent = offsetXYFromParent;
exports.outerHeight = outerHeight;
exports.outerWidth = outerWidth;
exports.removeClassName = removeClassName;
exports.removeEvent = removeEvent;
exports.removeUserSelectStyles = removeUserSelectStyles;
var _shims = require("af60d0462ec484c0");
var _getPrefix = _interopRequireWildcard(require("25bee73a12bb5ee8"));
function _getRequireWildcardCache(nodeInterop) {
    if (typeof WeakMap !== "function") return null;
    var cacheBabelInterop = new WeakMap();
    var cacheNodeInterop = new WeakMap();
    return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) {
        return nodeInterop ? cacheNodeInterop : cacheBabelInterop;
    })(nodeInterop);
}
function _interopRequireWildcard(obj, nodeInterop) {
    if (!nodeInterop && obj && obj.__esModule) return obj;
    if (obj === null || (typeof obj === "undefined" ? "undefined" : (0, _typeOf._)(obj)) !== "object" && typeof obj !== "function") return {
        default: obj
    };
    var cache = _getRequireWildcardCache(nodeInterop);
    if (cache && cache.has(obj)) return cache.get(obj);
    var newObj = {};
    var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor;
    for(var key in obj)if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) {
        var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null;
        if (desc && (desc.get || desc.set)) Object.defineProperty(newObj, key, desc);
        else newObj[key] = obj[key];
    }
    newObj.default = obj;
    if (cache) cache.set(obj, newObj);
    return newObj;
}
/*:: import type {ControlPosition, PositionOffsetControlPosition, MouseTouchEvent} from './types';*/ var matchesSelectorFunc = '';
function matchesSelector(el /*: Node*/ , selector /*: string*/ ) /*: boolean*/ {
    if (!matchesSelectorFunc) matchesSelectorFunc = (0, _shims.findInArray)([
        'matches',
        'webkitMatchesSelector',
        'mozMatchesSelector',
        'msMatchesSelector',
        'oMatchesSelector'
    ], function(method) {
        // $FlowIgnore: Doesn't think elements are indexable
        return (0, _shims.isFunction)(el[method]);
    });
    // Might not be found entirely (not an Element?) - in that case, bail
    // $FlowIgnore: Doesn't think elements are indexable
    if (!(0, _shims.isFunction)(el[matchesSelectorFunc])) return false;
    // $FlowIgnore: Doesn't think elements are indexable
    return el[matchesSelectorFunc](selector);
}
// Works up the tree to the draggable itself attempting to match selector.
function matchesSelectorAndParentsTo(el /*: Node*/ , selector /*: string*/ , baseNode /*: Node*/ ) /*: boolean*/ {
    var node = el;
    do {
        if (matchesSelector(node, selector)) return true;
        if (node === baseNode) return false;
        // $FlowIgnore[incompatible-type]
        node = node.parentNode;
    }while (node);
    return false;
}
function addEvent(el /*: ?Node*/ , event /*: string*/ , handler /*: Function*/ , inputOptions /*: Object*/ ) /*: void*/ {
    if (!el) return;
    var options = (0, _objectSpread._)({
        capture: true
    }, inputOptions);
    // $FlowIgnore[method-unbinding]
    if (el.addEventListener) el.addEventListener(event, handler, options);
    else if (el.attachEvent) el.attachEvent('on' + event, handler);
    else // $FlowIgnore: Doesn't think elements are indexable
    el['on' + event] = handler;
}
function removeEvent(el /*: ?Node*/ , event /*: string*/ , handler /*: Function*/ , inputOptions /*: Object*/ ) /*: void*/ {
    if (!el) return;
    var options = (0, _objectSpread._)({
        capture: true
    }, inputOptions);
    // $FlowIgnore[method-unbinding]
    if (el.removeEventListener) el.removeEventListener(event, handler, options);
    else if (el.detachEvent) el.detachEvent('on' + event, handler);
    else // $FlowIgnore: Doesn't think elements are indexable
    el['on' + event] = null;
}
function outerHeight(node /*: HTMLElement*/ ) /*: number*/ {
    // This is deliberately excluding margin for our calculations, since we are using
    // offsetTop which is including margin. See getBoundPosition
    var height = node.clientHeight;
    var computedStyle = node.ownerDocument.defaultView.getComputedStyle(node);
    height += (0, _shims.int)(computedStyle.borderTopWidth);
    height += (0, _shims.int)(computedStyle.borderBottomWidth);
    return height;
}
function outerWidth(node /*: HTMLElement*/ ) /*: number*/ {
    // This is deliberately excluding margin for our calculations, since we are using
    // offsetLeft which is including margin. See getBoundPosition
    var width = node.clientWidth;
    var computedStyle = node.ownerDocument.defaultView.getComputedStyle(node);
    width += (0, _shims.int)(computedStyle.borderLeftWidth);
    width += (0, _shims.int)(computedStyle.borderRightWidth);
    return width;
}
function innerHeight(node /*: HTMLElement*/ ) /*: number*/ {
    var height = node.clientHeight;
    var computedStyle = node.ownerDocument.defaultView.getComputedStyle(node);
    height -= (0, _shims.int)(computedStyle.paddingTop);
    height -= (0, _shims.int)(computedStyle.paddingBottom);
    return height;
}
function innerWidth(node /*: HTMLElement*/ ) /*: number*/ {
    var width = node.clientWidth;
    var computedStyle = node.ownerDocument.defaultView.getComputedStyle(node);
    width -= (0, _shims.int)(computedStyle.paddingLeft);
    width -= (0, _shims.int)(computedStyle.paddingRight);
    return width;
}
/*:: interface EventWithOffset {
  clientX: number, clientY: number
}*/ // Get from offsetParent
function offsetXYFromParent(evt /*: EventWithOffset*/ , offsetParent /*: HTMLElement*/ , scale /*: number*/ ) /*: ControlPosition*/ {
    var isBody = offsetParent === offsetParent.ownerDocument.body;
    var offsetParentRect = isBody ? {
        left: 0,
        top: 0
    } : offsetParent.getBoundingClientRect();
    var x = (evt.clientX + offsetParent.scrollLeft - offsetParentRect.left) / scale;
    var y = (evt.clientY + offsetParent.scrollTop - offsetParentRect.top) / scale;
    return {
        x: x,
        y: y
    };
}
function createCSSTransform(controlPos /*: ControlPosition*/ , positionOffset /*: PositionOffsetControlPosition*/ ) /*: Object*/ {
    var translation = getTranslation(controlPos, positionOffset, 'px');
    return (0, _defineProperty._)({}, (0, _getPrefix.browserPrefixToKey)('transform', _getPrefix.default), translation);
}
function createSVGTransform(controlPos /*: ControlPosition*/ , positionOffset /*: PositionOffsetControlPosition*/ ) /*: string*/ {
    var translation = getTranslation(controlPos, positionOffset, '');
    return translation;
}
function getTranslation(_ref /*:: */ , positionOffset /*: PositionOffsetControlPosition*/ , unitSuffix /*: string*/ ) /*: string*/ {
    var x = _ref /*: ControlPosition*/ .x, y = _ref.y;
    var translation = "translate(".concat(x).concat(unitSuffix, ",").concat(y).concat(unitSuffix, ")");
    if (positionOffset) {
        var defaultX = "".concat(typeof positionOffset.x === 'string' ? positionOffset.x : positionOffset.x + unitSuffix);
        var defaultY = "".concat(typeof positionOffset.y === 'string' ? positionOffset.y : positionOffset.y + unitSuffix);
        translation = "translate(".concat(defaultX, ", ").concat(defaultY, ")") + translation;
    }
    return translation;
}
function getTouch(e /*: MouseTouchEvent*/ , identifier /*: number*/ ) /*: ?{clientX: number, clientY: number}*/ {
    return e.targetTouches && (0, _shims.findInArray)(e.targetTouches, function(t) {
        return identifier === t.identifier;
    }) || e.changedTouches && (0, _shims.findInArray)(e.changedTouches, function(t) {
        return identifier === t.identifier;
    });
}
function getTouchIdentifier(e /*: MouseTouchEvent*/ ) /*: ?number*/ {
    if (e.targetTouches && e.targetTouches[0]) return e.targetTouches[0].identifier;
    if (e.changedTouches && e.changedTouches[0]) return e.changedTouches[0].identifier;
}
// User-select Hacks:
//
// Useful for preventing blue highlights all over everything when dragging.
// Note we're passing `document` b/c we could be iframed
function addUserSelectStyles(doc /*: ?Document*/ ) {
    if (!doc) return;
    var styleEl = doc.getElementById('react-draggable-style-el');
    if (!styleEl) {
        styleEl = doc.createElement('style');
        styleEl.type = 'text/css';
        styleEl.id = 'react-draggable-style-el';
        styleEl.innerHTML = '.react-draggable-transparent-selection *::-moz-selection {all: inherit;}\n';
        styleEl.innerHTML += '.react-draggable-transparent-selection *::selection {all: inherit;}\n';
        doc.getElementsByTagName('head')[0].appendChild(styleEl);
    }
    if (doc.body) addClassName(doc.body, 'react-draggable-transparent-selection');
}
function removeUserSelectStyles(doc /*: ?Document*/ ) {
    if (!doc) return;
    try {
        if (doc.body) removeClassName(doc.body, 'react-draggable-transparent-selection');
        // $FlowIgnore: IE
        if (doc.selection) // $FlowIgnore: IE
        doc.selection.empty();
        else {
            // Remove selection caused by scroll, unless it's a focused input
            // (we use doc.defaultView in case we're in an iframe)
            var selection = (doc.defaultView || window).getSelection();
            if (selection && selection.type !== 'Caret') selection.removeAllRanges();
        }
    } catch (e) {
    // probably IE
    }
}
function addClassName(el /*: HTMLElement*/ , className /*: string*/ ) {
    if (el.classList) el.classList.add(className);
    else if (!el.className.match(new RegExp("(?:^|\\s)".concat(className, "(?!\\S)")))) el.className += " ".concat(className);
}
function removeClassName(el /*: HTMLElement*/ , className /*: string*/ ) {
    if (el.classList) el.classList.remove(className);
    else el.className = el.className.replace(new RegExp("(?:^|\\s)".concat(className, "(?!\\S)"), 'g'), '');
}

},{"@swc/helpers/_/_define_property":"dmvty","@swc/helpers/_/_object_spread":"7ZOov","@swc/helpers/_/_type_of":"cYs4R","af60d0462ec484c0":"79bOz","25bee73a12bb5ee8":"gfU4q"}],"79bOz":[function(require,module,exports,__globalThis) {
"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.dontSetMe = dontSetMe;
exports.findInArray = findInArray;
exports.int = int;
exports.isFunction = isFunction;
exports.isNum = isNum;
// @credits https://gist.github.com/rogozhnikoff/a43cfed27c41e4e68cdc
function findInArray(array /*: Array<any> | TouchList*/ , callback /*: Function*/ ) /*: any*/ {
    for(var i = 0, length = array.length; i < length; i++){
        if (callback.apply(callback, [
            array[i],
            i,
            array
        ])) return array[i];
    }
}
function isFunction(func /*: any*/ ) /*: boolean %checks*/ {
    // $FlowIgnore[method-unbinding]
    return typeof func === 'function' || Object.prototype.toString.call(func) === '[object Function]';
}
function isNum(num /*: any*/ ) /*: boolean %checks*/ {
    return typeof num === 'number' && !isNaN(num);
}
function int(a /*: string*/ ) /*: number*/ {
    return parseInt(a, 10);
}
function dontSetMe(props /*: Object*/ , propName /*: string*/ , componentName /*: string*/ ) /*: ?Error*/ {
    if (props[propName]) return new Error("Invalid prop ".concat(propName, " passed to ").concat(componentName, " - do not set this, set it on the child."));
}

},{}],"gfU4q":[function(require,module,exports,__globalThis) {
"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.browserPrefixToKey = browserPrefixToKey;
exports.browserPrefixToStyle = browserPrefixToStyle;
exports.default = void 0;
exports.getPrefix = getPrefix;
var prefixes = [
    'Moz',
    'Webkit',
    'O',
    'ms'
];
function getPrefix() /*: string*/ {
    var _window$document;
    var prop /*: string*/  = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 'transform';
    // Ensure we're running in an environment where there is actually a global
    // `window` obj
    if (typeof window === 'undefined') return '';
    // If we're in a pseudo-browser server-side environment, this access
    // path may not exist, so bail out if it doesn't.
    var style = (_window$document = window.document) === null || _window$document === void 0 || (_window$document = _window$document.documentElement) === null || _window$document === void 0 ? void 0 : _window$document.style;
    if (!style) return '';
    if (prop in style) return '';
    for(var i = 0; i < prefixes.length; i++){
        if (browserPrefixToKey(prop, prefixes[i]) in style) return prefixes[i];
    }
    return '';
}
function browserPrefixToKey(prop /*: string*/ , prefix /*: string*/ ) /*: string*/ {
    return prefix ? "".concat(prefix).concat(kebabToTitleCase(prop)) : prop;
}
function browserPrefixToStyle(prop /*: string*/ , prefix /*: string*/ ) /*: string*/ {
    return prefix ? "-".concat(prefix.toLowerCase(), "-").concat(prop) : prop;
}
function kebabToTitleCase(str /*: string*/ ) /*: string*/ {
    var out = '';
    var shouldCapitalize = true;
    for(var i = 0; i < str.length; i++){
        if (shouldCapitalize) {
            out += str[i].toUpperCase();
            shouldCapitalize = false;
        } else if (str[i] === '-') shouldCapitalize = true;
        else out += str[i];
    }
    return out;
}
// Default export is the prefix itself, like 'Moz', 'Webkit', etc
// Note that you may have to re-test for certain things; for instance, Chrome 50
// can handle unprefixed `transform`, but not unprefixed `user-select`
var _default = exports.default = getPrefix();

},{}],"69Uv7":[function(require,module,exports,__globalThis) {
"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.canDragX = canDragX;
exports.canDragY = canDragY;
exports.createCoreData = createCoreData;
exports.createDraggableData = createDraggableData;
exports.getBoundPosition = getBoundPosition;
exports.getControlPosition = getControlPosition;
exports.snapToGrid = snapToGrid;
var _shims = require("44bb88b39f2262ab");
var _domFns = require("6d8383fdeb613c7c");
/*:: import type Draggable from '../Draggable';*/ /*:: import type {Bounds, ControlPosition, DraggableData, MouseTouchEvent} from './types';*/ /*:: import type DraggableCore from '../DraggableCore';*/ function getBoundPosition(draggable /*: Draggable*/ , x /*: number*/ , y /*: number*/ ) /*: [number, number]*/ {
    // If no bounds, short-circuit and move on
    if (!draggable.props.bounds) return [
        x,
        y
    ];
    // Clone new bounds
    var bounds = draggable.props.bounds;
    bounds = typeof bounds === 'string' ? bounds : cloneBounds(bounds);
    var node = findDOMNode(draggable);
    if (typeof bounds === 'string') {
        var ownerDocument = node.ownerDocument;
        var ownerWindow = ownerDocument.defaultView;
        var boundNode;
        if (bounds === 'parent') boundNode = node.parentNode;
        else boundNode = ownerDocument.querySelector(bounds);
        if (!(boundNode instanceof ownerWindow.HTMLElement)) throw new Error('Bounds selector "' + bounds + '" could not find an element.');
        var boundNodeEl /*: HTMLElement*/  = boundNode; // for Flow, can't seem to refine correctly
        var nodeStyle = ownerWindow.getComputedStyle(node);
        var boundNodeStyle = ownerWindow.getComputedStyle(boundNodeEl);
        // Compute bounds. This is a pain with padding and offsets but this gets it exactly right.
        bounds = {
            left: -node.offsetLeft + (0, _shims.int)(boundNodeStyle.paddingLeft) + (0, _shims.int)(nodeStyle.marginLeft),
            top: -node.offsetTop + (0, _shims.int)(boundNodeStyle.paddingTop) + (0, _shims.int)(nodeStyle.marginTop),
            right: (0, _domFns.innerWidth)(boundNodeEl) - (0, _domFns.outerWidth)(node) - node.offsetLeft + (0, _shims.int)(boundNodeStyle.paddingRight) - (0, _shims.int)(nodeStyle.marginRight),
            bottom: (0, _domFns.innerHeight)(boundNodeEl) - (0, _domFns.outerHeight)(node) - node.offsetTop + (0, _shims.int)(boundNodeStyle.paddingBottom) - (0, _shims.int)(nodeStyle.marginBottom)
        };
    }
    // Keep x and y below right and bottom limits...
    if ((0, _shims.isNum)(bounds.right)) x = Math.min(x, bounds.right);
    if ((0, _shims.isNum)(bounds.bottom)) y = Math.min(y, bounds.bottom);
    // But above left and top limits.
    if ((0, _shims.isNum)(bounds.left)) x = Math.max(x, bounds.left);
    if ((0, _shims.isNum)(bounds.top)) y = Math.max(y, bounds.top);
    return [
        x,
        y
    ];
}
function snapToGrid(grid /*: [number, number]*/ , pendingX /*: number*/ , pendingY /*: number*/ ) /*: [number, number]*/ {
    var x = Math.round(pendingX / grid[0]) * grid[0];
    var y = Math.round(pendingY / grid[1]) * grid[1];
    return [
        x,
        y
    ];
}
function canDragX(draggable /*: Draggable*/ ) /*: boolean*/ {
    return draggable.props.axis === 'both' || draggable.props.axis === 'x';
}
function canDragY(draggable /*: Draggable*/ ) /*: boolean*/ {
    return draggable.props.axis === 'both' || draggable.props.axis === 'y';
}
// Get {x, y} positions from event.
function getControlPosition(e /*: MouseTouchEvent*/ , touchIdentifier /*: ?number*/ , draggableCore /*: DraggableCore*/ ) /*: ?ControlPosition*/ {
    var touchObj = typeof touchIdentifier === 'number' ? (0, _domFns.getTouch)(e, touchIdentifier) : null;
    if (typeof touchIdentifier === 'number' && !touchObj) return null; // not the right touch
    var node = findDOMNode(draggableCore);
    // User can provide an offsetParent if desired.
    var offsetParent = draggableCore.props.offsetParent || node.offsetParent || node.ownerDocument.body;
    return (0, _domFns.offsetXYFromParent)(touchObj || e, offsetParent, draggableCore.props.scale);
}
// Create an data object exposed by <DraggableCore>'s events
function createCoreData(draggable /*: DraggableCore*/ , x /*: number*/ , y /*: number*/ ) /*: DraggableData*/ {
    var isStart = !(0, _shims.isNum)(draggable.lastX);
    var node = findDOMNode(draggable);
    if (isStart) // If this is our first move, use the x and y as last coords.
    return {
        node: node,
        deltaX: 0,
        deltaY: 0,
        lastX: x,
        lastY: y,
        x: x,
        y: y
    };
    else // Otherwise calculate proper values.
    return {
        node: node,
        deltaX: x - draggable.lastX,
        deltaY: y - draggable.lastY,
        lastX: draggable.lastX,
        lastY: draggable.lastY,
        x: x,
        y: y
    };
}
// Create an data exposed by <Draggable>'s events
function createDraggableData(draggable /*: Draggable*/ , coreData /*: DraggableData*/ ) /*: DraggableData*/ {
    var scale = draggable.props.scale;
    return {
        node: coreData.node,
        x: draggable.state.x + coreData.deltaX / scale,
        y: draggable.state.y + coreData.deltaY / scale,
        deltaX: coreData.deltaX / scale,
        deltaY: coreData.deltaY / scale,
        lastX: draggable.state.x,
        lastY: draggable.state.y
    };
}
// A lot faster than stringify/parse
function cloneBounds(bounds /*: Bounds*/ ) /*: Bounds*/ {
    return {
        left: bounds.left,
        top: bounds.top,
        right: bounds.right,
        bottom: bounds.bottom
    };
}
function findDOMNode(draggable /*: Draggable | DraggableCore*/ ) /*: HTMLElement*/ {
    var node = draggable.findDOMNode();
    if (!node) throw new Error('<DraggableCore>: Unmounted during event!');
    // $FlowIgnore we can't assert on HTMLElement due to tests... FIXME
    return node;
}

},{"44bb88b39f2262ab":"79bOz","6d8383fdeb613c7c":"azx9g"}],"8qL5z":[function(require,module,exports,__globalThis) {
var _callSuper = require("@swc/helpers/_/_call_super");
var _classCallCheck = require("@swc/helpers/_/_class_call_check");
var _createClass = require("@swc/helpers/_/_create_class");
var _inherits = require("@swc/helpers/_/_inherits");
var _slicedToArray = require("@swc/helpers/_/_sliced_to_array");
var _typeOf = require("@swc/helpers/_/_type_of");
"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = void 0;
var React = _interopRequireWildcard(require("d830172ba8d01674"));
var _propTypes = _interopRequireDefault(require("936051a0e8f63cef"));
var _reactDom = _interopRequireDefault(require("51e89cac1fd8612a"));
var _domFns = require("a60a19bd70f37cbe");
var _positionFns = require("32cd453cf02f7977");
var _shims = require("b3ef123d6f743aa4");
var _log = _interopRequireDefault(require("71bc142b940fef0c"));
function _interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
function _getRequireWildcardCache(nodeInterop) {
    if (typeof WeakMap !== "function") return null;
    var cacheBabelInterop = new WeakMap();
    var cacheNodeInterop = new WeakMap();
    return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) {
        return nodeInterop ? cacheNodeInterop : cacheBabelInterop;
    })(nodeInterop);
}
function _interopRequireWildcard(obj, nodeInterop) {
    if (!nodeInterop && obj && obj.__esModule) return obj;
    if (obj === null || (typeof obj === "undefined" ? "undefined" : (0, _typeOf._)(obj)) !== "object" && typeof obj !== "function") return {
        default: obj
    };
    var cache = _getRequireWildcardCache(nodeInterop);
    if (cache && cache.has(obj)) return cache.get(obj);
    var newObj = {};
    var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor;
    for(var key in obj)if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) {
        var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null;
        if (desc && (desc.get || desc.set)) Object.defineProperty(newObj, key, desc);
        else newObj[key] = obj[key];
    }
    newObj.default = obj;
    if (cache) cache.set(obj, newObj);
    return newObj;
}
function _defineProperty(obj, key, value) {
    key = _toPropertyKey(key);
    if (key in obj) Object.defineProperty(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
    });
    else obj[key] = value;
    return obj;
}
function _toPropertyKey(arg) {
    var key = _toPrimitive(arg, "string");
    return (typeof key === "undefined" ? "undefined" : (0, _typeOf._)(key)) === "symbol" ? key : String(key);
}
function _toPrimitive(input, hint) {
    if ((typeof input === "undefined" ? "undefined" : (0, _typeOf._)(input)) !== "object" || input === null) return input;
    var prim = input[Symbol.toPrimitive];
    if (prim !== undefined) {
        var res = prim.call(input, hint || "default");
        if ((typeof res === "undefined" ? "undefined" : (0, _typeOf._)(res)) !== "object") return res;
        throw new TypeError("@@toPrimitive must return a primitive value.");
    }
    return (hint === "string" ? String : Number)(input);
}
/*:: import type {EventHandler, MouseTouchEvent} from './utils/types';*/ /*:: import type {Element as ReactElement} from 'react';*/ // Simple abstraction for dragging events names.
var eventsFor = {
    touch: {
        start: 'touchstart',
        move: 'touchmove',
        stop: 'touchend'
    },
    mouse: {
        start: 'mousedown',
        move: 'mousemove',
        stop: 'mouseup'
    }
};
// Default to mouse events.
var dragEventFor = eventsFor.mouse;
/*:: export type DraggableData = {
  node: HTMLElement,
  x: number, y: number,
  deltaX: number, deltaY: number,
  lastX: number, lastY: number,
};*/ /*:: export type DraggableEventHandler = (e: MouseEvent, data: DraggableData) => void | false;*/ /*:: export type ControlPosition = {x: number, y: number};*/ /*:: export type PositionOffsetControlPosition = {x: number|string, y: number|string};*/ /*:: export type DraggableCoreDefaultProps = {
  allowAnyClick: boolean,
  disabled: boolean,
  enableUserSelectHack: boolean,
  onStart: DraggableEventHandler,
  onDrag: DraggableEventHandler,
  onStop: DraggableEventHandler,
  onMouseDown: (e: MouseEvent) => void,
  scale: number,
};*/ /*:: export type DraggableCoreProps = {
  ...DraggableCoreDefaultProps,
  cancel: string,
  children: ReactElement<any>,
  offsetParent: HTMLElement,
  grid: [number, number],
  handle: string,
  nodeRef?: ?React.ElementRef<any>,
};*/ //
// Define <DraggableCore>.
//
// <DraggableCore> is for advanced usage of <Draggable>. It maintains minimal internal state so it can
// work well with libraries that require more control over the element.
//
var DraggableCore = /*#__PURE__*/ function(_React_Component) {
    (0, _inherits._)(DraggableCore, _React_Component);
    function DraggableCore() {
        (0, _classCallCheck._)(this, DraggableCore);
        var _this;
        _this = (0, _callSuper._)(this, DraggableCore, arguments);
        _defineProperty(_this, "dragging", false);
        // Used while dragging to determine deltas.
        _defineProperty(_this, "lastX", NaN);
        _defineProperty(_this, "lastY", NaN);
        _defineProperty(_this, "touchIdentifier", null);
        _defineProperty(_this, "mounted", false);
        _defineProperty(_this, "handleDragStart", function(e) {
            // Make it possible to attach event handlers on top of this one.
            _this.props.onMouseDown(e);
            // Only accept left-clicks.
            if (!_this.props.allowAnyClick && typeof e.button === 'number' && e.button !== 0) return false;
            // Get nodes. Be sure to grab relative document (could be iframed)
            var thisNode = _this.findDOMNode();
            if (!thisNode || !thisNode.ownerDocument || !thisNode.ownerDocument.body) throw new Error('<DraggableCore> not mounted on DragStart!');
            var ownerDocument = thisNode.ownerDocument;
            // Short circuit if handle or cancel prop was provided and selector doesn't match.
            if (_this.props.disabled || !(e.target instanceof ownerDocument.defaultView.Node) || _this.props.handle && !(0, _domFns.matchesSelectorAndParentsTo)(e.target, _this.props.handle, thisNode) || _this.props.cancel && (0, _domFns.matchesSelectorAndParentsTo)(e.target, _this.props.cancel, thisNode)) return;
            // Prevent scrolling on mobile devices, like ipad/iphone.
            // Important that this is after handle/cancel.
            if (e.type === 'touchstart') e.preventDefault();
            // Set touch identifier in component state if this is a touch event. This allows us to
            // distinguish between individual touches on multitouch screens by identifying which
            // touchpoint was set to this element.
            var touchIdentifier = (0, _domFns.getTouchIdentifier)(e);
            _this.touchIdentifier = touchIdentifier;
            // Get the current drag point from the event. This is used as the offset.
            var position = (0, _positionFns.getControlPosition)(e, touchIdentifier, _this);
            if (position == null) return; // not possible but satisfies flow
            var x = position.x, y = position.y;
            // Create an event object with all the data parents need to make a decision here.
            var coreEvent = (0, _positionFns.createCoreData)(_this, x, y);
            (0, _log.default)('DraggableCore: handleDragStart: %j', coreEvent);
            // Call event handler. If it returns explicit false, cancel.
            (0, _log.default)('calling', _this.props.onStart);
            var shouldUpdate = _this.props.onStart(e, coreEvent);
            if (shouldUpdate === false || _this.mounted === false) return;
            // Add a style to the body to disable user-select. This prevents text from
            // being selected all over the page.
            if (_this.props.enableUserSelectHack) (0, _domFns.addUserSelectStyles)(ownerDocument);
            // Initiate dragging. Set the current x and y as offsets
            // so we know how much we've moved during the drag. This allows us
            // to drag elements around even if they have been moved, without issue.
            _this.dragging = true;
            _this.lastX = x;
            _this.lastY = y;
            // Add events to the document directly so we catch when the user's mouse/touch moves outside of
            // this element. We use different events depending on whether or not we have detected that this
            // is a touch-capable device.
            (0, _domFns.addEvent)(ownerDocument, dragEventFor.move, _this.handleDrag);
            (0, _domFns.addEvent)(ownerDocument, dragEventFor.stop, _this.handleDragStop);
        });
        _defineProperty(_this, "handleDrag", function(e) {
            // Get the current drag point from the event. This is used as the offset.
            var position = (0, _positionFns.getControlPosition)(e, _this.touchIdentifier, _this);
            if (position == null) return;
            var x = position.x, y = position.y;
            // Snap to grid if prop has been provided
            if (Array.isArray(_this.props.grid)) {
                var deltaX = x - _this.lastX, deltaY = y - _this.lastY;
                var ref;
                ref = (0, _slicedToArray._)((0, _positionFns.snapToGrid)(_this.props.grid, deltaX, deltaY), 2), deltaX = ref[0], deltaY = ref[1], ref;
                if (!deltaX && !deltaY) return; // skip useless drag
                x = _this.lastX + deltaX, y = _this.lastY + deltaY;
            }
            var coreEvent = (0, _positionFns.createCoreData)(_this, x, y);
            (0, _log.default)('DraggableCore: handleDrag: %j', coreEvent);
            // Call event handler. If it returns explicit false, trigger end.
            var shouldUpdate = _this.props.onDrag(e, coreEvent);
            if (shouldUpdate === false || _this.mounted === false) {
                try {
                    // $FlowIgnore
                    _this.handleDragStop(new MouseEvent('mouseup'));
                } catch (err) {
                    // Old browsers
                    var event = document.createEvent('MouseEvents');
                    // I see why this insanity was deprecated
                    // $FlowIgnore
                    event.initMouseEvent('mouseup', true, true, window, 0, 0, 0, 0, 0, false, false, false, false, 0, null);
                    _this.handleDragStop(event);
                }
                return;
            }
            _this.lastX = x;
            _this.lastY = y;
        });
        _defineProperty(_this, "handleDragStop", function(e) {
            if (!_this.dragging) return;
            var position = (0, _positionFns.getControlPosition)(e, _this.touchIdentifier, _this);
            if (position == null) return;
            var x = position.x, y = position.y;
            // Snap to grid if prop has been provided
            if (Array.isArray(_this.props.grid)) {
                var deltaX = x - _this.lastX || 0;
                var deltaY = y - _this.lastY || 0;
                var ref;
                ref = (0, _slicedToArray._)((0, _positionFns.snapToGrid)(_this.props.grid, deltaX, deltaY), 2), deltaX = ref[0], deltaY = ref[1], ref;
                x = _this.lastX + deltaX, y = _this.lastY + deltaY;
            }
            var coreEvent = (0, _positionFns.createCoreData)(_this, x, y);
            // Call event handler
            var shouldContinue = _this.props.onStop(e, coreEvent);
            if (shouldContinue === false || _this.mounted === false) return false;
            var thisNode = _this.findDOMNode();
            if (thisNode) // Remove user-select hack
            {
                if (_this.props.enableUserSelectHack) (0, _domFns.removeUserSelectStyles)(thisNode.ownerDocument);
            }
            (0, _log.default)('DraggableCore: handleDragStop: %j', coreEvent);
            // Reset the el.
            _this.dragging = false;
            _this.lastX = NaN;
            _this.lastY = NaN;
            if (thisNode) {
                // Remove event handlers
                (0, _log.default)('DraggableCore: Removing handlers');
                (0, _domFns.removeEvent)(thisNode.ownerDocument, dragEventFor.move, _this.handleDrag);
                (0, _domFns.removeEvent)(thisNode.ownerDocument, dragEventFor.stop, _this.handleDragStop);
            }
        });
        _defineProperty(_this, "onMouseDown", function(e) {
            dragEventFor = eventsFor.mouse; // on touchscreen laptops we could switch back to mouse
            return _this.handleDragStart(e);
        });
        _defineProperty(_this, "onMouseUp", function(e) {
            dragEventFor = eventsFor.mouse;
            return _this.handleDragStop(e);
        });
        // Same as onMouseDown (start drag), but now consider this a touch device.
        _defineProperty(_this, "onTouchStart", function(e) {
            // We're on a touch device now, so change the event handlers
            dragEventFor = eventsFor.touch;
            return _this.handleDragStart(e);
        });
        _defineProperty(_this, "onTouchEnd", function(e) {
            // We're on a touch device now, so change the event handlers
            dragEventFor = eventsFor.touch;
            return _this.handleDragStop(e);
        });
        return _this;
    }
    (0, _createClass._)(DraggableCore, [
        {
            key: "componentDidMount",
            value: function componentDidMount() {
                this.mounted = true;
                // Touch handlers must be added with {passive: false} to be cancelable.
                // https://developers.google.com/web/updates/2017/01/scrolling-intervention
                var thisNode = this.findDOMNode();
                if (thisNode) (0, _domFns.addEvent)(thisNode, eventsFor.touch.start, this.onTouchStart, {
                    passive: false
                });
            }
        },
        {
            key: "componentWillUnmount",
            value: function componentWillUnmount() {
                this.mounted = false;
                // Remove any leftover event handlers. Remove both touch and mouse handlers in case
                // some browser quirk caused a touch event to fire during a mouse move, or vice versa.
                var thisNode = this.findDOMNode();
                if (thisNode) {
                    var ownerDocument = thisNode.ownerDocument;
                    (0, _domFns.removeEvent)(ownerDocument, eventsFor.mouse.move, this.handleDrag);
                    (0, _domFns.removeEvent)(ownerDocument, eventsFor.touch.move, this.handleDrag);
                    (0, _domFns.removeEvent)(ownerDocument, eventsFor.mouse.stop, this.handleDragStop);
                    (0, _domFns.removeEvent)(ownerDocument, eventsFor.touch.stop, this.handleDragStop);
                    (0, _domFns.removeEvent)(thisNode, eventsFor.touch.start, this.onTouchStart, {
                        passive: false
                    });
                    if (this.props.enableUserSelectHack) (0, _domFns.removeUserSelectStyles)(ownerDocument);
                }
            }
        },
        {
            // React Strict Mode compatibility: if `nodeRef` is passed, we will use it instead of trying to find
            // the underlying DOM node ourselves. See the README for more information.
            key: "findDOMNode",
            value: function findDOMNode() /*: ?HTMLElement*/ {
                var _this$props, _this$props2;
                return (_this$props = this.props) !== null && _this$props !== void 0 && _this$props.nodeRef ? (_this$props2 = this.props) === null || _this$props2 === void 0 || (_this$props2 = _this$props2.nodeRef) === null || _this$props2 === void 0 ? void 0 : _this$props2.current : _reactDom.default.findDOMNode(this);
            }
        },
        {
            key: "render",
            value: function render() /*: React.Element<any>*/ {
                // Reuse the child provided
                // This makes it flexible to use whatever element is wanted (div, ul, etc)
                return /*#__PURE__*/ React.cloneElement(React.Children.only(this.props.children), {
                    // Note: mouseMove handler is attached to document so it will still function
                    // when the user drags quickly and leaves the bounds of the element.
                    onMouseDown: this.onMouseDown,
                    onMouseUp: this.onMouseUp,
                    // onTouchStart is added on `componentDidMount` so they can be added with
                    // {passive: false}, which allows it to cancel. See
                    // https://developers.google.com/web/updates/2017/01/scrolling-intervention
                    onTouchEnd: this.onTouchEnd
                });
            }
        }
    ]);
    return DraggableCore;
}(React.Component /*:: <DraggableCoreProps>*/ );
exports.default = DraggableCore;
_defineProperty(DraggableCore, "displayName", 'DraggableCore');
_defineProperty(DraggableCore, "propTypes", {
    /**
   * `allowAnyClick` allows dragging using any mouse button.
   * By default, we only accept the left button.
   *
   * Defaults to `false`.
   */ allowAnyClick: _propTypes.default.bool,
    children: _propTypes.default.node.isRequired,
    /**
   * `disabled`, if true, stops the <Draggable> from dragging. All handlers,
   * with the exception of `onMouseDown`, will not fire.
   */ disabled: _propTypes.default.bool,
    /**
   * By default, we add 'user-select:none' attributes to the document body
   * to prevent ugly text selection during drag. If this is causing problems
   * for your app, set this to `false`.
   */ enableUserSelectHack: _propTypes.default.bool,
    /**
   * `offsetParent`, if set, uses the passed DOM node to compute drag offsets
   * instead of using the parent node.
   */ offsetParent: function offsetParent(props /*: DraggableCoreProps*/ , propName /*: $Keys<DraggableCoreProps>*/ ) {
        if (props[propName] && props[propName].nodeType !== 1) throw new Error('Draggable\'s offsetParent must be a DOM Node.');
    },
    /**
   * `grid` specifies the x and y that dragging should snap to.
   */ grid: _propTypes.default.arrayOf(_propTypes.default.number),
    /**
   * `handle` specifies a selector to be used as the handle that initiates drag.
   *
   * Example:
   *
   * ```jsx
   *   let App = React.createClass({
   *       render: function () {
   *         return (
   *            <Draggable handle=".handle">
   *              <div>
   *                  <div className="handle">Click me to drag</div>
   *                  <div>This is some other content</div>
   *              </div>
   *           </Draggable>
   *         );
   *       }
   *   });
   * ```
   */ handle: _propTypes.default.string,
    /**
   * `cancel` specifies a selector to be used to prevent drag initialization.
   *
   * Example:
   *
   * ```jsx
   *   let App = React.createClass({
   *       render: function () {
   *           return(
   *               <Draggable cancel=".cancel">
   *                   <div>
   *                     <div className="cancel">You can't drag from here</div>
   *                     <div>Dragging here works fine</div>
   *                   </div>
   *               </Draggable>
   *           );
   *       }
   *   });
   * ```
   */ cancel: _propTypes.default.string,
    /* If running in React Strict mode, ReactDOM.findDOMNode() is deprecated.
   * Unfortunately, in order for <Draggable> to work properly, we need raw access
   * to the underlying DOM node. If you want to avoid the warning, pass a `nodeRef`
   * as in this example:
   *
   * function MyComponent() {
   *   const nodeRef = React.useRef(null);
   *   return (
   *     <Draggable nodeRef={nodeRef}>
   *       <div ref={nodeRef}>Example Target</div>
   *     </Draggable>
   *   );
   * }
   *
   * This can be used for arbitrarily nested components, so long as the ref ends up
   * pointing to the actual child DOM node and not a custom component.
   */ nodeRef: _propTypes.default.object,
    /**
   * Called when dragging starts.
   * If this function returns the boolean false, dragging will be canceled.
   */ onStart: _propTypes.default.func,
    /**
   * Called while dragging.
   * If this function returns the boolean false, dragging will be canceled.
   */ onDrag: _propTypes.default.func,
    /**
   * Called when dragging stops.
   * If this function returns the boolean false, the drag will remain active.
   */ onStop: _propTypes.default.func,
    /**
   * A workaround option which can be passed if onMouseDown needs to be accessed,
   * since it'll always be blocked (as there is internal use of onMouseDown)
   */ onMouseDown: _propTypes.default.func,
    /**
   * `scale`, if set, applies scaling while dragging an element
   */ scale: _propTypes.default.number,
    /**
   * These properties should be defined on the child, not here.
   */ className: _shims.dontSetMe,
    style: _shims.dontSetMe,
    transform: _shims.dontSetMe
});
_defineProperty(DraggableCore, "defaultProps", {
    allowAnyClick: false,
    // by default only accept left click
    disabled: false,
    enableUserSelectHack: true,
    onStart: function onStart() {},
    onDrag: function onDrag() {},
    onStop: function onStop() {},
    onMouseDown: function onMouseDown() {},
    scale: 1
});

},{"@swc/helpers/_/_call_super":"6D4Bs","@swc/helpers/_/_class_call_check":"4fJVn","@swc/helpers/_/_create_class":"LhYkq","@swc/helpers/_/_inherits":"YAPwf","@swc/helpers/_/_sliced_to_array":"5Sh31","@swc/helpers/_/_type_of":"cYs4R","d830172ba8d01674":"gjea9","936051a0e8f63cef":"kMWEB","51e89cac1fd8612a":"b9022","a60a19bd70f37cbe":"azx9g","32cd453cf02f7977":"69Uv7","b3ef123d6f743aa4":"79bOz","71bc142b940fef0c":"iVF5L"}],"iVF5L":[function(require,module,exports,__globalThis) {
"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = log;
/*eslint no-console:0*/ function log() {}

},{}],"aSEXp":[function(require,module,exports,__globalThis) {
module.exports = JSON.parse("{\"name\":\"carussel-modularization\",\"version\":\"5.5.2\",\"description\":\"\",\"typeRoot\":\"\",\"targets\":{\"node\":{\"context\":\"node\",\"outputFormat\":\"commonjs\",\"distDir\":\"./dist/server\"},\"default\":{\"source\":[\"./src/dwt-app.ts\",\"./src/service-worker.ts\",\"./src/index.html\"],\"distDir\":\"./dist\",\"publicUrl\":\"./\"},\"main\":false},\"alias\":{\"yamlparser\":false,\"punycode\":false,\"pseudomap\":false},\"scripts\":{\"clean:dist\":\"rimraf dist\",\"clean:tmp\":\"rimraf .tmp\",\"clean:cache\":\"rimraf .parcel-cache\",\"clean:serve\":\"rimraf serve\",\"clean\":\"run-p clean:*\",\"format\":\"prettier src/**/*.{ts,tsx} --write\",\"lint:prettier\":\"prettier src/**/*.{ts,tsx} --check\",\"tslint\":\"tslint --project tsconfig.json\",\"lint:stylelint\":\"stylelint src/**/*.{ts,tsx}\",\"lint:eslint\":\"eslint src/**/*.{ts,tsx} --cache --cache-location .tmp/.eslintcache --quiet\",\"lint\":\"run-p --aggregate-output lint:*\",\"build:app\":\"parcel build --no-scope-hoist\",\"build:server\":\"parcel build ./src/server/index.ts --target node --dist-dir ./dist/server\",\"build\":\"run-s clean lint build:*\",\"gcp-build\":\"\",\"serve:demo\":\"parcel ./src/index.html --dist-dir ./serve --port 3000 --no-cache\",\"serve\":\"run-s clean:serve clean:cache serve:*\",\"deploy:dev\":\"gcloud app deploy app.dev.yaml --project carussel-dwt --no-promote\",\"deploy:prod\":\"gcloud app deploy app.yaml --project carussel-dwt --no-promote\",\"deploy:staging\":\"gcloud app deploy app.staging.yaml --project carussel-dwt --no-promote\",\"ci:deploy:dev:master\":\"gcloud app deploy app.dev.yaml --project carussel-dwt --version master --no-promote --quiet\",\"ci:deploy:staging:master\":\"gcloud app deploy app.staging.yaml --project carussel-dwt --version master --no-promote --quiet\",\"ci:deploy:dev:beta\":\"gcloud app deploy app.dev.yaml --project carussel-dwt --version beta --no-promote --quiet\",\"ci:deploy:staging:beta\":\"gcloud app deploy app.staging.yaml --project carussel-dwt --version beta --no-promote --quiet\",\"ci:deploy:dev:stable\":\"gcloud app deploy app.dev.yaml --project carussel-dwt --version stable --no-promote --quiet\",\"ci:deploy:staging:stable\":\"gcloud app deploy app.staging.yaml --project carussel-dwt --version stable --no-promote --quiet\",\"postversion\":\"node ./script/setup-gae-version.js\",\"release:deploy\":\"npm run deploy:prod -- --version=%npm_config_gae_version%\",\"release\":\"npm ci && npm run clean && npm run build && npm run postversion && npm run release:deploy\",\"start\":\"node dist/server/index.js\"},\"repository\":{\"type\":\"git\",\"url\":\"git+https://github.com/CDM-eStrategiai/modularization.git\"},\"bugs\":{\"url\":\"https://github.com/CDM-eStrategiai/modularization/issues\"},\"homepage\":\"https://github.com/CDM-eStrategiai/modularization#readme\",\"devDependencies\":{\"@babel/core\":\"^7.20.12\",\"@parcel/bundler-experimental\":\"^2.7.0\",\"@parcel/reporter-dev-server\":\"^2.13.3\",\"@parcel/transformer-less\":\"^2.13.3\",\"@parcel/transformer-sass\":\"^2.13.3\",\"@parcel/transformer-typescript-tsc\":\"^2.13.3\",\"@types/body-parser\":\"^1.19.2\",\"@types/bunyan\":\"^1.8.8\",\"@types/classnames\":\"^2.3.1\",\"@types/dompurify\":\"2.4.0\",\"@types/express\":\"^4.17.15\",\"@types/glob\":\"^8.0.0\",\"@types/googlemaps\":\"^3.43.3\",\"@types/node-fetch\":\"2.6.3\",\"@types/object-hash\":\"^3.0.2\",\"@types/react\":\"^18.0.26\",\"@types/react-custom-scroll\":\"^5.0.1\",\"@types/react-dom\":\"^18.0.10\",\"@types/react-image-gallery\":\"^1.2.2\",\"@types/react-input-mask\":\"^3.0.2\",\"@types/react-router-dom\":\"^5.3.3\",\"@types/react-select\":\"^5.0.1\",\"@types/react-tabs\":\"^5.0.5\",\"@types/react-test-renderer\":\"^18.0.0\",\"@types/react-youtube-embed\":\"^1.0.4\",\"@types/styled-components\":\"^5.1.26\",\"@types/useragent\":\"^2.3.1\",\"@types/uuid\":\"^9.0.0\",\"@typescript-eslint/eslint-plugin\":\"^5.48.2\",\"@typescript-eslint/eslint-plugin-tslint\":\"^5.48.2\",\"@typescript-eslint/parser\":\"^5.48.2\",\"assert\":\"^2.1.0\",\"browserify-zlib\":\"^0.2.0\",\"browserslist\":\"^4.21.4\",\"cross-env\":\"^7.0.3\",\"crypto-browserify\":\"^3.12.1\",\"cssnano\":\"^7.0.6\",\"eslint\":\"^8.32.0\",\"eslint-config-prettier\":\"^8.6.0\",\"eslint-plugin-react\":\"^7.32.1\",\"glob\":\"^8.1.0\",\"https-browserify\":\"^1.0.0\",\"husky\":\"^8.0.3\",\"identity-obj-proxy\":\"^3.0.0\",\"less\":\"^4.1.3\",\"less-loader\":\"^11.1.0\",\"npm-run-all\":\"^4.1.5\",\"os-browserify\":\"^0.3.0\",\"parcel\":\"^2.13.3\",\"parcel-plugin-bundle-visualiser\":\"^1.2.0\",\"parcel-plugin-static-files-copy\":\"^2.6.0\",\"parcel-reporter-static-files-copy\":\"^1.5.3\",\"path-browserify\":\"^1.0.1\",\"postcss\":\"^8.5.1\",\"postcss-import\":\"^16.1.0\",\"prettier\":\"^2.8.3\",\"pretty-quick\":\"^3.1.3\",\"querystring-es3\":\"^0.2.1\",\"react-is\":\"^18.2.0\",\"react-test-renderer\":\"^18.2.0\",\"regenerator-runtime\":\"^0.13.11\",\"rimraf\":\"^4.1.0\",\"sass\":\"^1.57.1\",\"stream-browserify\":\"^3.0.0\",\"stream-http\":\"^3.2.0\",\"string_decoder\":\"^1.3.0\",\"style-loader\":\"^3.3.1\",\"stylelint\":\"^14.16.1\",\"stylelint-config-prettier\":\"^9.0.4\",\"stylelint-config-recommended\":\"^9.0.0\",\"stylelint-config-styled-components\":\"^0.1.1\",\"stylelint-no-unsupported-browser-features\":\"^7.0.0\",\"stylelint-processor-styled-components\":\"^1.10.0\",\"ts-loader\":\"^9.4.2\",\"tslint\":\"^6.1.3\",\"tslint-config-prettier\":\"^1.18.0\",\"tslint-react\":\"^5.0.0\",\"typescript\":\"^4.9.4\",\"url\":\"^0.11.4\",\"util\":\"^0.12.5\",\"vm-browserify\":\"^1.1.2\"},\"dependencies\":{\"@dnd-kit/core\":\"^6.1.0\",\"@dnd-kit/modifiers\":\"^7.0.0\",\"@dnd-kit/sortable\":\"^8.0.0\",\"@dnd-kit/utilities\":\"^3.2.2\",\"@fortawesome/fontawesome-svg-core\":\"latest\",\"@fortawesome/free-regular-svg-icons\":\"^6.2.1\",\"@fortawesome/free-solid-svg-icons\":\"^6.2.1\",\"@fortawesome/react-fontawesome\":\"^0.2.0\",\"@google-cloud/logging-bunyan\":\"^4.2.2\",\"@parcel/config-default\":\"^2.13.3\",\"@paypal/react-paypal-js\":\"^8.1.3\",\"@popperjs/core\":\"^2.11.8\",\"@stripe/react-stripe-js\":\"^2.7.1\",\"@stripe/stripe-js\":\"^3.4.1\",\"@swc/helpers\":\"^0.5.15\",\"@szhsin/react-accordion\":\"^1.4.1\",\"@tanstack/react-table\":\"^8.20.5\",\"@tinymce/tinymce-react\":\"^5.0.1\",\"@types/lodash\":\"^4.14.194\",\"@types/react-datepicker\":\"^6.2.0\",\"@types/react-slick\":\"^0.23.10\",\"body-parser\":\"^1.20.1\",\"buffer\":\"^6.0.3\",\"bunyan\":\"^1.8.15\",\"classnames\":\"^2.5.1\",\"core-js\":\"^3.27.1\",\"date-fns\":\"^2.29.3\",\"dompurify\":\"^2.4.3\",\"eventsource-parser\":\"^3.0.1\",\"express\":\"^4.18.2\",\"fs-extra\":\"^11.2.0\",\"gsap\":\"^3.12.5\",\"jest-environment-jsdom\":\"^29.3.1\",\"jest-extended\":\"^3.2.3\",\"jwt-decode\":\"^3.1.2\",\"ka-table\":\"^7.8.0\",\"lodash\":\"^4.17.21\",\"mobx\":\"^6.7.0\",\"mobx-react-lite\":\"^3.4.0\",\"node-fetch\":\"^2.6.9\",\"npm\":\"^11.1.0\",\"object-hash\":\"^3.0.0\",\"prop-types\":\"^15.8.1\",\"punycode\":\"^2.3.1\",\"react\":\"^18.2.0\",\"react-accessible-accordion\":\"^5.0.0\",\"react-accessible-treeview\":\"^2.8.3\",\"react-animate-height\":\"3.2.0\",\"react-currency-input-field\":\"^3.6.12\",\"react-custom-scroll\":\"^5.0.0\",\"react-custom-scrollbars-2\":\"^4.5.0\",\"react-datepicker\":\"^6.6.0\",\"react-device-detect\":\"^2.2.3\",\"react-dom\":\"^18.2.0\",\"react-draggable\":\"^4.4.5\",\"react-google-recaptcha-v3\":\"^1.10.1\",\"react-hook-form\":\"^7.55.0\",\"react-image-crop\":\"^11.0.7\",\"react-image-gallery\":\"^1.3.0\",\"react-image-zooom\":\"^1.3.5\",\"react-input-mask\":\"^3.0.0-alpha.2\",\"react-lite-yt-embed\":\"^1.2.7\",\"react-number-format\":\"^5.3.4\",\"react-router\":\"^7.1.5\",\"react-router-dom\":\"^6.11.2\",\"react-scrollbars-custom\":\"^4.1.1\",\"react-select\":\"^5.7.0\",\"react-slick\":\"^0.29.0\",\"react-slideshow-image\":\"^4.3.0\",\"react-stripe-checkout\":\"^2.6.3\",\"react-switch\":\"^7.0.0\",\"react-tabs\":\"^6.0.0\",\"react-toastify\":\"^9.1.3\",\"react-tooltip\":\"^5.28.0\",\"react-use-file-upload\":\"^0.9.5\",\"reactjs-popup\":\"^2.0.5\",\"regenerator-runtime\":\"^0.13.11\",\"request\":\"^2.88.2\",\"resize-observer-polyfill\":\"^1.5.1\",\"simplebar\":\"^6.2.5\",\"simplebar-react\":\"^3.1.0\",\"slick-carousel\":\"^1.8.1\",\"styled-components\":\"^5.3.6\",\"tinymce\":\"^7.1.0\",\"tslib\":\"^2.4.1\",\"useragent\":\"^2.3.0\",\"uuid\":\"^9.0.0\",\"workbox-cacheable-response\":\"^6.5.4\",\"workbox-expiration\":\"^6.5.4\",\"workbox-routing\":\"^6.5.4\",\"workbox-strategies\":\"^6.5.4\",\"yamlparser\":\"^0.0.2\"},\"husky\":{\"hooks\":{\"pre-commit\":\"pretty-quick --staged\"}},\"browserslist\":[\"> 1%\",\"last 1.5 years\",\"not dead\",\"ie >= 11\",\"not op_mini all\"],\"staticFiles\":{\"staticPath\":\"src/assets/common\",\"watcherGlob\":\"emission/**/*\",\"staticOutDir\":\"emission\",\"outDirPattern\":\"**/{dist,serve}\"}}");

},{}],"8Ipv2":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "ScrollToHashWhenReady", function() {
    return ScrollToHashWhenReady;
});
var _react = require("react");
var waitForElementAndScroll = function(selector) {
    var timeout = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : 5000, interval = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : 100;
    var startTime = performance.now();
    var intervalId = setInterval(function() {
        var element = document.querySelector(selector);
        if (element) {
            element.scrollIntoView({
                block: 'start'
            });
            clearInterval(intervalId);
            return;
        }
        if (performance.now() - startTime >= timeout) clearInterval(intervalId);
    }, interval);
};
var ScrollToHashWhenReady = function() {
    (0, _react.useEffect)(function() {
        var hash = window.location.hash;
        if (!hash) return;
        waitForElementAndScroll(hash);
    }, []);
    return null;
};

},{"react":"gjea9","@parcel/transformer-js/src/esmodule-helpers.js":"g0Ia8"}],"94ZjL":[function(require,module,exports,__globalThis) {
module.exports = require("56b63ddea98bb40")(require("122e78eb09383c6d").resolve("fyWjb")).then(function() {
    return module.bundle.root('jztwV');
});

},{"56b63ddea98bb40":"aJpgn","122e78eb09383c6d":"aiVrJ"}]},[], null, "parcelRequire94c2")

//# sourceMappingURL=embed-root.f554da83.js.map
